// Customizable Area Start
import React, { useEffect, useRef, useState } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import {
  HeartSmallIcon,
  uploadIcon,
  sendMedssageIcon,
  redHeart,
  CommentIcon,
  CommentIconWhite,
  logoEverybrand
} from "./assets";
import clsx from "clsx";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { Comment, DashboardAccount, PostType } from "./interfaces";
import {
  Box,
  Divider,
  Grid,
  ListItemText,
  MenuItem,
  Modal,
  Popover,
  Snackbar,
  styled,
  TextField,
  withStyles,
  Paper,
  Avatar,
  IconButton,
  Typography,
  Switch,
  FormControlLabel,
  CircularProgress,
} from "@material-ui/core";
import { CloseIcon } from "../../settings2/src/assets";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import MuiAlert, { Color } from "@material-ui/lab/Alert";
import { useInView } from "react-intersection-observer";
import Select from "react-dropdown-select";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import moment from "moment";
import ReactPlayer from 'react-player'
import { IconAvtar } from "../../contactlist/src/assets";
import { handleOrConditions } from "../../../components/src/CommonFunctions";
import CommentImage from "../../../components/src/CommentImage.web";
import CustomConditionalRender from "../../../components/src/CustomConditionalRender.web";
import CustomLoader from "../../../components/src/CustomLoader.web";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

// Register Swiper modules
SwiperCore.use([Navigation, Pagination]);
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import FavoriteIcon from '@material-ui/icons/Favorite';
import MoreHorizRoundedIcon from '@material-ui/icons/MoreHorizRounded';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import VolumeUpRoundedIcon from '@material-ui/icons/VolumeUpRounded';
import VolumeOffRoundedIcon from '@material-ui/icons/VolumeOffRounded';
import Poll from "./Poll.web";
import useWindowSize from "../../../components/src/useWindowsHook";
const configJSON = require("./config.js")

// Post is rendered once PER POST CARD in the feed (one component instance each), unlike
// EuDashboard which owns the whole feed in a single controller instance with one shared
// globalMuted/audio-unlock state. To match that same "one mute preference, one audio unlock
// for the whole feed" behavior here, this state must live at module scope so every Post
// instance reads/writes the same values instead of each having its own independent copy.
// Starts true because every video renders with the `muted` attribute (required for autoPlay
// to be allowed at all) - this MUST match the video's real initial DOM state, otherwise the
// first tap of the mute button computes the wrong direction (it looks like it "does nothing"
// because it reinforces the already-muted state instead of unmuting).
let mobileFeedMuted = true;
let mobileFeedAudioUnlocked = false;
const mobileFeedMuteListeners = new Set<(muted: boolean) => void>();
const setMobileFeedMuted = (muted: boolean) => {
  mobileFeedMuted = muted;
  mobileFeedMuteListeners.forEach((listener) => listener(muted));
};

enum CommentsOrderEnum {
  ASC = "asc",
  DESC = "desc"
}

interface Props {
  postInfo: PostType;
  allPosts?: PostType[];
  hidePostApicall: Function;
  deletePostApicall?: Function;
  showAlert: boolean;
  showSuccess: string;
  banUserApiCall: Function;
  errorAlertMessage: boolean;
  postCommentApiCall: Function;
  postPollApiCall: Function;
  isSortingComments: boolean
  userAccount?: DashboardAccount
  deleteCommentApiCall: Function;
  archiveCommentApiCall: Function;
  revertArchiveCommentApiCall: Function;
  achiveId: number;
  getPostCommentsApiCall: Function;
  handleLikePostAPICall: Function;
  handleSortingCommentsChange: (isSorting: boolean) => void
  handleUndoLikeAPICall: (likeableId: string, likeType: string, postId?: string) => void
  highlighted: boolean;
  handlePostProfileClick: Function;
  handleVote: (optionId : number, postId: string) => void
  handleDeleteVote: (optionId : number, postId: string) => void
  handleVoteComment: (optionId : number, commentId: number) => void
  highlightedCommentId?: string | number;
  autoExpandComments?: boolean;
  notificationData?: any;
  setCommentModalOpen?: (isOpen: boolean) => void;
}

function Post({
  postInfo,
  allPosts,
  archiveCommentApiCall,
  revertArchiveCommentApiCall,
  deleteCommentApiCall,
  hidePostApicall,
  deletePostApicall,
  showAlert,
  showSuccess,
  userAccount,
  banUserApiCall,
  errorAlertMessage,
  isSortingComments,
  postCommentApiCall,
  postPollApiCall,
  getPostCommentsApiCall,
  handleLikePostAPICall,
  handleUndoLikeAPICall,
  highlighted,
  handlePostProfileClick,
  handleSortingCommentsChange,
  handleVote,
  handleDeleteVote,
  handleVoteComment,
  highlightedCommentId,
  autoExpandComments,
  notificationData,
  setCommentModalOpen
}: Props) {
  // console.log("Post component props:", {
  //   postId: postInfo.id,
  //   highlighted,
  //   highlightedCommentId,
  //   autoExpandComments,
  //   notificationData: !!notificationData
  // });
  
  // Debug post highlighting
  // if (highlighted) {
  //   console.log("Post is highlighted:", {
  //     postId: postInfo.id,
  //     highlighted,
  //     // backgroundColor: handleOrConditions(highlighted, "#fff2d2", "none")
  //   });
  // }
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width:768px)');
  const imageInputRef = useRef<HTMLInputElement | null>(null)
  const videoInputRef = useRef<HTMLInputElement | null>(null)
  const videoModalInputRef = useRef<HTMLInputElement | null>(null)
  const videoGalleryInputRef = useRef<HTMLInputElement | null>(null)
  const videoCameraInputRef = useRef<HTMLInputElement | null>(null)
  const [commentImage, setCommentImage] = useState<File | null>(null)
  const [commentOptionsModal, setCommentOptionsModal] = useState(false)
  const [commentOptionsAnchorEl, setCommentOptionsAnchorEl] = useState<HTMLElement | null>(null)
  const [pollCommentModal, setPollCommentModal] = useState(false)
  const [videoCommentModal, setVideoCommentModal] = useState(false)
  const [selectedVideoFile, setSelectedVideoFile] = useState<File | null>(null)
  const [showMobileVideoSource, setShowMobileVideoSource] = useState(false)
  //Poll options and question
  const [pollQuestion, setPollQuestion] = useState("")
  const [pollOptions, setPollOptions] = useState<string[]>(["", ""])
  const [allowMultipleResponses, setAllowMultipleResponses] = useState(true)
  const [localPoll, setLocalPoll] = useState<any>(null)
  const [localPollOptions, setLocalPollOptions] = useState<any[]>([])
  const [isCommentPoll, setIsCommentPoll] = useState<boolean>(false) // Track if poll is a comment poll
  const [selectedPost, setSelectedPost] = useState<PostType | null>(null);
  const [toastType, setToastType] = useState<Color | undefined>(undefined)
  const [toastMessage, setToastMessage] = useState<string>("")
  const [anchorEll, setAnchorEll] = useState(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [endWaitlistModalS, setendWaitlistModalS] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [postComment, setPostComment] = useState(false);
  const [postPreviewComment, setPostPreviewComment] = useState<boolean>(false);
  const [instagramCommentModal, setInstagramCommentModal] = useState<boolean>(false);
  const [viewReplies, setViewReplies] = useState(null);
  const [
    hidePostConfirmationModalS,
    sethidePostConfirmationModalS,
  ] = React.useState(false);
  const [
    deletePostConfirmationModalS,
    setDeletePostConfirmationModalS,
  ] = React.useState(false);
  const [isPostHidden, setIsPostHidden] = useState(false);
  const isMountedRef = useRef(true);
  const [selectedReasonS, setSelectedReasonS] = useState("");
  const [comment, setComment] = useState("");
  const [replyingToID, setReplyingToID] = useState<string | null>(null)
  const [replyingToName, setReplyingToName] = useState<string>("")
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState<boolean>(false)
  // Track expanded descriptions per post in reels modal
  const [expandedDescriptions, setExpandedDescriptions] = useState<Set<string | number>>(new Set())
  const commentRef = useRef<HTMLInputElement>(null);
  const [isEmptyReason, setIsEmptyReason] = useState(false)
  const playerRef = useRef<ReactPlayer>(null);
  const elementRef = useRef<HTMLDivElement>(null)
  const highlightedCommentRef = useRef<HTMLDivElement>(null);
  const [commentsOrder, setCommentsOrder] = useState<CommentsOrderEnum>(CommentsOrderEnum.ASC)
  const [scrollDirection, setScrollDirection] = useState<string | null>(null);
  const [lastScrollY, setLastScrollY] = useState(0)
  const [pollDataStore, setPollDataStore] = useState<any>(null);
  const [ref, inView ] = useInView({
    threshold: 0.1,
  })
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [previewModalId, setPreviewModalId] = useState<string | null>(null)
  const [mediaFiles, setMediaFiles] = useState<{link:string}[] | null>(null);
  const [currentPostIndex, setCurrentPostIndex] = useState<number>(0);
  const [currentPostSlide, setCurrentPostSlide] = useState<number>(0);
  const [swiperInstance, setSwiperInstance] = useState<SwiperCore | null>(null);
  const [swiperInstanceHome, setSwiperInstanceHome] = useState<SwiperCore | null>(null);
  const [highlightedComment, setHighlightedComment] = useState<string | number | null>(null);
  const [manuallyHighlightedComments, setManuallyHighlightedComments] = useState<Set<string | number>>(new Set());

  const videoRefs = useRef<HTMLVideoElement[]>([]);
  const reelVideoRefs = useRef<Map<string, HTMLVideoElement>>(new Map());
  const desktopVideoRefs = useRef<Map<string, HTMLVideoElement>>(new Map());
  const [videoPlayingStates, setVideoPlayingStates] = useState<Map<string, boolean>>(new Map());
  // Use refs to store current post index and slide so event handlers always have latest values
  const currentPostIndexRef = useRef<number>(0);
  const currentPostSlideRef = useRef<number>(0);
  // Reel mute/unmute toggle (mobile), same UX as EuDashboard's globalMuted/toggleVideoSound
  const [isReelMuted, setIsReelMuted] = useState(false);
  const isReelMutedRef = useRef(false);
  // Brief center-of-video flash icon on toggle, same as EuDashboard's soundFlashIndex/showSoundFlash
  const [reelSoundFlash, setReelSoundFlash] = useState(false);
  const reelSoundFlashTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const showReelSoundFlash = () => {
    if (reelSoundFlashTimerRef.current) clearTimeout(reelSoundFlashTimerRef.current);
    setReelSoundFlash(true);
    reelSoundFlashTimerRef.current = setTimeout(() => setReelSoundFlash(false), 600);
  };
  // Track video orientation and resize mode: key = video identifier, value = 'cover' | 'contain'
  const [videoResizeModes, setVideoResizeModes] = useState<Map<string, 'cover' | 'contain'>>(new Map());
  // Track image orientation and resize mode: key = image identifier, value = 'cover' | 'contain'
  const [imageResizeModes, setImageResizeModes] = useState<Map<string, 'cover' | 'contain'>>(new Map());
  // Track which videos have been processed to prevent infinite loops
  const processedVideosRef = useRef<Set<string>>(new Set());
  // Track which images have been processed to prevent infinite loops
  const processedImagesRef = useRef<Set<string>>(new Set());

  const {wWidth, wHeight} = useWindowSize();

  // Handle video load to detect orientation and set resize mode
  const handleVideoLoad = React.useCallback((videoElement: HTMLVideoElement, videoKey: string) => {
    if (!videoElement) return;
    
    // Check if we've already processed this video to prevent infinite loops
    if (processedVideosRef.current.has(videoKey)) {
      return;
    }
    
    // Mark as processing to prevent duplicate calls
    processedVideosRef.current.add(videoKey);
    
    // Wait for video metadata to be loaded
    const handleLoadedMetadata = () => {
      // Check if element still exists and is valid
      if (!videoElement || !videoElement.videoWidth || !videoElement.videoHeight) {
        processedVideosRef.current.delete(videoKey);
        return;
      }
      
      const width = videoElement.videoWidth;
      const height = videoElement.videoHeight;
      
      if (width && height) {
        // Determine orientation: vertical if height > width
        const isVertical = height > width;
        const resizeMode: 'cover' | 'contain' = isVertical ? 'cover' : 'contain';
        
        // Update resize mode for this video only if not already set
        setVideoResizeModes(prev => {
          // Don't update if already set to prevent unnecessary re-renders
          if (prev.has(videoKey)) {
            return prev;
          }
          const newMap = new Map(prev);
          newMap.set(videoKey, resizeMode);
          return newMap;
        });
      }
    };
    
    // Check if metadata is already loaded
    if (videoElement.readyState >= 1 && videoElement.videoWidth && videoElement.videoHeight) {
      handleLoadedMetadata();
    } else {
      // Only add listener if not already added, and use once option
      const handler = () => {
        handleLoadedMetadata();
        videoElement.removeEventListener('loadedmetadata', handler);
      };
      videoElement.addEventListener('loadedmetadata', handler, { once: true });
    }
  }, []);

  // Handle image load to detect orientation and set resize mode
  const handleImageLoad = React.useCallback((imageElement: HTMLImageElement, imageKey: string) => {
    if (!imageElement) return;
    
    // Check if we've already processed this image to prevent infinite loops
    if (processedImagesRef.current.has(imageKey)) {
      return;
    }
    
    // Mark as processing to prevent duplicate calls
    processedImagesRef.current.add(imageKey);
    
    // Wait for image to be loaded
    const handleLoad = () => {
      // Check if element still exists and is valid
      if (!imageElement || !imageElement.naturalWidth || !imageElement.naturalHeight) {
        processedImagesRef.current.delete(imageKey);
        return;
      }
      
      const width = imageElement.naturalWidth;
      const height = imageElement.naturalHeight;
      
      if (width && height) {
        // Determine orientation: vertical if height > width
        const isVertical = height > width;
        const resizeMode: 'cover' | 'contain' = isVertical ? 'cover' : 'contain';
        
        // Update resize mode for this image only if not already set
        setImageResizeModes(prev => {
          // Don't update if already set to prevent unnecessary re-renders
          if (prev.has(imageKey)) {
            return prev;
          }
          const newMap = new Map(prev);
          newMap.set(imageKey, resizeMode);
          return newMap;
        });
      }
    };
    
    // Check if image is already loaded
    if (imageElement.complete && imageElement.naturalWidth && imageElement.naturalHeight) {
      handleLoad();
    } else {
      // Only add listener if not already added, and use once option
      const handler = () => {
        handleLoad();
        imageElement.removeEventListener('load', handler);
      };
      imageElement.addEventListener('load', handler, { once: true });
    }
  }, []);

  useEffect(() => {
    videoRefs.current.forEach((video: HTMLVideoElement | null, index: number) => {
      if (video) {
        // NEVER unmute desktop feed videos
        const isDesktopFeed = video.getAttribute('data-desktop-feed') === 'true';
        if (isDesktopFeed) {
          video.pause();
          video.muted = true;
          video.volume = 0;
          return; // Skip desktop feed videos
        }
        
        handlePlayPause(video, index)
        // Unmute current video, mute others
        if (index === currentSlide) {
          video.muted = false;
          video.volume = 1.0;
        } else {
          video.muted = true;
        }
      }
    });
  }, [currentSlide]);

  // Ensure all desktop videos are paused and muted (thumbnails only in home feed)
  useEffect(() => {
    desktopVideoRefs.current.forEach((video) => {
      if (video) {
        video.pause();
        video.muted = true; // Keep muted on desktop thumbnail
        video.volume = 0; // Ensure volume is 0
      }
    });
  }, [postInfo.id]);

  // Continuously ensure desktop videos stay paused and muted (home feed thumbnails)
  useEffect(() => {
    const interval = setInterval(() => {
      // Method 1: Check all desktop video refs
      desktopVideoRefs.current.forEach((video) => {
        if (video && !previewModalId) { // Only enforce when modal is not open
          // HARD STOP - Never allow desktop feed videos to play
          if (!video.paused) {
            video.pause();
            video.currentTime = 0;
          }
          if (!video.muted || video.volume > 0) {
            video.muted = true;
            video.volume = 0;
          }
          // Remove autoplay attribute if present
          video.removeAttribute('autoplay');
          // Ensure data attribute is set
          if (video.getAttribute('data-desktop-feed') !== 'true') {
            video.setAttribute('data-desktop-feed', 'true');
          }
        }
      });
      
      // Method 2: Check DOM directly for ALL desktop feed videos (most aggressive)
      document.querySelectorAll('video[data-desktop-feed="true"]').forEach((video) => {
        const v = video as HTMLVideoElement;
        // FORCE pause and mute - no exceptions
        if (!v.paused) {
          v.pause();
          v.currentTime = 0;
        }
        if (!v.muted || v.volume > 0) {
          v.muted = true;
          v.volume = 0;
        }
        v.removeAttribute('autoplay');
      });
      
      // Method 3: Also check ALL videos in DOM and identify desktop feed videos by context
      // Desktop feed videos are in the home feed, not in modals
      if (!previewModalId) {
        document.querySelectorAll('video').forEach((video) => {
          const v = video as HTMLVideoElement;
          // Check if video is in desktop feed (not in modal)
          const isInModal = v.closest('[class*="postViewContainer"], [class*="previewModal"], [class*="modal"]') !== null;
          const hasDesktopFeedAttr = v.getAttribute('data-desktop-feed') === 'true';
          
          // If it's marked as desktop feed OR it's not in a modal and not in mobile view, treat as desktop feed
          if (hasDesktopFeedAttr || (!isInModal && !isMobile && v.closest('[class*="postMediaContainer"]') !== null)) {
            if (!v.paused) {
              v.pause();
              v.currentTime = 0;
            }
            if (!v.muted || v.volume > 0) {
              v.muted = true;
              v.volume = 0;
            }
            v.removeAttribute('autoplay');
            v.setAttribute('data-desktop-feed', 'true');
          }
        });
      }
    }, 50); // Check every 50ms for more aggressive monitoring

    return () => clearInterval(interval);
  }, [previewModalId, isMobile]);

  const handlePlayPause = (video: HTMLVideoElement, index: number) => {
    // NEVER play desktop feed videos
    const isDesktopFeed = video.getAttribute('data-desktop-feed') === 'true';
    if (isDesktopFeed) {
      video.pause();
      video.muted = true;
      video.volume = 0;
      return;
    }
    
    if (index === currentSlide) {
      video.play();
    } else {
      video.pause();
    }
  }

  // Update refs whenever state changes
  useEffect(() => {
    currentPostIndexRef.current = currentPostIndex;
  }, [currentPostIndex]);

  useEffect(() => {
    currentPostSlideRef.current = currentPostSlide;
  }, [currentPostSlide]);

  // Continuous monitor to ensure only the correct video is playing (runs every 200ms)
  useEffect(() => {
    if (!previewModalId || !allPosts || allPosts.length === 0) return;

    const monitorInterval = setInterval(() => {
      const currentPostIdx = currentPostIndexRef.current;
      const currentSlideIdx = currentPostSlideRef.current;
      const currentPost = allPosts[currentPostIdx];
      
      if (!currentPost || !currentPost.attributes.files) return;

      // Determine which video should be playing
      const activeFileIndex = currentPost.attributes.files.length > 1 
        ? Math.min(currentSlideIdx, currentPost.attributes.files.length - 1)
        : 0;
      const activeFile = currentPost.attributes.files[activeFileIndex];
      
      if (!activeFile || !activeFile.link_content_type?.includes("video")) {
        // If current post doesn't have a video, pause all
        reelVideoRefs.current.forEach((video) => {
          if (video && !video.paused) {
            video.pause();
            video.muted = true;
            video.volume = 0;
          }
        });
        return;
      }

      const correctVideoKey = currentPost.attributes.files.length > 1 
        ? `post-${currentPost.id}-${activeFileIndex}`
        : `post-${currentPost.id}`;

      // Pause all videos that shouldn't be playing
      reelVideoRefs.current.forEach((video, key) => {
        if (video && key !== correctVideoKey) {
          // NEVER affect desktop feed videos
          const isDesktopFeed = video.getAttribute('data-desktop-feed') === 'true';
          if (isDesktopFeed) {
            video.pause();
            video.muted = true;
            video.volume = 0;
            return;
          }
          
          if (!video.paused || !video.muted) {
            video.pause();
            video.muted = true;
            video.volume = 0;
          }
        }
      });

      // Ensure the correct video is playing
      const correctVideo = reelVideoRefs.current.get(correctVideoKey);
      if (correctVideo) {
        // NEVER play or unmute desktop feed videos
        const isDesktopFeed = correctVideo.getAttribute('data-desktop-feed') === 'true';
        if (isDesktopFeed) {
          correctVideo.pause();
          correctVideo.muted = true;
          correctVideo.volume = 0;
          return;
        }
        
        // Honor the user's mute preference instead of forcing sound on - this interval
        // used to unconditionally unmute every 200ms, which fought the mute toggle and,
        // on mobile, kept re-attempting an unmute with no user gesture behind it (silently
        // ignored by the browser's audio engine even though the muted property looked false).
        if (!isReelMutedRef.current && (correctVideo.muted || correctVideo.volume === 0)) {
          correctVideo.muted = false;
          correctVideo.volume = 1.0;
        }
        if (correctVideo.paused) {
          // Browsers reject play() on an unmuted video unless the call is synchronously
          // inside a real user gesture - this runs on a setInterval tick, so it never
          // qualifies. Always (re)start muted (always allowed), then unmute right after
          // playback actually begins if sound is wanted - same pattern as the other
          // autoplay effects above. Starting unmuted here was why a freshly-swiped-to
          // reel would silently fail to play and show the browser's native tap-to-play
          // button until the user tapped it themselves (a real gesture).
          correctVideo.muted = true;
          correctVideo.volume = 0;
          correctVideo.play().then(() => {
            if (!isReelMutedRef.current) {
              correctVideo.muted = false;
              correctVideo.volume = 1.0;
            }
          }).catch(() => {});
        }
      }
    }, 200); // Check every 200ms

    return () => clearInterval(monitorInterval);
  }, [previewModalId, allPosts]);

  // Auto play/pause videos when scrolling reels in modal
  useEffect(() => {
    if (previewModalId && allPosts && allPosts.length > 0) {
      // CRITICAL: First, aggressively pause and mute ALL videos (like Instagram/TikTok)
      // Method 1: Pause all videos in refs
      reelVideoRefs.current.forEach((video, key) => {
        if (video) {
          video.pause();
          video.muted = true;
          video.volume = 0;
          video.removeAttribute('autoplay');
          setVideoPlayingStates(prev => {
            const newMap = new Map(prev);
            newMap.set(key, false);
            return newMap;
          });
        }
      });

      // Method 2: Also query DOM directly to catch any videos we might have missed
      const allVideosInDOM = document.querySelectorAll('video');
      allVideosInDOM.forEach((video) => {
        // NEVER play desktop feed videos
        const isDesktopFeed = video.getAttribute('data-desktop-feed') === 'true';
        if (isDesktopFeed) {
          video.pause();
          video.muted = true;
          video.volume = 0;
          video.removeAttribute('autoplay');
          return; // Skip desktop feed videos
        }
        
        const isInModal = video.closest('[class*="postViewContainer"], [class*="previewModal"]') !== null;
        if (isInModal) {
          video.pause();
          video.muted = true;
          video.volume = 0;
          video.removeAttribute('autoplay');
        }
      });

      // Small delay to ensure all videos are paused before playing the new one
      const playTimer = setTimeout(() => {
        // Unmute and play ONLY the current post's active video
        const currentPost = allPosts[currentPostIndex];
        if (currentPost && currentPost.attributes.files && currentPost.attributes.files.length > 0) {
          const activeFileIndex = currentPost.attributes.files.length > 1 
            ? Math.min(currentPostSlide, currentPost.attributes.files.length - 1)
            : 0;
          const activeFile = currentPost.attributes.files[activeFileIndex];
          
          if (activeFile && activeFile.link_content_type?.includes("video")) {
            const videoKey = currentPost.attributes.files.length > 1 
              ? `post-${currentPost.id}-${activeFileIndex}`
              : `post-${currentPost.id}`;
            const video = reelVideoRefs.current.get(videoKey);
            if (video) {
              // NEVER play or unmute desktop feed videos
              const isDesktopFeed = video.getAttribute('data-desktop-feed') === 'true';
              if (isDesktopFeed) {
                video.pause();
                video.muted = true;
                video.volume = 0;
                return;
              }
              
              // Double-check all other videos are still paused
              reelVideoRefs.current.forEach((v, k) => {
                if (v && k !== videoKey) {
                  // NEVER affect desktop feed videos
                  const vIsDesktopFeed = v.getAttribute('data-desktop-feed') === 'true';
                  if (vIsDesktopFeed) {
                    v.pause();
                    v.muted = true;
                    v.volume = 0;
                    return;
                  }
                  
                  v.pause();
                  v.muted = true;
                  v.volume = 0;
                }
              });
              // Now play the current video. Always start muted (guaranteed to be allowed to
              // autoplay), then unmute right after playback actually begins if sound is wanted.
              video.muted = true;
              video.volume = 0;
              video.play().then(() => {
                if (!isReelMutedRef.current) {
                  video.muted = false;
                  video.volume = 1.0;
                }
                setVideoPlayingStates(prev => {
                  const newMap = new Map(prev);
                  newMap.set(videoKey, true);
                  return newMap;
                });
              }).catch(err => console.log('Video autoplay prevented:', err));
            }
          }
        }
      }, 100); // Increased delay to ensure previous videos are fully paused

      return () => clearTimeout(playTimer);
    }
  }, [currentPostIndex, currentPostSlide, allPosts, previewModalId]);

  // Play video with sound when modal opens
  useEffect(() => {
    if (previewModalId && allPosts && allPosts.length > 0) {
      // Small delay to ensure modal is rendered
      const timer = setTimeout(() => {
        // Pause and mute all videos first (like Instagram does)
        reelVideoRefs.current.forEach((video) => {
          if (video) {
            video.pause(); // Pause all videos
            video.muted = true; // Mute all videos
            video.volume = 0;
          }
        });

        const currentPost = allPosts[currentPostIndex];
        if (currentPost && currentPost.attributes.files && currentPost.attributes.files.length > 0) {
          // For multi-file posts, play the first video, otherwise play the only video
          const activeFileIndex = 0;
          const activeFile = currentPost.attributes.files[activeFileIndex];
          
          // Only handle video files
          if (activeFile && activeFile.link_content_type?.includes("video")) {
            const videoKey = currentPost.attributes.files.length > 1 
              ? `post-${currentPost.id}-${activeFileIndex}`
              : `post-${currentPost.id}`;
            const video = reelVideoRefs.current.get(videoKey);
            if (video) {
              // NEVER play or unmute desktop feed videos
              const isDesktopFeed = video.getAttribute('data-desktop-feed') === 'true';
              if (isDesktopFeed) {
                video.pause();
                video.muted = true;
                video.volume = 0;
                return;
              }
              
              // Mobile browsers block autoplay that starts unmuted (no direct user gesture in this
              // context), so always start muted (always allowed) then unmute right after playback
              // actually begins if the user wants sound - matches Instagram Reels behavior.
              video.muted = true;
              video.volume = 0;
              video.play().then(() => {
                if (!isReelMutedRef.current) {
                  video.muted = false;
                  video.volume = 1.0;
                }
                setVideoPlayingStates(prev => {
                  const newMap = new Map(prev);
                  newMap.set(videoKey, true);
                  return newMap;
                });
              }).catch(err => console.log('Video autoplay prevented:', err));
            }
          }
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [previewModalId, allPosts, currentPostIndex]);

  // Toggle play/pause for reel videos
  const toggleReelVideoPlayPause = (videoKey: string) => {
    const video = reelVideoRefs.current.get(videoKey);
    if (video) {
      if (video.paused) {
        // In modal, play videos with sound (both mobile and desktop)
        video.muted = false;
        video.volume = 1.0;
        video.play().then(() => {
          setVideoPlayingStates(prev => {
            const newMap = new Map(prev);
            newMap.set(videoKey, true);
            return newMap;
          });
        }).catch(err => console.log('Video play failed:', err));
      } else {
        video.pause();
        setVideoPlayingStates(prev => {
          const newMap = new Map(prev);
          newMap.set(videoKey, false);
          return newMap;
        });
      }
    }
  };

  // Toggle mute/unmute for the active reel video (mobile), same UX as EuDashboard's toggleVideoSound
  // Same as EuDashboard's toggleVideoSound - just flips muted/volume on the video element
  // directly (no play() call), then flashes the icon.
  const toggleReelSound = (videoKey: string) => {
    const video = reelVideoRefs.current.get(videoKey);
    if (!video) return;

    const newMuted = !isReelMutedRef.current;
    video.muted = newMuted;
    if (!newMuted) video.volume = 1;
    isReelMutedRef.current = newMuted;
    setIsReelMuted(newMuted);
    showReelSoundFlash();
  };

  // Toggle play/pause for fallback modal videos
  const toggleFallbackVideoPlayPause = (index: number) => {
    const video = videoRefs.current[index];
    if (video) {
      if (video.paused) {
        // In modal, play videos with sound (both mobile and desktop)
        video.muted = false;
        video.volume = 1.0;
        video.play().then(() => {
          setVideoPlayingStates(prev => {
            const newMap = new Map(prev);
            newMap.set(`fallback-${index}`, true);
            return newMap;
          });
        }).catch(err => console.log('Video play failed:', err));
      } else {
        video.pause();
        setVideoPlayingStates(prev => {
          const newMap = new Map(prev);
          newMap.set(`fallback-${index}`, false);
          return newMap;
        });
      }
    }
  };

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY) {
      setScrollDirection('down');
    } else if (currentScrollY < lastScrollY) {
      setScrollDirection('up');
    }

    setLastScrollY(currentScrollY);
  }

  const isImage = (link: string) => {
    return /\.(jpg|jpeg|png|gif)$/i.test(link);
  };

  const isVideo = (link: string) => {
    return /\.(mp4|webm|ogg)$/i.test(link);
  };

  useEffect(() => {
    if(!inView && postComment) {
      setPostComment(false)
      if(scrollDirection === 'down' && elementRef.current) {
        const elementHeight = elementRef.current.offsetHeight;
        window.scrollTo({
          top: window.scrollY - elementHeight,
        })
      }
    }
  }, [inView, scrollDirection])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY])

  const options = [
    { value: "Fake Profile", label: "Fake Profile" },
    { value: "Mean behavior", label: "Mean behavior" },
    {
      value: "Broke community guidelines",
      label: "Broke community guidelines",
    },
    { value: "Inappropriate content", label: "Inappropriate content" },
    { value: "Fraud or spamming", label: "Fraud or spamming" },
    { value: "Something else", label: "Something else" },
  ];

  const [archivedStatus, setArchivedStatus] = useState<{
    [key: string]: boolean;
  }>(() => {
    const storedArchivedStatus = localStorage.getItem("archivedStatus");
    return storedArchivedStatus ? JSON.parse(storedArchivedStatus) : {};
  });
  const [banUserOfselectedCommentId, setBanUserOfSelectedCommentId] = useState<
    string | null
  >(null); // Store the ID of the selected comment

  const [selectedCommentId, setSelectedCommentId] = useState<string | null>(
    null
  ); // Store the ID of the selected comment
  
  const [repliesVisible, setRepliesVisible] = useState<{[key: string]: boolean}>({});
  const [selectedComment, setSelectedComment] = useState<Comment | null>(null)

  const handleArchiveComment = () => {
    if (selectedCommentId !== null) {
      const isArchived = archivedStatus[selectedCommentId]; // Check if the comment is already archived
      setArchivedStatus((prevState) => ({
        ...prevState,
        [selectedCommentId]: !isArchived,
      })); // Toggle the archive status
      // Add your archive/unarchive comment API call here
    }
  };

  const ratings = (data: any) => {
    if (data.length) {
      const rating =
        data
          .map((x: any) => x.rating)
          .reduce((acc: any, curVal: any) => acc + curVal) / data.length;
      return rating;
    } else {
      return 0;
    }
  };

  const handleRevertArchive = () => {
    if (selectedCommentId !== null) {
      setArchivedStatus((prevState) => ({
        ...prevState,
        [selectedCommentId]: false,
      })); // Set archive status to false
      // Add your revert archive API call here
    }
  };


  useEffect(() => {
    localStorage.setItem("archivedStatus", JSON.stringify(archivedStatus));
  }, [archivedStatus]);
  // Function to handle the click on a comment
  const handleCommentClick = (commentId: any) => {
    setBanUserOfSelectedCommentId(commentId);
  };

  const handleSendClick = (
    item: any,
    replyComment: any,
    setViewReplies: any
  ) => {
    const formData = new FormData();

    // Append comment fields
    const reply = handleOrConditions(replyComment, replyComment, "");
    formData.append("comment[commentable_id]", item?.attributes?.id || replyingToID);
    formData.append("comment[comment]", reply);
    formData.append("comment[commentable_type]", "BxBlockComments::Comment");
    commentImage && formData.append("comment[files][]", commentImage);

    postCommentApiCall(formData, postInfo.id);
    setComment("");
    setViewReplies(item && item.id || replyingToID);
    setReplyingToID(null);
    setReplyingToName("");
  };

  const handleReasonChangeS = (selectedReason: any) => {
    if (selectedReason && selectedReason.length > 0) {
      setSelectedReasonS(selectedReason[0].value);
      setIsEmptyReason(false)
    } else {
      setSelectedReasonS("");
    }
  };

  const openHideConfirmationModalS = (event: React.MouseEvent) => {
    event.stopPropagation()
    sethidePostConfirmationModalS(!hidePostConfirmationModalS);
  };

  const openDeletePostConfirmationModalS = (event: React.MouseEvent) => {
    event.stopPropagation()
    setDeletePostConfirmationModalS(!deletePostConfirmationModalS);
  };

  const handleOpenSnackbar = (type: Color, message: string) => {
    setToastType(type)
    setToastMessage(message)
  }

  const isSelfComment = () => {
    if(selectedComment && userAccount) {
      const isSelf = String(selectedComment.attributes.account_id) === userAccount.id;
      // console.log('isSelfComment check:', {
      //   selectedCommentAccountId: selectedComment.attributes.account_id,
      //   userAccountId: userAccount.id,
      //   isSelf
      // });
      return isSelf;
    }
    // console.log('isSelfComment: missing data', { selectedComment, userAccount });
    return false
  }

  const commonFunctionForCondition = (
    condition: any,
    param1: any,
    param2: any
  ) => {
    return condition ? param1 : param2;
  };
  const openEndWaitlistModalS = (event: React.MouseEvent) => {
    event.stopPropagation()
    setendWaitlistModalS(!endWaitlistModalS);
  };

  const closeCommentSection = () => {
    !anchorEll && handleCommentClose()
  }

  const handleCommentClose = () => {
    setPostComment(false)
    setPostPreviewComment(false)
  }

  const postCommentFlag = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, postInfo: PostType) => {
    event.stopPropagation()
    if(postInfo.attributes.allow_comment || postInfo.attributes.allow_comment == null) {
      !postComment && getPostCommentsApiCall(postInfo.id);
      setPostComment(!postComment);
      setSelectedPost(postInfo || null);
    }
  };

  const postPreviewCommentFlag = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, postInfo: PostType) => {
    event.stopPropagation()
    if(postInfo.attributes.allow_comment == null || postInfo.attributes.allow_comment){
      !postPreviewComment && getPostCommentsApiCall(postInfo.id);
      setPostPreviewComment(!postPreviewComment);
    }
  };

  const openInstagramCommentModal = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    postInfo: PostType
  ) => {
    event.stopPropagation();
    const commentsAllowed = postInfo.attributes.allow_comment == null || postInfo.attributes.allow_comment;
    if (!commentsAllowed) return;
    // Always fetch comments
    if (!postPreviewComment && !instagramCommentModal) {
      getPostCommentsApiCall(postInfo.id);
    }
    // Mobile -> open bottom sheet; Desktop -> open preview modal
    if (isMobile) {
      if (!instagramCommentModal) {
        setInstagramCommentModal(true);
        setCommentModalOpen?.(true); // Notify parent that comment modal is open
        setTimeout(() => {
          const panel = document.querySelector('.comment-panel');
          if (panel) panel.classList.add('open');
        }, 10);
      }
    } else {
      if (!postPreviewComment) setPostPreviewComment(true);
    }
  };

  const closeInstagramCommentModal = () => {
    setInstagramCommentModal(false);
    setCommentModalOpen?.(false); // Notify parent that comment modal is closed
    // Remove the open class for smooth animation
    setTimeout(() => {
      const panel = document.querySelector('.comment-panel');
      if (panel) {
        panel.classList.remove('open');
      }
    }, 10);
  };

  const handleCommentMenuClick = (event: React.MouseEvent<HTMLButtonElement>, commentId: string | number, comment?: Comment) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedCommentId(String(commentId));
    if (comment) {
      setSelectedComment(comment);
    }
  };

  const handleHighlightClick = (commentId: string | number) => {
    // Add highlight functionality
  };

  const handleViewRepliesClick = (commentId: string | number) => {
    // Toggle replies visibility
    setRepliesVisible(prev => ({
      ...prev,
      [String(commentId)]: !prev[String(commentId)]
    }));
  };

  const handleInstagramCommentLike = (comment: any) => {
    if (comment.attributes?.already_liked) {
      handleUndoLikeAPICall(comment.id, "Comment", postInfo.id);
    } else {
      handleLikePostAPICall(comment, "Comment", postInfo.id);
    }
  };

  const handleInstagramCommentReply = (commentId: string, userName: string) => {
    setReplyingToID(commentId);
    setReplyingToName(userName);
    // Focus on input field
    setTimeout(() => {
      const input = document.querySelector('.input-field') as HTMLInputElement;
      if (input) {
        input.focus();
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };

  const handleCancelReply = () => {
    setReplyingToID(null);
    setReplyingToName('');
  };

  const handleInstagramAddComment = async () => {
    if (comment.trim()) {
      
      const formData = new FormData();
      
      if (replyingToID) {
        // This is a reply to a comment
        formData.append("comment[commentable_id]", replyingToID);
        formData.append("comment[commentable_type]", "BxBlockComments::Comment");
      } else {
        // This is a top-level comment
        formData.append("comment[commentable_id]", postInfo.id);
        formData.append("comment[commentable_type]", "BxBlockPosts::Post");
      }
      
      formData.append("comment[comment]", comment);
      commentImage && formData.append("comment[files][]", commentImage);
      
      try {
        await postCommentApiCall(formData);
        // Clear form and reset reply state
        setComment("");
        setReplyingToID(null);
        setReplyingToName('');
        handleImageCommentRemove();
        // Refresh comments to show the new comment
        getPostCommentsApiCall(postInfo.id);
      } catch (error) {
        console.error('Error posting comment:', error);
      }
    }
  };

  const handleInstagramCloseModal = (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setInstagramCommentModal(false);
    setCommentModalOpen?.(false); // Notify parent that comment modal is closed
    setReplyingToID(null);
    setReplyingToName('');
    setComment('');
    // Remove the open class for smooth animation
    setTimeout(() => {
      const panel = document.querySelector('.comment-panel');
      if (panel) {
        panel.classList.remove('open');
      }
    }, 10);
  };

  // Prevent background scroll when Instagram comment modal is open
  useEffect(() => {
    if (instagramCommentModal && isMobile) {
      // Disable Swiper instances to prevent scrolling
      if (swiperInstance && swiperInstance.allowTouchMove !== undefined) {
        try {
          swiperInstance.allowTouchMove = false;
          swiperInstance.allowSlideNext = false;
          swiperInstance.allowSlidePrev = false;
          if (swiperInstance.mousewheel && typeof swiperInstance.mousewheel.disable === 'function') {
            swiperInstance.mousewheel.disable();
          }
          if (swiperInstance.keyboard && typeof swiperInstance.keyboard.disable === 'function') {
            swiperInstance.keyboard.disable();
          }
        } catch (e) {
          // Swiper instance might be destroyed
        }
      }
      if (swiperInstanceHome && swiperInstanceHome.allowTouchMove !== undefined) {
        try {
          swiperInstanceHome.allowTouchMove = false;
          swiperInstanceHome.allowSlideNext = false;
          swiperInstanceHome.allowSlidePrev = false;
          if (swiperInstanceHome.mousewheel && typeof swiperInstanceHome.mousewheel.disable === 'function') {
            swiperInstanceHome.mousewheel.disable();
          }
          if (swiperInstanceHome.keyboard && typeof swiperInstanceHome.keyboard.disable === 'function') {
            swiperInstanceHome.keyboard.disable();
          }
        } catch (e) {
          // Swiper instance might be destroyed
        }
      }

      // Store current scroll position
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      document.body.style.overflow = 'hidden';

      // Store original styles for restoration
      let originalOverflow = '';
      let originalTouchAction = '';
      
      // Disable scroll on the main feed container (ContentFeed)
      const allPostsContainer = document.querySelector('[class*="allPosts"]') as HTMLElement;
      if (allPostsContainer) {
        originalOverflow = allPostsContainer.style.overflow || '';
        originalTouchAction = allPostsContainer.style.touchAction || '';
        allPostsContainer.style.overflow = 'hidden';
        allPostsContainer.style.touchAction = 'none';
      }

      // Prevent reels/video containers from scrolling
      // But allow scrolling inside comment modals
      const preventReelsScroll = (e: Event) => {
        const target = e.target as HTMLElement;
        // Don't prevent scroll if inside comment modal
        if (target.closest('.instagram-comment-modal') || 
            target.closest('.comment-modal-open') ||
            target.closest('.comment-panel') ||
            target.closest('[class*="commentSection"]') ||
            target.closest('[class*="commentSectionContainer"]')) {
          return; // Allow scroll inside comment modal
        }
        // Prevent scroll on reels/video containers
        if (target.closest('.videoImageContainer') || 
            target.closest('.swiper-container') || 
            target.closest('.swiper-wrapper') ||
            target.closest('.swiper-slide') ||
            target.closest('[class*="allPosts"]') ||
            target.closest('[data-post-id]')) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      };

      // Add event listeners to prevent reels scroll
      // Exclude comment containers from being prevented from scrolling
      const videoContainers = document.querySelectorAll('.videoImageContainer, .swiper-container, .swiper-wrapper, [class*="allPosts"], [data-post-id]');
      videoContainers.forEach(container => {
        // Skip if container is inside a comment modal
        const element = container as HTMLElement;
        if (element.closest('.instagram-comment-modal') || 
            element.closest('.comment-modal-open') ||
            element.closest('.comment-panel') ||
            element.closest('[class*="commentSection"]') ||
            element.closest('[class*="commentSectionContainer"]')) {
          return; // Don't prevent scroll on comment containers
        }
        container.addEventListener('touchstart', preventReelsScroll, { passive: false });
        container.addEventListener('touchmove', preventReelsScroll, { passive: false });
        container.addEventListener('wheel', preventReelsScroll, { passive: false });
        container.addEventListener('scroll', preventReelsScroll, { passive: false });
      });

      // Add global scroll prevention
      const preventGlobalScroll = (e: Event) => {
        const target = e.target as HTMLElement;
        // Only allow scrolling within comment modal or comment sections
        if (!target.closest('.instagram-comment-modal') && 
            !target.closest('.comment-modal-open') &&
            !target.closest('.comment-panel') &&
            !target.closest('[class*="commentSection"]') &&
            !target.closest('[class*="commentSectionContainer"]')) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      };

      const preventWheel = (e: WheelEvent) => {
        const target = e.target as HTMLElement;
        // Only allow wheel events within comment modal
        if (!target.closest('.instagram-comment-modal') && 
            !target.closest('.comment-modal-open') &&
            !target.closest('.comment-panel') &&
            !target.closest('[class*="commentSection"]') &&
            !target.closest('[class*="commentSectionContainer"]')) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      };

      window.addEventListener('touchstart', preventGlobalScroll, { passive: false });
      window.addEventListener('touchmove', preventGlobalScroll, { passive: false });
      window.addEventListener('wheel', preventWheel, { passive: false });
      window.addEventListener('scroll', preventGlobalScroll, { passive: false });
      document.addEventListener('scroll', preventGlobalScroll, { passive: false });

      // Store scroll position for restoration
      document.body.setAttribute('data-scroll-y', scrollY.toString());

      return () => {
        // Re-enable Swiper instances
        if (swiperInstance && swiperInstance.allowTouchMove !== undefined) {
          try {
            swiperInstance.allowTouchMove = true;
            swiperInstance.allowSlideNext = true;
            swiperInstance.allowSlidePrev = true;
            if (swiperInstance.mousewheel && typeof swiperInstance.mousewheel.enable === 'function') {
              swiperInstance.mousewheel.enable();
            }
            if (swiperInstance.keyboard && typeof swiperInstance.keyboard.enable === 'function') {
              swiperInstance.keyboard.enable();
            }
          } catch (e) {
            // Swiper instance might be destroyed
          }
        }
        if (swiperInstanceHome && swiperInstanceHome.allowTouchMove !== undefined) {
          try {
            swiperInstanceHome.allowTouchMove = true;
            swiperInstanceHome.allowSlideNext = true;
            swiperInstanceHome.allowSlidePrev = true;
            if (swiperInstanceHome.mousewheel && typeof swiperInstanceHome.mousewheel.enable === 'function') {
              swiperInstanceHome.mousewheel.enable();
            }
            if (swiperInstanceHome.keyboard && typeof swiperInstanceHome.keyboard.enable === 'function') {
              swiperInstanceHome.keyboard.enable();
            }
          } catch (e) {
            // Swiper instance might be destroyed
          }
        }

        // Restore body scroll after a small delay to ensure modal is fully closed
        const scrollY = document.body.getAttribute('data-scroll-y');
        document.body.style.position = 'unset';
        document.body.style.top = 'unset';
        document.body.style.width = 'unset';
        document.body.style.height = 'unset';
        document.body.style.overflow = 'unset';

        // Remove event listeners
        window.removeEventListener('touchstart', preventGlobalScroll);
        window.removeEventListener('touchmove', preventGlobalScroll);
        window.removeEventListener('wheel', preventWheel);
        window.removeEventListener('scroll', preventGlobalScroll);
        document.removeEventListener('scroll', preventGlobalScroll);

        videoContainers.forEach(container => {
          container.removeEventListener('touchstart', preventReelsScroll);
          container.removeEventListener('touchmove', preventReelsScroll);
          container.removeEventListener('wheel', preventReelsScroll);
          container.removeEventListener('scroll', preventReelsScroll);
        });

        // Restore scroll on the main feed container (ContentFeed)
        const allPostsContainerRestore = document.querySelector('[class*="allPosts"]') as HTMLElement;
        if (allPostsContainerRestore) {
          if (originalOverflow) {
            allPostsContainerRestore.style.overflow = originalOverflow;
          } else {
            allPostsContainerRestore.style.overflow = '';
          }
          if (originalTouchAction) {
            allPostsContainerRestore.style.touchAction = originalTouchAction;
          } else {
            allPostsContainerRestore.style.touchAction = '';
          }
        }

        // Restore scroll position only to window, not to any comment containers
        // Use setTimeout to ensure modal is fully closed before restoring
        if (scrollY) {
          setTimeout(() => {
            // Only restore window scroll - never touch comment panel scroll
            // Check if modal is actually closed before restoring
            const modalStillOpen = document.querySelector('.comment-modal-open') || 
                                  document.querySelector('.instagram-comment-modal');
            
            if (!modalStillOpen) {
              // Restore window scroll position only - instant, no smooth behavior
              requestAnimationFrame(() => {
                window.scrollTo({
                  top: parseInt(scrollY),
                  left: 0,
                  behavior: 'auto'
                });
              });
            }
            document.body.removeAttribute('data-scroll-y');
          }, 150); // Delay to ensure modal transition and cleanup are complete
        }
      };
    }
  }, [instagramCommentModal, isMobile, swiperInstance, swiperInstanceHome]);

  // Prevent background scroll when poll comment modal is open on mobile
  useEffect(() => {
    if (pollCommentModal && isMobile) {
      // Only disable Swiper instances if preview modal is NOT open
      // The preview modal uses swiperInstance, so we shouldn't disable it when preview is open
      const isPreviewModalOpen = previewModalId !== null;
      
      if (swiperInstance && !isPreviewModalOpen && swiperInstance.allowTouchMove !== undefined) {
        try {
          swiperInstance.allowTouchMove = false;
          swiperInstance.allowSlideNext = false;
          swiperInstance.allowSlidePrev = false;
          if (swiperInstance.mousewheel && typeof swiperInstance.mousewheel.disable === 'function') {
            swiperInstance.mousewheel.disable();
          }
          if (swiperInstance.keyboard && typeof swiperInstance.keyboard.disable === 'function') {
            swiperInstance.keyboard.disable();
          }
        } catch (e) {
          // Swiper instance might be destroyed
        }
      }
      if (swiperInstanceHome && swiperInstanceHome.allowTouchMove !== undefined) {
        try {
          swiperInstanceHome.allowTouchMove = false;
          swiperInstanceHome.allowSlideNext = false;
          swiperInstanceHome.allowSlidePrev = false;
          if (swiperInstanceHome.mousewheel && typeof swiperInstanceHome.mousewheel.disable === 'function') {
            swiperInstanceHome.mousewheel.disable();
          }
          if (swiperInstanceHome.keyboard && typeof swiperInstanceHome.keyboard.disable === 'function') {
            swiperInstanceHome.keyboard.disable();
          }
        } catch (e) {
          // Swiper instance might be destroyed
        }
      }

      // Store current scroll position
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      document.body.style.overflow = 'hidden';
      
      // Store scroll position for restoration
      document.body.setAttribute('data-poll-modal-scroll-y', scrollY.toString());

      // Store original styles for restoration
      let originalOverflow = '';
      let originalTouchAction = '';
      
      // Disable scroll on the main feed container (ContentFeed)
      const allPostsContainer = document.querySelector('[class*="allPosts"]') as HTMLElement;
      if (allPostsContainer) {
        originalOverflow = allPostsContainer.style.overflow || '';
        originalTouchAction = allPostsContainer.style.touchAction || '';
        allPostsContainer.style.overflow = 'hidden';
        allPostsContainer.style.touchAction = 'none';
      }

      return () => {
        // Re-enable Swiper instances only if preview modal is NOT open
        // If preview modal is open, we want to keep swiperInstance enabled for the preview modal
        const isPreviewModalOpen = previewModalId !== null;
        
        if (swiperInstance && !isPreviewModalOpen && swiperInstance.allowTouchMove !== undefined) {
          try {
            swiperInstance.allowTouchMove = true;
            swiperInstance.allowSlideNext = true;
            swiperInstance.allowSlidePrev = true;
            if (swiperInstance.mousewheel && typeof swiperInstance.mousewheel.enable === 'function') {
              swiperInstance.mousewheel.enable();
            }
            if (swiperInstance.keyboard && typeof swiperInstance.keyboard.enable === 'function') {
              swiperInstance.keyboard.enable();
            }
          } catch (e) {
            // Swiper instance might be destroyed
          }
        }
        if (swiperInstanceHome && swiperInstanceHome.allowTouchMove !== undefined) {
          try {
            swiperInstanceHome.allowTouchMove = true;
            swiperInstanceHome.allowSlideNext = true;
            swiperInstanceHome.allowSlidePrev = true;
            if (swiperInstanceHome.mousewheel && typeof swiperInstanceHome.mousewheel.enable === 'function') {
              swiperInstanceHome.mousewheel.enable();
            }
            if (swiperInstanceHome.keyboard && typeof swiperInstanceHome.keyboard.enable === 'function') {
              swiperInstanceHome.keyboard.enable();
            }
          } catch (e) {
            // Swiper instance might be destroyed
          }
        }

        // Restore body scroll
        const scrollY = document.body.getAttribute('data-poll-modal-scroll-y');
        document.body.style.position = 'unset';
        document.body.style.top = 'unset';
        document.body.style.width = 'unset';
        document.body.style.height = 'unset';
        document.body.style.overflow = 'unset';

        // Restore scroll on the main feed container (ContentFeed)
        const allPostsContainerRestore = document.querySelector('[class*="allPosts"]') as HTMLElement;
        if (allPostsContainerRestore) {
          if (originalOverflow) {
            allPostsContainerRestore.style.overflow = originalOverflow;
          } else {
            allPostsContainerRestore.style.overflow = '';
          }
          if (originalTouchAction) {
            allPostsContainerRestore.style.touchAction = originalTouchAction;
          } else {
            allPostsContainerRestore.style.touchAction = '';
          }
        }

        // Restore scroll position
        if (scrollY) {
          setTimeout(() => {
            window.scrollTo({
              top: parseInt(scrollY),
              left: 0,
              behavior: 'auto'
            });
            document.body.removeAttribute('data-poll-modal-scroll-y');
          }, 100);
        }
      };
    }
  }, [pollCommentModal, isMobile, swiperInstance, swiperInstanceHome, previewModalId]);

  const closeConfirmModalS = () => {
    setConfirmModal(false);
  };

  const openConfirmModalS = () => {
    setConfirmModal(true);
  };

  const handleClickPopOver = (event: any) => {
    event.stopPropagation()
    setAnchorEll(event.currentTarget);
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCommentToPost = () => {
  const formData = new FormData();

    // Append comment fields
  formData.append("comment[commentable_id]", postInfo.id);
  formData.append("comment[comment]", comment);
  commentImage && formData.append("comment[files][]", commentImage);
    formData.append(
      "comment[commentable_type]",
      "BxBlockPosts::Post"
    );

    postCommentApiCall(formData);
      setComment("");
    handleImageCommentRemove()
    }

  const handleClosePopOver = () => {
    setAnchorEll(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedComment(null)
  };

  const handleReplyClick = (commentId: string | null, replyingTo: string) => {
    setReplyingToID(commentId);
    setReplyingToName(replyingTo)
    if (commentRef.current) {
      commentRef.current.focus();
    }
  }

  const handleReplyLike = (replyDetails: Comment, commentId?: string) => {
    if (!replyDetails || !replyDetails.attributes) return;
    const { id, attributes: { already_liked } } = replyDetails
    if(already_liked) {
      handleUndoLikeAPICall(id, "Comment", postInfo.id)
    } else {
      handleLikePostAPICall(replyDetails, "Comment", postInfo.id)
    }
  }

  const handleImageCommentClick = (event: React.MouseEvent<HTMLElement>) => {
    setCommentOptionsAnchorEl(event.currentTarget)
    setCommentOptionsModal(true)
  }

  const handleUploadVideoComment = (event?: React.MouseEvent | React.TouchEvent) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setCommentOptionsModal(false)
    setCommentOptionsAnchorEl(null)
    setVideoCommentModal(true)
    setSelectedVideoFile(null)
    setShowMobileVideoSource(false)
  }

  const handleCloseVideoCommentModal = () => {
    setVideoCommentModal(false)
    setSelectedVideoFile(null)
    setShowMobileVideoSource(false)
    // Reset all video inputs
    if (videoModalInputRef.current) videoModalInputRef.current.value = ''
    if (videoGalleryInputRef.current) videoGalleryInputRef.current.value = ''
    if (videoCameraInputRef.current) videoCameraInputRef.current.value = ''
    // Note: Don't clear comment state here as it might be used for regular comments
    // Only clear it after successful upload
  }

  const handleSelectVideo = () => {
    // Directly open file picker on both mobile and desktop
    if (videoModalInputRef.current) {
      videoModalInputRef.current.value = ''
      videoModalInputRef.current.click()
    }
  }

  const handleSelectFromGallery = () => {
    setShowMobileVideoSource(false)
    if (videoGalleryInputRef.current) {
      videoGalleryInputRef.current.value = ''
      videoGalleryInputRef.current.click()
    }
  }

  const handleSelectFromCamera = () => {
    setShowMobileVideoSource(false)
    if (videoCameraInputRef.current) {
      videoCameraInputRef.current.value = ''
      videoCameraInputRef.current.click()
    }
  }

  const handleAddPollComment = (event?: React.MouseEvent | React.TouchEvent) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setCommentOptionsModal(false)
    setCommentOptionsAnchorEl(null)
    setPollCommentModal(true)
  }

  const handleClosePollCommentModal = () => {
    setPollCommentModal(false)
    setPollQuestion("")
    setPollOptions(["", ""])
    setAllowMultipleResponses(true)
  }


  const handlePollOptionChange = (index: number, value: string) => {
    const newOptions = [...pollOptions]
    newOptions[index] = value
    setPollOptions(newOptions)
  }

  const handlePollContinue = async (event?: React.MouseEvent | React.TouchEvent) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    
    if (!pollQuestion.trim()) {
      handleOpenSnackbar("error", "Please enter a question")
      return
    }
    const validOptions = pollOptions.filter(opt => opt.trim() !== "")
    if (validOptions.length < 2) {
      handleOpenSnackbar("error", "Please add at least 2 options")
      return
    }
    if (!postInfo || !postInfo.id) {
      handleOpenSnackbar("error", "No post selected")
      return
    }

    try {
      let payload: any = {
        "comment": {
          "comment": "Poll",
          "commentable_id": postInfo.id,
          "commentable_type": "BxBlockPosts::Post",
          "comment_poll_attributes": {
            "question": pollQuestion.trim(),
            "comment_poll_options_attributes": validOptions.map((item) => ({
              name: item.trim()
            }))
          }
        }
      }
      postPollApiCall(payload);
      setPollDataStore(payload);
      handleClosePollCommentModal();
      setTimeout(() => {
        getPostCommentsApiCall(postInfo.id);
        setTimeout(() => {
          setPollDataStore(null);
        }, 1000);
      }, 2000);
    } catch (error) {
      console.error("Error creating poll:", error);
      handleOpenSnackbar("error", "An error occurred while creating the poll. Please try again.")
    }
  }

  const handleCloseCommentOptionsModal = () => {
    setCommentOptionsModal(false)
    setCommentOptionsAnchorEl(null)
  }

  const handleVideoCommentUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files: videoFiles } = event.currentTarget;
    if (videoFiles && videoFiles.length > 0) {
      const currentFile = videoFiles[0];
      
      // Validate file type - only allow video files
      const validVideoTypes = [
        'video/mp4', 
        'video/mpeg', 
        'video/quicktime', 
        'video/x-msvideo',
        'video/x-matroska',
        'video/webm',
        'video/3gpp',
        'video/x-flv'
      ];
      
      // Also check file extension as fallback
      const validExtensions = ['.mp4', '.mpeg', '.mov', '.avi', '.mkv', '.webm', '.3gp', '.flv'];
      const fileExtension = currentFile.name.toLowerCase().substring(currentFile.name.lastIndexOf('.'));
      
      const isValidVideoType = validVideoTypes.includes(currentFile.type) || 
                               validExtensions.includes(fileExtension) ||
                               currentFile.type.startsWith('video/');
      
      if (isValidVideoType) {
        // Store the selected video file
        setSelectedVideoFile(currentFile)
        handleOpenSnackbar("success", "Video selected: " + currentFile.name)
        // Don't close modal yet - user can review and confirm
      } else {
        handleOpenSnackbar("error", "Invalid file type. Please select a video file only (MP4, MOV, AVI, etc.)")
        // Reset input on error
        if (videoModalInputRef.current) videoModalInputRef.current.value = ''
        if (videoInputRef.current) videoInputRef.current.value = ''
        if (videoGalleryInputRef.current) videoGalleryInputRef.current.value = ''
        if (videoCameraInputRef.current) videoCameraInputRef.current.value = ''
      }
    }
  }

  const handleConfirmVideoUpload = () => {
    if (selectedVideoFile) {
      const formData = new FormData();
      
      // Handle reply vs top-level comment
      if (replyingToID) {
        // This is a reply to a comment
        formData.append("comment[commentable_id]", replyingToID);
        formData.append("comment[commentable_type]", "BxBlockComments::Comment");
      } else {
        // This is a top-level comment
        formData.append("comment[commentable_type]", "BxBlockPosts::Post");
        formData.append("comment[commentable_id]", postInfo.id);
      }
      
      // Append comment text (use comment from state, or empty string if not provided)
      formData.append("comment[comment]", comment || "");
      
      // Append video file - ensure it's added correctly
      formData.append("comment[files][]", selectedVideoFile);
      
      // Debug: Verify FormData structure
      // console.log("handleConfirmVideoUpload FormData:", {
      //   commentable_type: replyingToID ? "BxBlockComments::Comment" : "BxBlockPosts::Post",
      //   commentable_id: replyingToID || postInfo.id,
      //   comment: comment || "(empty)",
      //   hasVideoFile: true,
      //   videoFileName: selectedVideoFile.name,
      //   videoFileSize: selectedVideoFile.size,
      //   videoFileType: selectedVideoFile.type
      // });
      
      // Call the API to upload video comment
      postCommentApiCall(formData, postInfo.id);
      
      // Refresh comments after upload
      setTimeout(() => {
        getPostCommentsApiCall(postInfo.id);
      }, 1000);
      
      handleOpenSnackbar("success", "Video comment uploaded: " + selectedVideoFile.name);
      handleCloseVideoCommentModal();
      setSelectedVideoFile(null);
      setComment("");
      setReplyingToID(null);
      setReplyingToName("");
    } else {
      handleOpenSnackbar("error", "Please select a video file first");
    }
  }

  const handleImageCommentRemove = () => {
    setCommentImage(null)
  }

  const isSelfPost = () => {
    if(postInfo && userAccount) {
      return String(postInfo.attributes.account_id) === userAccount.id
    }
    return false
  }

  const toggleCommentHighlight = (commentId: string | number) => {
    setManuallyHighlightedComments(prev => {
      const newSet = new Set(prev);
      if (newSet.has(commentId)) {
        newSet.delete(commentId);
      } else {
        newSet.add(commentId);
      }
      
      // Save to localStorage
      const storageKey = `highlighted_comments_${postInfo.id}`;
      localStorage.setItem(storageKey, JSON.stringify(Array.from(newSet)));
      
      return newSet;
    });
  }

  const isCommentManuallyHighlighted = (commentId: string | number) => {
    return manuallyHighlightedComments.has(commentId);
  }

  const handleCloseSnackbar = () => {
    setToastType(undefined)
    setToastMessage("")
  }

  const checkAndCondition = (condition1: string | boolean, condition2: string | boolean) => {
    return condition1 && condition2
  }

  const handleImageCommentUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files: imageFiles } = event.currentTarget;
    if (imageFiles && imageFiles.length > 0) {
      const currentFile = imageFiles[0];
      
      const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      
      if (validImageTypes.includes(currentFile.type)) {
        setCommentImage(currentFile);
      } else {
        handleOpenSnackbar("error", "Invalid file type. Please upload a jpeg, jpg, or png image.")
      }
    }
  }

  const handleCommentOnBlur = () => {
    if (comment === "" && !anchorEl) {
      // setReplyingToID(null)
      // setReplyingToName("")
    }
  }

  const getValue = (value: number | string | null) => {
    if (!value || isNaN(Number(value))) return "0";
  
    const num = Number(value);
  
    if (num >= 1_000_000_000) {
      return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      return num.toString();
    }
  };
  
  

  const ternaryCondition = <T, F>(
    condition: string | boolean | null,
    trueValue: T,
    falseValue: F
  ): T | F => {
    return condition ? trueValue : falseValue;
  }

  const toggleCommentsSorting = () => {
    const updatedOrder =
      commentsOrder === CommentsOrderEnum.ASC
        ? CommentsOrderEnum.DESC
        : CommentsOrderEnum.ASC;
    setCommentsOrder(updatedOrder);
    handleSortingCommentsChange(true);
    getPostCommentsApiCall(postInfo.id, updatedOrder);
  }
  const handlePreviewModalOpen = (files : {link: string}[], index?: number) => {
    // Pause all desktop videos before opening modal
    desktopVideoRefs.current.forEach((video) => {
      if (video) {
        video.pause();
        video.muted = true;
        video.volume = 0;
      }
    });
    
    setPreviewModalId(postInfo.id)
    setMediaFiles(files)
    if (index !== undefined && allPosts) {
      setCurrentPostIndex(index)
      setCurrentPostSlide(0)
    }
  }

  // Lock background scroll while the Instagram Reels-style preview modal is open. Without
  // this, a vertical swipe inside the modal's own Swiper also drags the page underneath
  // (which is still natively scrollable/elastic), so the browser's own scroll/rubber-band
  // fights the Swiper's transform-based slide transition - on iOS Safari in particular this
  // shows up as the swipe visibly bouncing back the wrong way for a moment before the
  // correct slide settles into place. instagramCommentModal already gets this treatment
  // above; the reels preview modal (previewModalId) never did.
  useEffect(() => {
    if (!previewModalId) return;
    const scrollY = window.scrollY;
    const { body } = document;
    const previousPosition = body.style.position;
    const previousTop = body.style.top;
    const previousWidth = body.style.width;
    const previousHeight = body.style.height;
    const previousOverflow = body.style.overflow;
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.width = '100%';
    body.style.height = '100%';
    body.style.overflow = 'hidden';
    return () => {
      body.style.position = previousPosition;
      body.style.top = previousTop;
      body.style.width = previousWidth;
      body.style.height = previousHeight;
      body.style.overflow = previousOverflow;
      window.scrollTo(0, scrollY);
    };
  }, [previewModalId]);

  useEffect(() => {
    setMediaFiles(files)
  }, [])

  // Load highlighted comments from localStorage
  useEffect(() => {
    const storageKey = `highlighted_comments_${postInfo.id}`;
    const savedHighlights = localStorage.getItem(storageKey);
    if (savedHighlights) {
      try {
        const highlightsArray = JSON.parse(savedHighlights);
        setManuallyHighlightedComments(new Set(highlightsArray));
      } catch (error) {
        console.error('Error loading highlighted comments:', error);
      }
    }
  }, [postInfo.id]);

  // Auto-expand comments when coming from notification
  useEffect(() => {
    if (autoExpandComments && !postComment) {
      setPostComment(true);
      getPostCommentsApiCall(postInfo.id);
    }
  }, [autoExpandComments, postComment, getPostCommentsApiCall, postInfo.id]);

  // Handle comment highlighting from notification
  useEffect(() => {
    // console.log("Highlight Effect:", {
    //   highlightedCommentId,
    //   highlightedComment,
    //   postComment,
    //   postId: postInfo.id
    // });
    
    if (highlightedCommentId && highlightedCommentId !== highlightedComment) {
      setHighlightedComment(highlightedCommentId);
      
      // Auto-expand comments if not already expanded
      if (!postComment) {
        setPostComment(true);
        getPostCommentsApiCall(postInfo.id);
      }
      
      // Remove highlight after 2.5 seconds
      const timer = setTimeout(() => {
        setHighlightedComment(null);
      }, 2500);
      
      return () => clearTimeout(timer);
    }
  }, [highlightedCommentId, highlightedComment, postComment, getPostCommentsApiCall, postInfo.id]);

  // Scroll to highlighted comment
  useEffect(() => {
    // console.log("Scroll Effect:", {
    //   highlightedComment,
    //   hasRef: !!highlightedCommentRef.current
    // });
    
    if (highlightedComment && highlightedCommentRef.current) {
      // Small delay to ensure the comment is rendered
      setTimeout(() => {
        highlightedCommentRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 100);
    }
  }, [highlightedComment]);

  // Test function for highlighting (remove in production)
  const testHighlightComment = (commentId: string) => {
    setHighlightedComment(commentId);
    setPostComment(true);
    getPostCommentsApiCall(postInfo.id);
  };



  const handlePreviewModalClose = () => {
    const pauseAndMute = (video:any) => {
      if (video) {
        video.pause();
        video.currentTime = 0; // reset to start
        video.muted = true;
        video.volume = 0;
        video.removeAttribute('autoplay'); // prevent browser from re-triggering
      }
    };
  
    // Pause every video ref type
    videoRefs.current.forEach((video) => pauseAndMute(video));
    reelVideoRefs.current.forEach((video) => pauseAndMute(video));
    desktopVideoRefs.current.forEach((video) => pauseAndMute(video));
  
    // Destroy Swiper instances safely
    if (isMountedRef.current) {
      try { 
        if (swiperInstance && swiperInstance.destroy) {
          swiperInstance.destroy(true, true);
        }
      } catch {}
      try { 
        if (swiperInstanceHome && swiperInstanceHome.destroy) {
          swiperInstanceHome.destroy(true, true);
        }
      } catch {}
    
      setSwiperInstance(null);
      setSwiperInstanceHome(null);
      setPreviewModalId(null);
      setMediaFiles(files);
    }
  
    // Absolute silence guarantee — after DOM settles
    setTimeout(() => {
      document.querySelectorAll('video').forEach((video) => {
        // Ensure desktop feed videos stay paused
        const isDesktopFeed = video.getAttribute('data-desktop-feed') === 'true';
        video.pause();
        video.muted = true;
        video.volume = 0;
        if (isDesktopFeed) {
          video.removeAttribute('autoplay');
          video.currentTime = 0;
        }
      });
    }, 200);
  };
  
  

  const getCommentHeaderUI = (item : any, isCurrentUserPost: boolean = false) => {
    const isNotificationHighlighted = highlightedComment === item.id;
    const isManuallyHighlighted = isCommentManuallyHighlighted(item.id);
    const isHighlighted = isNotificationHighlighted || isManuallyHighlighted;
    const isNotCurrentUser = !isCurrentUserPost;
    
    // Check for poll data - try multiple possible property names
    const commentPoll = item.attributes?.comment_poll || item.attributes?.poll;
    const commentPollOptions = item.attributes?.comment_poll_options || item.attributes?.poll_options || [];
    
    if (isHighlighted) {
      console.log("Comment highlighted:", {
        commentId: item.id,
        isNotificationHighlighted,
        isManuallyHighlighted,
        highlightedComment
      });
    }
    
    // Determine background color: highlighted > not current user (yellow) > transparent
    let backgroundColor = "transparent";
    let borderRadius = "0px";
    let padding = "0px";
    let margin = "0px";
    
    // if (isHighlighted) {
    //   backgroundColor = "#fff2d2";
    //   // borderRadius = "8px";
    //   padding = "8px";
    //   // margin = "4px 0";
    // } else if (isNotCurrentUser) {
    //   backgroundColor = "#fff2d2"; // Cream/beige color
    //   // borderRadius = "8px";
    //   padding = "8px";
    //   // margin = "4px 0";
    // }
    
    return (
      <div 
        ref={isHighlighted ? highlightedCommentRef : null}
        className={classes.commentscardHeader}
        style={{
          backgroundColor: backgroundColor,
          borderRadius: borderRadius,
          padding: padding,
          margin: margin,
          transition: "all 0.3s ease-in-out"
        }}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "flex-start",
          }}
          id="commentAvtarBox"
        >
          <Avatar
            className={classes.avatar}
            data-test-id="commentAvtarBox"
          >
            <img
              src={commonFunctionForCondition(
                item.attributes?.account.data?.attributes
                  ?.profile_pic?.url,
                item.attributes?.account.data?.attributes
                  ?.profile_pic?.url,
                IconAvtar
              )}
              className={`${classes.fallbackAvatar} ${
                item.attributes?.archived == null
                  ? classes.cardHeaderContentOfResponsiveContainer
                  : ""
              }`}
              onError={(e) => {
                // If image fails to load, show fallback avatar
                const target = e.target as HTMLImageElement;
                if (target.src !== IconAvtar) {
                  target.src = IconAvtar;
                }
              }}
            />
          </Avatar>
        </Box>
        <div
          className={`${classes.cardHeaderContent} ${
            item.attributes?.archived == null
              ? classes.cardHeaderContentOfResponsiveContainer
              : ""
          }`}
          id="commentcardHeader"
        >
          <ReceiverMessageContainer id="commentContainer">
            <MessageBubble data-test-id="commentBuble">
              <div
                style={{
                  display: "flex",
                  // justifyContent: "space-between",
                  marginLeft:'10px'
                }}
              >
                <div className="commenterNAme">
                  <Typography
                    className={classes.commnetSectionUser}
                  >
                    {commonFunctionForCondition(
                      item.attributes?.account.data.attributes
                        .first_name !== null,
                      item.attributes?.account.data.attributes
                        .first_name,
                      ""
                    ) +
                      " " +
                      commonFunctionForCondition(
                        item.attributes?.account.data.attributes
                          .last_name !== null,
                        item.attributes?.account.data.attributes
                          .last_name,
                        ""
                      )}
                  </Typography>
                </div>
                <div className="commenterTime">
                  <Typography className={classes.commentTime}>
                    {moment(
                      item.attributes?.created_at
                    ).fromNow()}
                  </Typography>
                </div>
              </div>
              <Typography className={classes.commentFonts} style={{marginLeft: '10px',}}>
                {
                  commentPoll 
                    ? commentPoll.question ?? ""   // show only actual comment
                    : (item.attributes?.comment === "Poll" ? "" : item.attributes.comment)  // show full comment when no poll, but hide "Poll" placeholder
                }
              </Typography>
              {/* Render Poll UI at the top, right after comment text */}
              {commentPoll && (
                <Box
                  style={{
                    marginTop: "12px",
                    marginLeft: "10px",
                    marginRight: "10px",
                    padding: "12px 0"
                  }}
                >
                  <Poll
                    hideLabel={true}
                    poll={{
                      id: commentPoll.id,
                      question: commentPoll.question,
                      comment_id: item.id,
                      post_id: item.attributes.commentable_id,
                      created_at: commentPoll.created_at,
                      user_voted_option_id: commentPoll.user_voted_option_id,
                      total_count: commentPoll.total_count
                    }}
                    poll_options={commentPollOptions}
                    accountProfile={item.attributes?.account?.data?.attributes?.profile_pic?.url}
                    handleVote={(optionId: number) => {
                      console.log("VOTED optionId:", optionId);
                      console.log("VOTED POST id:", item.id);
                      console.log("VOTED POST:", item);
                    
                      return handleVoteComment(optionId, item.id);
                    }}
                    
                    handleDeleteVote={(optionId: number) => {
                      console.log("handleDeleteVote optionId", optionId)
                      console.log("handleDeleteVote item.id", item.id)
                      handleDeleteVote(optionId, item.id)
                      return;
                    }}
                  />
                </Box>
              )}
              <CommentImage files={item.attributes.files} />

            </MessageBubble>
          </ReceiverMessageContainer>
        </div>

        <div className={classes.commentCardHeaderAction} data-test-id="postSettingsIcon">
          <IconButton
            size="small"
            onClick={(event: any) => {
              handleClick(event);
              handleCommentClick(item.attributes?.account_id);
              setReplyingToName(
                commonFunctionForCondition(
                  item.attributes?.account.data.attributes
                    .first_name !== null,
                  item.attributes?.account.data.attributes
                    .first_name,
                  ""
                ) +
                  " " +
                  commonFunctionForCondition(
                    item.attributes?.account.data.attributes
                      .last_name !== null,
                    item.attributes?.account.data.attributes
                      .last_name,
                    ""
                  )
              );
              setSelectedCommentId(item.attributes?.id);
              setSelectedComment(item);
            }}
            aria-label="post-settings"
            className={classes.postSettingsBtn}
            data-test-id="threeDotIconPopOver"
          >
            <MoreVertIcon data-test-id="commentMore" />
          </IconButton>
        </div>
      </div>
    )
  }

  const getCommentActionsUI = (item : any, isCurrentUserPost: boolean = false) => {
    const isNotCurrentUser = !isCurrentUserPost;
    
    return (
      <div
        className={`${classes.commentCardActions} ${
          item.attributes?.archived == null
            ? classes.cardHeaderContentOfResponsiveContainer
            : ""
        }`}
        id="cardActions"
        style={{
          // backgroundColor: isNotCurrentUser ? "#fff2d2" : "transparent",
          // borderRadius: isNotCurrentUser ? "8px" : "0px",
          // padding: isNotCurrentUser ? "8px" : "0px",
          // margin: isNotCurrentUser ? "0px 0px 20px 0px" : "0px 0px 20px 0px",
          transition: "all 0.3s ease-in-out"
        }}
      >
        <div
          className={classes.reactionBtn}
          data-test-id="reactionButtons"
        >
          {item.attributes?.already_liked ? (
            <IconButton data-test-id="undo-like-comment" className="icons" aria-label="post-likes" onClick={() => handleUndoLikeAPICall(item.id, "Comment", postInfo.id)} style={{padding:'0px'}}>
              <img src={redHeart} alt="heart" className="likes" />
            </IconButton>
          ) : (
            <IconButton
              onClick={() =>
                handleLikePostAPICall(item, "Comment")
              }
              className="icons"
              aria-label="post-likes"
            >
              <img
                src={HeartSmallIcon}
                alt="heart"
                className="likes"
              />
            </IconButton>
          )}
          <Typography
            variant="body2"
            data-test-id="likesCountss"
            className={classes.likesComments}
            component="span"
          >
            {item.attributes?.likes_count}
          </Typography>
        </div>
        <div
          className={classes.reactionBtn}
          data-test-id="replyOuter"
          onClick={() =>
            handleReplyClick(
              item.id,
              commonFunctionForCondition(
                item.attributes?.account.data.attributes
                  .first_name !== null,
                item.attributes?.account.data.attributes
                  .first_name,
                ""
              ) +
                " " +
                commonFunctionForCondition(
                  item.attributes?.account.data.attributes
                    .last_name !== null,
                  item.attributes?.account.data.attributes
                    .last_name,
                  ""
                )
            )
          }
          id="cardChatButtons"
        >
          <Typography
            variant="body2"
            className={classes.likesComments}
            style={{ cursor: "pointer" }}
            component="span"
            id="chatBubbleCounts"
          >
            Reply
          </Typography>
        </div>
        {handleOrConditions(
          item.attributes?.replies?.data.length,
          <div
            className={classes.reactionBtn}
            data-test-id="openRepliesButton"
            onClick={() => {
              if (viewReplies === item.id) {
                setViewReplies(null);
              } else {
                setViewReplies(item.id);
              }
            }}
          >
            <Typography
              component="span"
              variant="body2"
              className={classes.viewComments}
            >
              View reply
            </Typography>

            <IconButton size="small" className={clsx(classes.replyExpandIcon, {
              [classes.replyExpandedIcon]: viewReplies === item.id
            })} aria-label="post-likes">
              <ExpandMoreIcon />
            </IconButton>
          </div>,
          null
        )}
      </div>
    )
  }

  const getCommentsListUI = () => {
    // console.log(":comments?.data",comments?.data,account_id)
    // Separate poll comments and normal comments
    const pollComments = comments?.data?.filter((item: any) => {
      const commentPoll = item.attributes?.comment_poll || item.attributes?.poll;
      return !!commentPoll; // Only include comments with polls
    }) || [];
    
    const normalComments = comments?.data?.filter((item: any) => {
      const commentPoll = item.attributes?.comment_poll || item.attributes?.poll;
      return !commentPoll; // Only include comments without polls
    }) || [];
    
    return (
      <Box>
        {/* Render poll comments first in the comment list (scrolls normally) */}
        {pollComments.map((item: any) => {
          const isCurrentUserPost = item?.attributes?.account_id == account_id
          
          return (
            <div key={item.id} id={`comment-${item.id}`}>
              {getCommentHeaderUI(item, isCurrentUserPost)}
              {getCommentActionsUI(item, isCurrentUserPost)}
            </div>
          );
        })}
        
        {/* Also show local poll if it exists (for newly created polls) */}
        {isCommentPoll && (localPoll || poll) && !pollComments.find((item: any) => {
          const commentPoll = item.attributes?.comment_poll || item.attributes?.poll;
          return commentPoll?.id === (localPoll || poll)?.id;
        }) && (
          <div>
            <Poll 
              poll={localPoll || poll} 
              poll_options={localPollOptions.length > 0 ? localPollOptions : poll_options} 
              accountProfile={account_profile?.url} 
              handleVote={(optionId : number) => handleVote(optionId, postInfo.id)} 
              handleDeleteVote={(optionId : number) => handleDeleteVote(optionId, postInfo.id)}
            />
          </div>
        )}
        
        {/* Render normal comments below poll comments */}
        {normalComments.map((item: any) => {
          const isCurrentUserPost = item?.attributes?.account_id == account_id
          const commentDetails = item
          return (
            <div key={item.id} id={`comment-${item.id}`}>
              {getCommentHeaderUI(item, isCurrentUserPost)}
              {getCommentActionsUI(item, isCurrentUserPost)}

              {viewReplies == item.id &&
                item.attributes?.replies?.data.map(
                  (item: Comment) => {
                    if (!item || !item.attributes) return null;
                    const { attributes, attributes: { account, files } } = item
                    const { data: {
                      attributes: {
                        first_name,
                        last_name,
                      }
                    } } = account

                    const isReplyNotificationHighlighted = highlightedComment === item.id;
                    const isReplyManuallyHighlighted = isCommentManuallyHighlighted(item.id);
                    const isReplyHighlighted = isReplyNotificationHighlighted || isReplyManuallyHighlighted;
                    const isReplyCurrentUserPost = item?.attributes?.account_id == account_id;
                    const isReplyNotCurrentUser = !isReplyCurrentUserPost;
                    
                    // Determine background color: highlighted > not current user (cream/beige) > transparent
                    let replyBackgroundColor = "transparent";
                    let replyBorderRadius = "0px";
                    let replyPadding = "0px";
                    let replyMargin = "0px";
                    
                    // if (isReplyHighlighted) {
                    //   replyBackgroundColor = "#fff2d2";
                    //   replyBorderRadius = "8px";
                    //   replyPadding = "8px";
                    //   replyMargin = "4px 0";
                    // } else if (isReplyNotCurrentUser) {
                    //   replyBackgroundColor = "#fff2d2"; // Cream/beige color
                    //   replyBorderRadius = "8px";
                    //   replyPadding = "8px";
                    //   replyMargin = "4px 0";
                    // }
                    
                    return (
                      <>
                        <div ref={isReplyHighlighted ? highlightedCommentRef : null}>
                          <ReplayToComment 
                            className={classes.commentscardHeader}
                            style={{
                              backgroundColor: replyBackgroundColor,
                              borderRadius: replyBorderRadius,
                              padding: replyPadding,
                              margin: replyMargin,
                              marginLeft: '53px',
                              transition: "all 0.3s ease-in-out"
                            }}
                          >
                          <Box
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Avatar className={classes.avatar}>
                              <img
                                src={commonFunctionForCondition(
                                  item.attributes?.account.data.attributes
                                    ?.profile_pic?.url,
                                  item.attributes?.account.data.attributes
                                    ?.profile_pic?.url,
                                  IconAvtar
                                )}
                                className={classes.fallbackAvatar}
                              />
                            </Avatar>
                          </Box>
                          <div
                            className={`${classes.cardHeaderContent} ${
                              item.attributes?.archived == null
                                ? classes.cardHeaderContentOfResponsiveContainer
                                : ""
                            }`}
                          >
                            <ReceiverMessageContainer>
                              <MessageBubble>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div style={{ marginRight: "10px" }}>
                                    <Typography
                                      className={
                                        classes.commnetSectionUser
                                      }
                                    >
                                      {item.attributes?.account.data
                                        .attributes?.first_name +
                                        " " +
                                        item.attributes?.account.data
                                          ?.attributes?.last_name}
                                    </Typography>
                                  </div>
                                  <div>
                                    <Typography className="replyToCommentTime" >
                                      {moment(
                                        item.attributes?.created_at
                                      ).fromNow()}
                                    </Typography>
                                  </div>
                                </div>
                                <Typography
                                  className={classes.commentFonts}
                                >
                                  {item.attributes?.comment}
                                </Typography>
                                <CommentImage files={files} />
                              </MessageBubble>
                            </ReceiverMessageContainer>
                          </div>

                          <div
                            className={classes.commentCardHeaderAction}
                            data-test-id="replyCommentDivv"
                          >
                            <IconButton
                              size="small"
                              onClick={(event: any) => {
                                handleClick(event);
                                setSelectedComment(item);
                                handleCommentClick(
                                  item.attributes?.account_id
                                );
                                setReplyingToName(`${first_name} ${last_name}`)
                                setSelectedCommentId(item.id);
                              }}
                              aria-label="post-settings"
                              className={classes.postSettingsBtn}
                              data-test-id="replyCommenthreeDotPopOver"
                            >
                              <MoreVertIcon data-test-id="commentMore" />
                            </IconButton>
                          </div>
                        </ReplayToComment>
                        </div>
                        <div
                          data-test-id="replyCOmmentActions"
                          className={`${classes.commentReplyCardActions} ${
                            item.attributes?.archived == null
                              ? classes.cardHeaderContentOfResponsiveContainer
                              : ""
                          }`}
                          style={{
                            // backgroundColor: isReplyNotCurrentUser ? "#fff2d2" : "transparent",
                            // borderRadius: isReplyNotCurrentUser ? "8px" : "0px",
                            // padding: isReplyNotCurrentUser ? "8px" : "0px",
                            // margin: isReplyNotCurrentUser ? "0px 0px 10px 0px" : "0px 0px 10px 0px",
                            marginLeft: '53px',
                            transition: "all 0.3s ease-in-out"
                          }}
                        >
                          <div
                            className={classes.reactionBtn}
                            data-test-id="reactonButtonsOfReply"
                          >
                            <IconButton aria-label="post-likes" onClick={() => handleReplyLike(item, commentDetails.id)} style={{padding:'0px'}}>
                              <img src={attributes.already_liked ? redHeart :HeartSmallIcon} />
                            </IconButton>
                            <Typography
                              component="span"
                              variant="body2"
                              className={classes.likesComments}
                            >
                              {attributes.likes_count}
                            </Typography>
                          </div>
                          <div className={classes.reactionBtn}>
                            <div
                              className={classes.reactionBtn}
                              data-test-id="replyOuter"
                              onClick={() =>
                                handleReplyClick(
                                  commentDetails.id,
                                  `${first_name} ${last_name}`
                                )
                              }
                              id="cardChatButtons"
                            >
                              <Typography
                                variant="body2"
                                className={classes.likesComments}
                                style={{ cursor: "pointer" }}
                                component="span"
                                id="chatBubbleCounts"
                              >
                                Reply
                              </Typography>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  }
                )}
            </div>
          );
        })}
        </Box>
    )
  }

  const returnPollUI = () => {
    if (!pollDataStore) return null;
    
    const pollData = pollDataStore as any;
    const pollQuestion = pollData?.comment?.comment_poll_attributes?.question;
    const pollOptionsData = pollData?.comment?.comment_poll_attributes?.comment_poll_options_attributes || [];
    
    if (!pollQuestion || pollOptionsData.length === 0) return null;
    
    // Create temporary poll structure from payload
    const tempPollOptions = pollOptionsData.map((opt: any, index: number) => ({
      id: Date.now() + index, // Temporary ID
      comment_poll_id: Date.now(),
      name: opt.name,
      vote_count: 0,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString()
    }));
    
    const tempPoll = {
      id: Date.now(),
      comment_id: Date.now(),
      post_id: parseInt(pollData?.comment?.commentable_id),
      question: pollQuestion,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      total_count: 0,
      user_voted_option_id: null
    };
    
    return (
      <Box style={{
        marginTop: '12px',
        marginLeft: '10px',
        marginRight: '10px',
        padding: '12px 0'
      }}>
        <Poll 
          poll={tempPoll as any}
          poll_options={tempPollOptions} 
          accountProfile={account_profile?.url} 
          handleVote={(optionId: number) => handleVote(optionId, postInfo.id)} 
          handleDeleteVote={(optionId: number) => handleDeleteVote(optionId, postInfo.id)} 
        />
      </Box>
    )
  }

  const returnPreviewBodyUI = (body : string) => {
    // Check if text is likely to overflow 2 lines (rough estimate: ~80-100 chars per 2 lines)
    const shouldShowMore = body && body.length > 80;

    return (
      <PostSummary>
        <Typography className="userName">
          {`${business_name}`}
        </Typography>
        <Box style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'baseline' }}>
          <Typography
            variant="body2"
            className={clsx(classes.postDescripation, isDescriptionExpanded && classes.postDescripationExpanded)}
            style={{ lineHeight: '1.4', wordBreak: 'break-word', margin: 0, padding: 0 }}
          >
            {body}
          </Typography>
          {shouldShowMore && (
            <Typography
              component="span"
              variant="body2"
              style={{ 
                cursor: "pointer", 
                fontWeight: 'bold',
                color: '#fff',
                marginLeft: '4px',
                whiteSpace: 'nowrap',
                textShadow: "0 1px 2px rgba(0,0,0,0.8)"
              }}
              onClick={(e) => {
                e.stopPropagation();
                setIsDescriptionExpanded(!isDescriptionExpanded);
              }}
            >
              {isDescriptionExpanded ? ' less' : ' more'}
            </Typography>
          )}
        </Box>
      </PostSummary>
    )
  }

  const returnProfileLikeCommentBodyUI = () => {
    return <Box className={classes.previewBottomWrapper}>
        <Box style={{flex: 1, minWidth: 0, maxWidth: 'calc(100% - 80px)'}}>
          {returnPreviewBodyUI(body)}
        </Box>

      <Box className={classes.reactionContainer}>
        <Avatar
          className={classes.avatar}
          style={{height: "35px", width: "35px", marginRight: "0px",borderRadius:'40px', marginBottom: '0px'}}
          data-test-id="preview-post-profile-wrapper"
          onClick={(event) => { event.stopPropagation(); handlePostProfileClick(account_id) }}
        >
          <img
            src={account_profile?.url && account_profile.url.trim() !== '' ? account_profile.url : IconAvtar}
            className={classes.fallbackAvatar}
            onError={(e) => {
              // If image fails to load, show fallback avatar
              const target = e.target as HTMLImageElement;
              if (target.src !== IconAvtar) {
                target.src = IconAvtar;
              }
            }}
          />
        </Avatar>
      {is_liked ? (
          <IconButton style={{ color: 'white',paddingBottom:0, marginBottom:'-9px' }} onClick={(event) => { event.stopPropagation(); handleUndoLikeAPICall(postInfo.id, "Post")}}>
            <FavoriteIcon style={{ color: 'red', fontSize: "30px" }} />
          </IconButton>
        ) : (
          <IconButton
            aria-label="post-likes"
            data-test-id="preview-post-like-box"
            style={{ color: 'white', paddingBottom:0, marginBottom:'-9px' }}
            onClick={(event) => { event.stopPropagation(); handleLikePostAPICall(postInfo, "Post")}}
          >
            <FavoriteBorderOutlinedIcon style={{fontSize: "30px"}}/>
          </IconButton>
        )}
      <Typography variant="body2" style={{ marginLeft: '0px',marginTop:'-3px' }}>
        {getValue(likes_count)}
      </Typography>

      <div
        data-test-id="preview-openCommentButton"
        className={classes.reactionBtn}
        onClick={(event) => {
          openInstagramCommentModal(event, postInfo);
        }}
        style={{padding:0 }}
      >
        <IconButton aria-label="post-comments" style={{padding:0, marginBottom:'-6px' }}>
          <img
            src={CommentIconWhite}
            alt="Comment"
            className={classes.commentIconWhite}
          />
        </IconButton>
      </div>
      <Typography variant="body2" style={{ marginLeft: '0px', marginTop:'-3px' }}>
        {getValue(comments_count)}
      </Typography>

      <IconButton
        size="small"
        onClick={handleClickPopOver}
        data-test-id="preview-threeDotIcon"
        aria-label="post-settings"
        className={classes.postSettingsBtn}
        style={{
          pointerEvents: "auto",
          zIndex: 1000,
        }}
      >
        <MoreHorizRoundedIcon style={{ color: 'white', fontSize: "28px" }} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEll}
        onClose={handleClosePopOver}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        classes={{
          paper: classes.popOverPaper,
        }}
      >
        {isSelfPost() ? (
          <StyledMenuItem
            data-test-id="preview-deletePost"
            onClick={openDeletePostConfirmationModalS}
          >
            <ListItemText primary="Delete Post" />
          </StyledMenuItem>
        ) : (
          <>
            {isPostHidden ? (
              <StyledMenuItem
                data-test-id="preview-unhidePost"
                onClick={(event) => {
                  event.stopPropagation();
                  safeSetIsPostHidden(false);
                  handleClosePopOver();
                  // Only close preview modal if it's open
                  if (previewModalId) {
                    handlePreviewModalClose();
                  }
                }}
              >
                <ListItemText primary="Unhide Post" />
              </StyledMenuItem>
            ) : (
              <StyledMenuItem
                data-test-id="preview-hidePost"
                onClick={openHideConfirmationModalS}
              >
                <ListItemText primary={configJSON.hidePostText} />
              </StyledMenuItem>
            )}
            <StyledMenuItem
              data-test-id="preview-banUser"
              onClick={openEndWaitlistModalS}
            >
              <ListItemText primary="Ban User" />
            </StyledMenuItem>
          </>
        )}
      </Popover>
    </Box>
  </Box>
  }

  const getCommentsUI = () => {
    // Check if we have comments or poll comments
    const pollComments = comments?.data?.filter((item: any) => {
      const commentPoll = item.attributes?.comment_poll || item.attributes?.poll;
      return !!commentPoll;
    }) || [];
    const hasPollComments = pollComments.length > 0 || (isCommentPoll && (poll || localPoll));
    const hasComments = comments && comments.data && comments.data.length > 0;
    
    return (
      <div className={classes.commentSectionContainer}>
        <CustomLoader
              isLoading={isSortingComments}
              wrapperHeight="150px"
              loaderSize={20}
            >
            {((hasComments) || hasPollComments) ? (
              <Box className={classes.commentsContentWrapper} style={!isMobile ? {maxHeight:'260px'} : {}}>
                <Divider />
                <Box className={classes.commentCloseIconWrapper}>
                  <IconButton onClick={handleCommentClose}>
                    <CloseRoundedIcon fontSize="small" />
                  </IconButton>
                </Box>
                <Box className={classes.pollCommentsWrapper}>
                  {getCommentsListUI()}
                </Box>
                <Popover
                  id={commentId}
                  open={openCommentPopover}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "center",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "center",
                    horizontal: "right",
                  }}
                  classes={{
                    paper: classes.popOverPaper,
                  }}
                >
                  <StyledMenuItem
                    data-test-id="reply"
                    onClick={() => {
                      handleClose();
                      handleReplyClick(selectedCommentId, replyingToName);
                    }}
                  >
                    <ListItemText primary="Reply" />
                  </StyledMenuItem>
                  <CustomConditionalRender isRender={isSelfPost()}>
                    <>
                    <StyledMenuItem
                      data-test-id="archive"
                      disabled={
                        selectedCommentId === null ||
                        archivedStatus[selectedCommentId]
                      }
                      onClick={() => {
                        const values = {
                          archives: {
                            archiveable_id: selectedCommentId,
                            archiveable_type: "BxBlockComments::Comment",
                          },
                        };
                        archiveCommentApiCall(values);
                        handleArchiveComment();
                        handleClose();
                      }}
                    >
                      <ListItemText primary="Archive" />
                    </StyledMenuItem>
                    <StyledMenuItem
                      data-test-id="revertArchive"
                      disabled={
                        Boolean(selectedCommentId &&
                        !archivedStatus[selectedCommentId])
                      }
                      onClick={() => {
                        const values = {
                          archives: {
                            archiveable_id: selectedCommentId,
                            archiveable_type: "BxBlockComments::Comment",
                          },
                        };
                        revertArchiveCommentApiCall(values);
                        handleRevertArchive();
                        handleClose();
                      }}
                    >
                      <ListItemText primary="Revert archive" />
                    </StyledMenuItem>
                    </>
                  </CustomConditionalRender>
                  <CustomConditionalRender isRender={isSelfComment()}>
                    <StyledMenuItem
                      data-test-id="delete"
                      onClick={() => {
                        deleteCommentApiCall(selectedCommentId, postInfo.id);
                        handleClose();
                      }}
                    >
                      <ListItemText primary="Delete" />
                    </StyledMenuItem>
                  </CustomConditionalRender>
                  <CustomConditionalRender isRender={!isSelfComment()}>
                    <StyledMenuItem
                      data-test-id="banUserOfComment"
                      onClick={(event) => {
                        openEndWaitlistModalS(event);
                        handleClose();
                      }}
                    >
                      <ListItemText primary="Ban user" />
                    </StyledMenuItem>
                  </CustomConditionalRender>
                </Popover>
              </Box>
            ) : (
              <Box className={classes.commentsContentWrapper}>
                <Divider />
                <Box className={classes.commentCloseIconWrapper}>
                  <IconButton onClick={handleCommentClose}>
                    <CloseRoundedIcon fontSize="small" />
                  </IconButton>
                </Box>
                <Box className={classes.pollCommentsWrapper}>
                  {getCommentsListUI()}
                  {(!hasComments && !hasPollComments) && (
                    <Box 
                      style={{ 
                        textAlign: 'center', 
                        padding: '20px 20px',
                        color: '#666',
                        fontSize: '16px'
                      }}
                    >
                      <Typography variant="body1" style={{ color: '#999', fontSize: '14px' }}>
                        No comments yet
                      </Typography>
                      <Typography variant="body2" style={{ color: '#ccc', fontSize: '12px', marginTop: '8px' }}>
                        Be the first to comment!
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            )}
        </CustomLoader>
        <Box style={{ 
          flexShrink: 0, 
          padding: '12px 16px',
          borderTop: '1px solid #E2E8F0',
          backgroundColor: '#fff'
        }}>
          {commentImage && (
            <Box paddingX={1} style={{ marginBottom: '8px' }}>
              <Box className={classes.commentImagePreviewWrapper}>
                <IconButton
                  size="small"
                  data-test-id="image-comment-remove"
                  onClick={handleImageCommentRemove}
                >
                  <CloseRoundedIcon fontSize="small" />
                </IconButton>
                <img
                  src={URL.createObjectURL(commentImage)}
                  alt="Image"
                  data-test-id="comment-image-selected"
                  className={classes.commentImage}
                />
              </Box>
            </Box>
          )}
          <Box
            alignItems="center"
            className={classes.postCommentRoot}
            style={{ margin: 0, padding: 0 }}
          >
            <Box>
              <IconButton
                style={{paddingLeft: "8px"}}
                data-test-id="image-comment-upload"
                aria-label="add emoji"
                onClick={handleImageCommentClick}
              >
                <img
                  src={uploadIcon}
                  alt="uploadIcon"
                />
                <input
                  ref={imageInputRef}
                  accept=".jpeg, .jpg, .png"
                  type="file"
                  hidden
                  data-test-id="image-comment-file"
                  capture={isMobile ? "environment" : undefined}
                  onChange={handleImageCommentUpload}
                />
                <input
                  ref={videoInputRef}
                  accept="video/*,.mp4,.mpeg,.mov,.avi,.mkv,.webm,.3gp,.flv"
                  type="file"
                  hidden
                  data-test-id="video-comment-file"
                  capture={isMobile ? "environment" : undefined}
                  onChange={handleVideoCommentUpload}
                />
              </IconButton>
            </Box>
            <Box className={classes.commentInputBox}>
              <Box>
                <TextField
                  data-test-id="commentField"
                  placeholder={ternaryCondition(replyingToID, `Replying to ${replyingToName}`, "Add a Comment")}
                  inputRef={commentRef}
                  onBlur={handleCommentOnBlur}
                  variant="outlined"
                  value={comment}
                  fullWidth
                  multiline
                  maxRows={6}
                  minRows={1}
                  name="comment"
                  onChange={(e) => setComment(e.target.value)}
                  InputProps={{
                    classes: {
                      root: classes.postCommentTextField,
                      input: classes.postCommentinput,
                    },
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.placeholder,
                    },
                  }}
                />
              </Box>
            </Box>
            <Box className={classes.uploadFileBox}>
            </Box>
            <Box className={clsx("iconStyle", classes.postCommentBox)}>
              <IconButton
                size="small"
                disabled={Boolean(checkAndCondition(!comment, !commentImage))}
                data-test-id="postCommentApiCall"
                onClick={() => replyingToID ? handleSendClick(
                    false,
                    comment,
                    setViewReplies
                  ) : handleCommentToPost()}
                >
                <img
                  src={sendMedssageIcon}
                  alt="sendIcon"
                />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </div>)
  }

  const handleDotClick = (index: number) => {
    if (isMountedRef.current) {
      try {
        if (swiperInstance && typeof swiperInstance.slideTo === 'function') {
          swiperInstance.slideTo(index);
        }
        if (swiperInstanceHome && typeof swiperInstanceHome.slideTo === 'function') {
          swiperInstanceHome.slideTo(index);
        }
        setCurrentSlide(index);
      } catch (e) {
        // Swiper instance might be destroyed
      }
    }
  };
  
  const videoRefMobile = useRef<HTMLVideoElement | null>(null);
  const [progress, setProgress] = useState(0);
  const [showVideoControls, setShowVideoControls] = useState(false);
  const [isVideoPaused, setIsVideoPaused] = useState(false);
  const [showPlayButton, setShowPlayButton] = useState(true);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(true);

  // Instagram Reels-style sound state for the mobile inline autoplay video. Mirrors the
  // module-level mobileFeedMuted/mobileFeedAudioUnlocked (shared across every Post instance,
  // just like EuDashboard's single globalMuted/audio-unlock covers its whole feed) - local
  // state here only exists to trigger a re-render of THIS post's icon when the shared value changes.
  const [isMobileMuted, setIsMobileMuted] = useState(mobileFeedMuted);
  // Brief center-of-video flash icon on toggle, same as EuDashboard's soundFlashIndex/showSoundFlash
  const [mobileSoundFlash, setMobileSoundFlash] = useState(false);
  const mobileSoundFlashTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const onMuteChange = (muted: boolean) => setIsMobileMuted(muted);
    mobileFeedMuteListeners.add(onMuteChange);
    return () => { mobileFeedMuteListeners.delete(onMuteChange); };
  }, []);

  const showMobileSoundFlash = () => {
    if (mobileSoundFlashTimerRef.current) clearTimeout(mobileSoundFlashTimerRef.current);
    setMobileSoundFlash(true);
    mobileSoundFlashTimerRef.current = setTimeout(() => setMobileSoundFlash(false), 600);
  };

  // NOTE: there used to be an ambient "unlock audio on first touch anywhere on the page"
  // listener here. It silently unmuted whichever video was in view on the user's very first
  // touch (scroll, like-tap, anything not on the mute control), which flipped mobileFeedMuted
  // to false before the user ever deliberately tapped the video. Their first deliberate tap
  // then read a stale "already unmuted" state and toggled it back to muted - so the first tap
  // appeared to mute instead of unmute. Removed so the shared mute preference only ever
  // changes from the explicit toggle below - first tap always unmutes, second mutes, etc.

  // Once this post is in view and audio has already been unlocked (the user explicitly
  // unmuted a different post earlier), pick up sound automatically - matches Instagram
  // Reels, where scrolling to the next reel keeps playing with sound.
  useEffect(() => {
    if (!inView || !mobileFeedAudioUnlocked || mobileFeedMuted) return;
    const video = videoRefMobile.current;
    if (!video) return;
    video.muted = false;
    video.volume = 1.0;
    video.play().catch(() => {});
  }, [inView]);

  // Same as EuDashboard's toggleVideoSound - just flips muted/volume on the video element
  // directly (no play() call), then flashes the icon. This is a single shared preference
  // (mobileFeedMuted), not per-video, so toggling it applies to every post's video as it
  // scrolls into view, same as EuDashboard's single globalMuted covers its whole feed.
  const toggleMobileSound = () => {
    const video = videoRefMobile.current;
    if (!video) return;

    const newMuted = !mobileFeedMuted;
    video.muted = newMuted;
    if (!newMuted) {
      video.volume = 1;
      mobileFeedAudioUnlocked = true;
    }
    setMobileFeedMuted(newMuted);
    showMobileSoundFlash();
  };

  // Initialize video state when component mounts
  useEffect(() => {
    if (videoRefMobile.current) {
      // Set initial state based on video
      setIsVideoPlaying(!videoRefMobile.current.paused);
      setShowPlayButton(videoRefMobile.current.paused);
    }
  }, []);

  const togglePlayPause = async () => {
    if (videoRefMobile.current) {
      if (videoRefMobile.current.paused) {
        try {
          videoRefMobile.current.muted = false;
          videoRefMobile.current.volume = 1.0;
          await videoRefMobile.current.play();
          setIsVideoPaused(false);
          setIsVideoPlaying(true);
          setShowVideoControls(false);
          setShowPlayButton(false);
        } catch (error) {
          console.log('Video play failed, trying with muted first:', error);
          try {
            videoRefMobile.current.muted = true;
            await videoRefMobile.current.play();
            videoRefMobile.current.muted = false;
            videoRefMobile.current.volume = 1.0;
            setIsVideoPaused(false);
            setIsVideoPlaying(true);
            setShowVideoControls(false);
            setShowPlayButton(false);
          } catch (mutedError) {
            console.error('Video play failed even with muted:', mutedError);
          }
        }
      } else {
        videoRefMobile.current.pause();
        setIsVideoPaused(true);
        setIsVideoPlaying(false);
        setShowVideoControls(true);
        setShowPlayButton(true);
      }
    }
  };

  const skipForward = () => {
    if (videoRefMobile.current) {
      videoRefMobile.current.currentTime = Math.min(
        videoRefMobile.current.currentTime + 10,
        videoRefMobile.current.duration
      );
    }
  };

  const skipBackward = () => {
    if (videoRefMobile.current) {
      videoRefMobile.current.currentTime = Math.max(
        videoRefMobile.current.currentTime - 10,
        0
      );
    }
  };

  const playVideo = async () => {
    if (videoRefMobile.current) {
      try {
        // Enable audio for mobile devices
        videoRefMobile.current.muted = false;
        videoRefMobile.current.volume = 1.0;
        
        // Play video with audio
        await videoRefMobile.current.play();
        setIsVideoPaused(false);
        setIsVideoPlaying(true);
        setShowVideoControls(false);
        setShowPlayButton(false);
      } catch (error) {
        console.log('Video play failed, trying with muted first:', error);
        // If play fails, try muted first (mobile requirement)
        try {
          videoRefMobile.current.muted = true;
          await videoRefMobile.current.play();
          // Unmute after successful play
          videoRefMobile.current.muted = false;
          videoRefMobile.current.volume = 1.0;
          setIsVideoPaused(false);
          setIsVideoPlaying(true);
          setShowVideoControls(false);
          setShowPlayButton(false);
        } catch (mutedError) {
          console.error('Video play failed even with muted:', mutedError);
        }
      }
    }
  };

  // Instagram-style tap to play/pause
  const handleVideoTap = () => {
    togglePlayPause();
  };

  const handleProgressClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (videoRefMobile.current) {
      const progressBar = e.currentTarget;
      const rect = progressBar.getBoundingClientRect();
      const clickPosition = e.clientX - rect.left;
      const newTime = (clickPosition / rect.width) * videoRefMobile.current.duration;
      videoRefMobile.current.currentTime = newTime;
    }
  };

  const handleTimeUpdate = () => {
    if (videoRefMobile.current) {
      const currentTime = videoRefMobile.current.currentTime;
      const duration = videoRefMobile.current.duration;
      setProgress((currentTime / duration) * 100);
    }
  };

  const handleVideoPlay = () => {
    setIsVideoPlaying(true);
    setIsVideoPaused(false);
    setShowPlayButton(false);
    setShowVideoControls(false);
  };

  const handleVideoPause = () => {
    setIsVideoPlaying(false);
    setIsVideoPaused(true);
    setShowPlayButton(true);
    setShowVideoControls(true);
  };

  const handleVideoEnded = () => {
    setIsVideoPlaying(false);
    setIsVideoPaused(true);
    setShowPlayButton(true);
    setShowVideoControls(false);
  };

  const renderVideoPregressBar = () => {
    return (
        <div className="progressBarOuterContainer">
          <div className="progressBar" onClick={handleProgressClick}>
            <div className="playedPart" style={{width: `${progress}%`}}></div>
            <div className="unplayedPart" style={{left: `calc(${progress}% - 4px)`}}></div>
          </div>
        </div>
    )
  }

  // Instagram-style play button overlay
  const renderInstagramPlayButton = () => {
    if (!showPlayButton) return null;
    
    return (
      <Box
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
          transition: 'all 0.3s ease',
          zIndex: 10,
        }}
        onClick={handleVideoTap}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 1)';
          e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
          e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1)';
        }}
      >
        <Box
          style={{
            width: 0,
            height: 0,
            borderLeft: '24px solid #000',
            borderTop: '16px solid transparent',
            borderBottom: '16px solid transparent',
            marginLeft: '4px',
          }}
        />
      </Box>
    );
  };

  const renderVideoControls = () => {
    if (!showVideoControls || showPlayButton) return null;
    
    return (
      <div className="videoControlsOverlay" style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        padding: '10px 20px',
        borderRadius: '25px',
        zIndex: 1000
      }}>
        <button 
          onClick={skipBackward}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            fontSize: '16px',
            cursor: 'pointer',
            padding: '5px'
          }}
        >
          ⏪ 10s
        </button>
        {/* Removed the play button - using Instagram-style button instead */}
        <button 
          onClick={skipForward}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            fontSize: '16px',
            cursor: 'pointer',
            padding: '5px'
          }}
        >
          10s ⏩
        </button>
      </div>
    )
  }

  const open = Boolean(anchorEll);
  const id = commonFunctionForCondition(open, "simple-popover", "")

  const openCommentPopover = Boolean(anchorEl);
  const commentId = commonFunctionForCondition(openCommentPopover, "simple-popover", "")
  const {
    attributes: {
      account,
      account_id,
      account_profile,
      body,
      created_at,
      comments,
      comments_count,
      files,
      is_liked,
      likes_count,
      model_name,
      reviews,
      poll,
      poll_options
    }
  } = postInfo
  const {
    first_name,
    last_name,
    followers,
    business_name
  } = account
  

  // Initialize and sync local poll state from postInfo
  // Post polls (from postInfo) are polls created with the post, not comment polls
  React.useEffect(() => {
    if (poll && poll.id) {
      // Check if poll was created with the post (post poll) or added later (comment poll)
      // If poll.created_at is close to post created_at (within 5 seconds), it's a post poll
      const pollCreatedAt = new Date(poll.created_at).getTime();
      const postCreatedAt = new Date(created_at).getTime();
      const timeDifference = Math.abs(pollCreatedAt - postCreatedAt);
      const isPostPoll = timeDifference < 5000; // 5 seconds threshold
      
      // If it's a post poll, set it and mark as not a comment poll
      if (isPostPoll && !isCommentPoll) {
        setLocalPoll(poll)
        setIsCommentPoll(false) // Post poll, not a comment poll
      } else if (!isPostPoll && !isCommentPoll) {
        // If poll was created later, it might be a comment poll
        // But if we haven't explicitly set it as a comment poll, treat it as post poll for now
        setLocalPoll(poll)
        setIsCommentPoll(false)
      }
    } else if (!poll) {
      // If poll is removed from postInfo, reset to post poll state
      if (!isCommentPoll) {
        setLocalPoll(null)
        setLocalPollOptions([])
      }
    }
    if (poll_options && poll_options.length > 0) {
      // Only set localPollOptions if it's not already set as a comment poll
      if (!isCommentPoll) {
        setLocalPollOptions(poll_options)
      }
    } else if (!poll_options || poll_options.length === 0) {
      // If poll_options is empty and not a comment poll, clear it
      if (!isCommentPoll) {
        setLocalPollOptions([])
      }
    }
  }, [poll, poll_options, isCommentPoll, created_at])

  // Find and highlight the most recent comment from notification creator
  useEffect(() => {
    if (autoExpandComments && comments && comments.data && comments.data.length > 0) {
      // If we have a specific comment ID, use it
      if (highlightedCommentId && typeof highlightedCommentId === 'string') {
        const foundComment = comments.data.find((comment: any) => comment.id === highlightedCommentId);
        if (foundComment) {
          setHighlightedComment(highlightedCommentId);
          // Remove highlight after 2.5 seconds
          const timer = setTimeout(() => {
            setHighlightedComment(null);
          }, 2500);
          return () => clearTimeout(timer);
        }
      }
      
      // If we have notification data, find the most recent comment from the notification creator
      if (notificationData && notificationData.attributes && !highlightedComment) {
        const notificationCreatorId = notificationData.attributes.created_by?.data?.id;
        if (notificationCreatorId) {
          // Find the most recent comment from the notification creator
          const creatorComments = comments.data.filter((comment: any) => 
            comment.attributes.account?.data?.id === notificationCreatorId
          );
          
          if (creatorComments.length > 0) {
            // Sort by created_at to get the most recent
            const mostRecentCreatorComment = creatorComments.sort((a: any, b: any) => 
              new Date(b.attributes.created_at).getTime() - new Date(a.attributes.created_at).getTime()
            )[0];
            
            setHighlightedComment(mostRecentCreatorComment.id);
            // Remove highlight after 2.5 seconds
            const timer = setTimeout(() => {
              setHighlightedComment(null);
            }, 2500);
            return () => clearTimeout(timer);
          }
        }
      }
      
      // If no specific comment ID and no notification data, highlight the most recent comment
      if (!highlightedComment && !notificationData) {
        const mostRecentComment = comments.data[0]; // Comments are usually sorted by newest first
        if (mostRecentComment) {
          setHighlightedComment(mostRecentComment.id);
          // Remove highlight after 2.5 seconds
          const timer = setTimeout(() => {
            setHighlightedComment(null);
          }, 2500);
          return () => clearTimeout(timer);
        }
      }
    }
  }, [autoExpandComments, comments, highlightedCommentId, highlightedComment, notificationData]);

  // Cleanup on unmount
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Safe state setter
  const safeSetIsPostHidden = (value: boolean) => {
    if (isMountedRef.current) {
      setIsPostHidden(value);
    }
  };

  return (
    <div ref={ref}>
      <MobileViewPostViewRender>
        <Box 
          className="videoImageContainer"
          style={{
            backgroundColor: isPostHidden ? "#E2E8F0" : "transparent",
            opacity: isPostHidden ? 0.6 : 1,
            pointerEvents: isPostHidden ? "none" : "auto",
          }}
        >
          <Box 
            className="imageVideoContainer" 
            style={{ 
              position: 'relative', 
              zIndex: 1,
            }}
          >
            <Swiper
              key={previewModalId ? previewModalId : 0}
              onSwiper={(swiper) => {
                if (isMountedRef.current && swiper) {
                  setSwiperInstance(swiper);
                }
              }}
              initialSlide={currentSlide}
              slidesPerView={1}
              spaceBetween={0}
              onSlideChange={(swiper) => {
                if (isMountedRef.current && swiper) {
                  setCurrentSlide(swiper.activeIndex);
                  // Reset loading state when slide changes to show loader for new video
                  setIsVideoLoading(true);
                }
              }}
              grabCursor={!isPostHidden}
              watchSlidesProgress={true}
              observer={true}
              observeParents={true}
              allowTouchMove={!isPostHidden}
              style={{ width: "100%", overflow: "hidden" }}
            >
              {files?.map((file, index) => (
                <SwiperSlide key={index} style={{ width: "100%" }}>
                  {(isImage(file.link) || file.link_content_type?.includes("image")) ? (
                    <Box data-test-id="imagePreview" className="mediaContainer">
                      <img
                        ref={(el) => {
                          if (el) {
                            const imageKey = `mobile-${postInfo.id}-${index}`;
                            // Only call handleImageLoad if not already processed
                            if (!processedImagesRef.current.has(imageKey)) {
                              handleImageLoad(el, imageKey);
                            }
                          }
                        }}
                        src={file.link}
                        alt={`Slide ${index}`}
                        style={{
                          border: 'none',
                          objectFit: imageResizeModes.get(`mobile-${postInfo.id}-${index}`) || 'contain',
                          width: '100%',
                          height: '100%',
                          outline: 'none',
                          boxShadow: 'none',
                          background: 'transparent',
                        }}
                      />
                    </Box>
                  ) : (
                    <Box data-test-id="videoPreview" className="mediaContainer" style={{ position: 'relative', width: '100%', height: '100%' }}>
                        <video
                          // ref={(el) => {
                          //   if (el) {
                          //     videoRefMobile.current = el;
                          //     const videoKey = `mobile-${postInfo.id}`;
                          //     if (!processedVideosRef.current.has(videoKey)) {
                          //       handleVideoLoad(el, videoKey);
                          //     }
                          //   }
                          // }}
                          // ref={(el) => { if (el) videoRefMobile.current = el; }}
                          ref={(el) => {
                            if (el) {
                              videoRefMobile.current = el;
                              const videoKey = `mobile-${postInfo.id}`;
                              if (!processedVideosRef.current.has(videoKey)) {
                                handleVideoLoad(el, videoKey);
                              }
                            }
                          }}
                          // swiper-no-swiping so tapping to toggle sound isn't swallowed by Swiper
                          className="swiper-no-swiping"
                          data-mute-control="true"
                          loop
                          controls={false}
                          autoPlay
                          muted   // IMPORTANT — required for autoPlay to be allowed at all; unmuted via JS after the user interacts
                          preload="auto"
                          playsInline
                          webkit-playsinline="true"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: videoResizeModes.get(`mobile-${postInfo.id}`) || 'contain',
                            backgroundColor: '#000',
                            cursor: 'pointer'
                          }}
                          // Tap anywhere on the video to toggle sound, same as EuDashboard's
                          // handleFileRender: onClick={() => this.toggleVideoSound(index)}
                          onClick={() => { toggleMobileSound(); }}
                          onTimeUpdate={handleTimeUpdate}
                          onPlay={handleVideoPlay}
                          onPause={handleVideoPause}
                          onEnded={handleVideoEnded}
                          onLoadStart={() => setIsVideoLoading(true)}
                          onCanPlay={() => setIsVideoLoading(false)}
                          onLoadedData={() => setIsVideoLoading(false)}
                          onWaiting={() => setIsVideoLoading(true)}
                          onPlaying={() => setIsVideoLoading(false)}
                        >
                          <source src={file.link} type="video/mp4" />
                        </video>

                    {/* Instagram-style loader overlay */}
                    {isVideoLoading && (
                      <Box
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'rgba(0, 0, 0, 0.3)',
                          zIndex: 10,
                        }}
                      >
                        <CircularProgress
                          style={{
                            color: '#fff',
                            width: '48px',
                            height: '48px',
                          }}
                        />
                      </Box>
                    )}

                    {/* Instagram-style play button overlay */}
                    {/* {renderInstagramPlayButton()} */}
                    {renderVideoPregressBar()}
                    {/* {renderVideoControls()} */}

                    {/* FLASH - same as EuDashboard's soundFlashOverlay/soundFlashBadge */}
                    {mobileSoundFlash && (
                      <div
                        style={{
                          position: 'absolute',
                          inset: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          zIndex: 10,
                          pointerEvents: 'none',
                          animation: 'soundFlashFade 0.6s ease-out forwards',
                        }}
                      >
                        <div
                          style={{
                            width: '80px',
                            height: '80px',
                            backgroundColor: 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '999px',
                            border: '1px solid #fff',
                          }}
                        >
                          {isMobileMuted ? (
                            <VolumeOffRoundedIcon style={{ fontSize: '40px', lineHeight: 1, color: '#fff' }} />
                          ) : (
                            <VolumeUpRoundedIcon style={{ fontSize: '40px', lineHeight: 1, color: '#fff' }} />
                          )}
                        </div>
                      </div>
                    )}

                    {/* MUTE BUTTON - same as EuDashboard's muteToggleButton/muteToggleIcon */}
                    <button
                      type="button"
                      // swiper-no-swiping is Swiper's built-in exclusion class: Swiper ignores
                      // touches that start on an element with this class entirely, so this
                      // button behaves like a plain button (same as EuDashboard's onClick-only
                      // mute button, which isn't inside a Swiper at all) instead of fighting
                      // Swiper's own touch/click handling.
                      className="swiper-no-swiping"
                      data-mute-control="true"
                      aria-label={isMobileMuted ? "Unmute video" : "Mute video"}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleMobileSound();
                      }}
                      style={{
                        position: 'absolute',
                        left: '10px',
                        bottom: '67px',
                        zIndex: 12,
                        width: '30px',
                        height: '30px',
                        border: 'none',
                        background: 'transparent',
                        backgroundColor: 'transparent',
                        color: '#fff',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 0,
                        touchAction: 'manipulation',
                      }}
                    >
                      {isMobileMuted ? (
                        <VolumeOffRoundedIcon style={{ color: '#fff', fontSize: '20px' }} />
                      ) : (
                        <VolumeUpRoundedIcon style={{ color: '#fff', fontSize: '20px' }} />
                      )}
                    </button>
                    </Box>
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
          
          {/* Overlay Container - Unified parent for Poll and Action Bar (Mobile) */}
          <Box
            style={{
              // position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              top: 0,
              zIndex: 10, // Above media layer
              pointerEvents: 'auto', // Transparent container - allows clicks to pass through
              backgroundColor: 'red'
            }}
          >
            {/* Display post poll as overlay on media (like Instagram stories) - Mobile */}
            {!isCommentPoll && (poll || localPoll) && (poll?.id || localPoll?.id) && (
              <Box 
                style={{
                  position: 'absolute',
                  bottom: '115px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: 12, // Poll layer - lower than action bar
                  width: 'fit-content', // Only as wide as content
                  maxWidth: '90%', // Constrain max width
                  pointerEvents: 'auto', // Transparent overlay - allows clicks to pass through
                  display: 'inline-flex', // Inline to prevent full-width expansion
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: 'auto',
                }}
              >
                {/* Only this inner box captures pointer events - the actual poll content */}
                <Box 
                  style={{
                    pointerEvents: 'auto', // Poll content captures clicks
                    width: 'fit-content',
                    maxWidth: '400px',
                    position: 'relative',
                  }}
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={(e) => e.stopPropagation()}
                >
                  <Poll 
                    poll={localPoll || poll} 
                    poll_options={(localPollOptions && localPollOptions.length > 0) ? localPollOptions : (poll_options || [])} 
                    accountProfile={account_profile?.url} 
                    handleVote={(optionId : number) => handleVote(optionId, postInfo.id)} 
                    handleDeleteVote={(optionId : number) => handleDeleteVote(optionId, postInfo.id)}
                  />
                </Box>
              </Box>
            )}
            
            {/* Action Bar - Mobile */}
            <Box className="postInfoContainer">
            {returnProfileLikeCommentBodyUI()}
            {(() => {
              const postType = postInfo.type?.toLowerCase() || "";
              const postModelName = model_name?.toLowerCase() || "";
              
              // Check if this is a Brandly/Everyreel post
              const isBrandly = postType === "everyreel" || 
                               postType.includes("everyreel") ||
                               postType.includes("brandly") ||
                               postType === "social_scroll" ||
                               postType === "funnel" ||
                               postModelName.includes("everyreel") || 
                               postModelName.includes("brandly") ||
                               postModelName.includes("social_scroll") ||
                               postModelName.includes("funnel");
              
              // Debug log to help identify the correct condition
              // console.log("Post Brandly check:", {
              //   postId: postInfo.id,
              //   type: postInfo.type,
              //   model_name: model_name,
              //   isBrandly: isBrandly
              // });
              
              return isBrandly;
            })() && (
              <div className="tradmard">
                <p>Powered by</p>
                <img src={logoEverybrand} alt="" />
              </div>
            )}
          </Box>
          </Box>
          {/* End Overlay Container - Mobile */}
        </Box>
        <Box className="commentSection">
          {postPreviewComment && getCommentsUI()}
        </Box>
      </MobileViewPostViewRender>

      <DesktopViewPostRender>
        <Paper
          square
          elevation={0}
          data-test-id="post-section"
          className={classes.post}
          onClick={isPostHidden ? (e) => {
            // Allow clicks on three-dot menu even when post is hidden
            const target = e.target as HTMLElement;
            if (!target.closest('[data-test-id="threeDotIcon"]') && 
                !target.closest('[class*="postSettingsBtn"]') &&
                !target.closest('[id*="simple-popover"]')) {
              e.stopPropagation();
            }
          } : closeCommentSection}
          style={{
            // backgroundColor: handleOrConditions(
            //   isPostHidden, 
            //   "#E2E8F0", 
            //   handleOrConditions(highlighted, "#fff2d2", "none")
            // ),
            backgroundColor: isPostHidden
            ? "#E2E8F0"       // hidden → grey
            : highlighted
              ? "#fff2d2"     // highlighted → yellow
              : "#FFFFFF", // default
            opacity: isPostHidden ? 0.6 : 1,
          }}
        >
          <Snackbar
            open={Boolean(toastType)}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MuiAlert onClose={handleCloseSnackbar} severity={toastType}>
              {toastMessage}
            </MuiAlert>
          </Snackbar>
          <Snackbar
            open={showAlert}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MuiAlert
              elevation={6}
              variant="filled"
              severity={handleOrConditions(errorAlertMessage, "error", "success")}
            >
              {showSuccess}
            </MuiAlert>
          </Snackbar>
          <Box className={classes.postDataContainer}>
            <div className={classes.cardHeader}>
              <Avatar
                className={classes.avatar}
                data-test-id="post-profile-wrapper"
                onClick={(event) => { 
                  if (isPostHidden) {
                    event.stopPropagation();
                    return;
                  }
                  event.stopPropagation(); 
                  handlePostProfileClick(account_id) 
                }}
                style={{
                  pointerEvents: isPostHidden ? "none" : "auto",
                  cursor: isPostHidden ? "not-allowed" : "pointer",
                }}
              >
                {/* {console.log("RESUlt----->>>", account_id)} */}
                <img
                  src={account_profile?.url && account_profile.url.trim() !== '' ? account_profile.url : IconAvtar}
                  className={classes.fallbackAvatar}
                  onError={(e) => {
                    // If image fails to load, show fallback avatar
                    const target = e.target as HTMLImageElement;
                    if (target.src !== IconAvtar) {
                      target.src = IconAvtar;
                    }
                  }}
                />
              </Avatar>
              <div className={classes.cardHeaderContent} style={{marginLeft:"10px"}}>
                <div className={classes.cardTitleWrapper}>
                  <Typography
                    component="span"
                    data-test-id="post-user-name"
                    className={clsx(classes.fontBold, classes.darkText)}
                  >
                    {business_name}
                  </Typography>
                  <Typography
                    component="span"
                    className={clsx(classes.fontBold, classes.lightText)}
                  >
                    @everybrand
                  </Typography>
                  {commonFunctionForCondition(
                    created_at,
                    <div>
                      <FiberManualRecordIcon className={classes.bullet} />
                      <Typography
                        component="span"
                        className={clsx(classes.fontBold, (wWidth >= 500 ?  classes.lightText : ""))}
                      >
                        {created_at}
                      </Typography>
                    </div>,
                    null
                  )}
                </div>
                <Typography variant="subtitle2" className={classes.followersText}>
                  {`${getValue(followers)} Followers`}
                </Typography>
              </div>
            </div>
            <div className={classes.cardContent}>
              <Typography className={classes.content}>{body}</Typography>
            </div>
            <div className={classes.cardActions}>
              <div className={classes.reactionBtn}>
                {is_liked ? (
                  <IconButton 
                    onClick={(event) => { 
                      if (isPostHidden) {
                        event.stopPropagation();
                        return;
                      }
                      event.stopPropagation(); 
                      handleUndoLikeAPICall(postInfo.id, "Post")
                    }}
                    style={{
                      pointerEvents: isPostHidden ? "none" : "auto",
                      cursor: isPostHidden ? "not-allowed" : "pointer",
                    }}
                  >
                    <img alt="liked" src={redHeart} />
                  </IconButton>
                ) : (
                  <IconButton
                    aria-label="post-likes"
                    data-test-id="post-like-box"
                    onClick={(event) => { 
                      if (isPostHidden) {
                        event.stopPropagation();
                        return;
                      }
                      event.stopPropagation(); 
                      handleLikePostAPICall(postInfo, "Post")
                    }}
                    style={{
                      pointerEvents: isPostHidden ? "none" : "auto",
                      cursor: isPostHidden ? "not-allowed" : "pointer",
                    }}
                  >
                    <img src={HeartSmallIcon} alt="like" />
                  </IconButton>
                )}
                <Typography
                  component="span"
                  variant="body2"
                  className={classes.likesComments}
                >
                  {getValue(likes_count)}
                </Typography>
              </div>
              <div
                data-test-id="openCommentButton"
                className={classes.reactionBtn}
                onClick={(event) => {
                  if (isPostHidden) {
                    event.stopPropagation();
                    return;
                  }
                  postCommentFlag(event, postInfo);
                }}
                style={{
                  pointerEvents: isPostHidden ? "none" : "auto",
                  cursor: isPostHidden ? "not-allowed" : "pointer",
                }}
              >
                <IconButton aria-label="post-comments">
                  <img
                    src={CommentIcon}
                    alt="Comment"
                    className={classes.commentIcon}
                  />
                </IconButton>
                <Typography
                  component="span"
                  variant="body2"
                  data-test-id="commentCount"
                  className={classes.likesComments}
                >
                  {getValue(comments_count)}
                </Typography>
              </div>
            </div>
          </Box>
          <Box className={classes.mediaContainer} style={{ position: 'relative' }}>
    <Swiper
      key={previewModalId ? previewModalId : 0}
      onSwiper={(swiper) => {
        if (isMountedRef.current && swiper) {
          setSwiperInstanceHome(swiper);
        }
      }}
      initialSlide={currentSlide}
      slidesPerView={1}
      spaceBetween={10}
      onSlideChange={(swiper) => {
        if (isMountedRef.current && swiper) {
          setCurrentSlide(swiper.activeIndex);
        }
      }}
      style={{ height: '100%' }}
      grabCursor={!isPostHidden}
      allowTouchMove={!isPostHidden}
      watchSlidesProgress
      observer
      observeParents
    >
      {files?.map((file, index) => (
        <SwiperSlide key={index}>
          {file.link_content_type.includes("video") ? (
            <Box
              data-test-id="videoPreview"
              className={classes.postMediaContainer}
              onClick={() => {
                if (isPostHidden) return;
                const currentIndex = allPosts?.findIndex(p => p.id === postInfo.id) || 0;
                handlePreviewModalOpen(files, currentIndex);
              }}
              style={{
                pointerEvents: isPostHidden ? "none" : "auto",
                cursor: isPostHidden ? "not-allowed" : "pointer",
              }}
            >
               <video
  ref={(el) => {
    if (el) {
      const videoKey = `desktop-${postInfo.id}-${index}`;
      desktopVideoRefs.current.set(videoKey, el);

      // HARD STOP – never let desktop videos play
      el.pause();
      el.currentTime = 0;
      el.muted = true;
      el.volume = 0;
      el.autoplay = false;
      el.playsInline = true;
      el.removeAttribute('autoplay');
      el.setAttribute('data-desktop-feed', 'true');

      // Only process orientation once
      if (!processedVideosRef.current.has(videoKey)) {
        handleVideoLoad(el, videoKey);
      }
    }
  }}
  src={file.link}
  autoPlay={false}
  muted={true}
  playsInline
  // controls={false}
  preload="metadata"
  width="100%"
  height="auto"
  poster={file.gif_link}
  style={{
    objectFit: 
      videoResizeModes.get(`desktop-${postInfo.id}-${index}`) || "cover",
    borderRadius: 8,
    pointerEvents: 'auto',
  }}
  onClick={(e) => {
    // Prevent default video behavior but allow click to bubble to parent Box to open modal
    e.preventDefault();
    // Don't stop propagation - let it bubble to parent Box which opens the modal
    const v = e.currentTarget;
    v.pause();
    v.currentTime = 0;
  }}

  // 🔒 HARD STOP ON METADATA LOAD
  onLoadedMetadata={(e) => {
    const v = e.currentTarget;
    // v.pause();
    // v.currentTime = 0;
    v.muted = true;
    v.volume = 0;
    // v.removeAttribute('autoplay');
  }}

  // 🔒 HARD STOP ON DATA LOAD
  onLoadedData={(e) => {
    const v = e.currentTarget;
    v.pause();
    v.currentTime = 0;
    v.muted = true;
    v.volume = 0;
    v.removeAttribute('autoplay');
  }}

  // 🔒 HARD STOP WHEN VIDEO CAN PLAY
  onCanPlay={(e) => {
    const v = e.currentTarget;
    v.pause();
    v.currentTime = 0;
    v.muted = true;
    v.volume = 0;
    v.removeAttribute('autoplay');
  }}

  // ❌ NEVER allow desktop feed to play - catch play attempts
  onPlay={(e) => {
    const v = e.currentTarget;
    // FORCE STOP immediately
    v.pause();
    v.currentTime = 0;
    v.muted = true;
    v.volume = 0;
    v.removeAttribute('autoplay');
  }}

  // ❌ Additional safeguard - catch playing state
  onPlaying={(e) => {
    const v = e.currentTarget;
    // FORCE STOP if somehow it started playing
    v.pause();
    v.currentTime = 0;
    v.muted = true;
    v.volume = 0;
  }}

  // Ensure muted always
  onPause={(e) => {
    const v = e.currentTarget;
    v.muted = true;
    v.volume = 0;
  }}

  // Prevent any seek attempts that might trigger play
  onSeeking={(e) => {
    const v = e.currentTarget;
    if (!v.paused) {
      v.pause();
    }
  }}
/>
            </Box>
          ) : (
            <Box
              data-test-id="imagePreview"
              className={classes.postMediaContainer}
              onClick={() => {
                if (isPostHidden) return;
                const currentIndex = allPosts?.findIndex(p => p.id === postInfo.id) || 0;
                handlePreviewModalOpen(files, currentIndex);
              }}
              style={{
                pointerEvents: isPostHidden ? "none" : "auto",
                cursor: isPostHidden ? "not-allowed" : "pointer",
              }}
            >
              <img
                ref={(el) => {
                  if (el) {
                    const imageKey = `desktop-${postInfo.id}-${index}`;
                    // Only call handleImageLoad if not already processed
                    if (!processedImagesRef.current.has(imageKey)) {
                      handleImageLoad(el, imageKey);
                    }
                  }
                }}
                src={file.link}
                alt="post mediafile preview"
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: imageResizeModes.get(`desktop-${postInfo.id}-${index}`) || "cover",
                  borderRadius: 8,
                }}
              />
            </Box>
          )}
        </SwiperSlide>
      ))}
    </Swiper>
    {/* Display post poll as overlay on media (like Instagram stories) - Desktop */}
    {/* {!isCommentPoll && (poll || localPoll) && (poll?.id || localPoll?.id) && (
      <Box style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 15,
        width: '90%',
        maxWidth: '400px',
        pointerEvents: 'auto'
      }}>
        <Poll 
          poll={localPoll || poll} 
          poll_options={(localPollOptions && localPollOptions.length > 0) ? localPollOptions : (poll_options || [])} 
          accountProfile={account_profile?.url} 
          handleVote={(optionId : number) => handleVote(optionId, postInfo.id)} 
          handleDeleteVote={(optionId : number) => handleDeleteVote(optionId, postInfo.id)}
        />
      </Box>
    )} */}

    {files?.length > 1 && (
      <Box className={classes.paginateBox}>
        {files.map((_, index) => (
          <Box
            key={index}
            data-test-id={`swiper-pagination-home-${index + 1}`}
            onClick={() => handleDotClick(index)}
            className={classes.paginateDots}
            style={{
              background: currentSlide === index ? "white" : "gray",
              width: 6,
              height: 6,
            }}
          />
        ))}
      </Box>
    )}
  </Box>

  {/* OPTIONS (5%) */}
  <Box className={classes.optionsAndRatings}>
    {ratings(reviews) ? (
      <Box className={classes.ratingsBox}>
        <Rating
          name="read-only"
          value={ratings(reviews)}
          readOnly
          precision={0.1}
        />
        <Typography className={classes.ratingText}>
          {ratings(reviews).toFixed(1)}
        </Typography>
      </Box>
    ) : null}

    <div className={classes.cardHeaderAction}>
      <IconButton
        size="small"
        onClick={handleClickPopOver}
        data-test-id="threeDotIcon"
        aria-label="post-settings"
        className={classes.postSettingsBtn}
        style={{
          pointerEvents: "auto",
          // zIndex: 1000,
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEll}
        onClose={handleClosePopOver}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        classes={{
          paper: classes.popOverPaper,
        }}
      >
        {isSelfPost() ? (
          <StyledMenuItem
            data-test-id="desktop-deletePost"
            onClick={openDeletePostConfirmationModalS}
          >
            <ListItemText primary="Delete Post" />
          </StyledMenuItem>
        ) : (
          <>
            {isPostHidden ? (
              <StyledMenuItem
                data-test-id="desktop-unhidePost"
                onClick={(event) => {
                  event.stopPropagation();
                  safeSetIsPostHidden(false);
                  handleClosePopOver();
                }}
              >
                <ListItemText primary="Unhide Post" />
              </StyledMenuItem>
            ) : (
              <StyledMenuItem
                data-test-id="desktop-hidePost"
                onClick={openHideConfirmationModalS}
              >
                <ListItemText primary={configJSON.hidePostText} />
              </StyledMenuItem>
            )}
            <StyledMenuItem
              data-test-id="desktop-banUser"
              onClick={openEndWaitlistModalS}
            >
              <ListItemText primary="Ban User" />
            </StyledMenuItem>
          </>
        )}
      </Popover>
    </div>
  </Box>
        </Paper>
      </DesktopViewPostRender>


      <Modal
        open={endWaitlistModalS}
        onClose={openEndWaitlistModalS}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        data-test-id="templateEditModal"
      >
        <Box className={classes.EndWaitlistmodalBox}>
          <ResetModalTitle>
            Please select a reason
            <ClosePostConfirmButton
              data-test-id="closeEndModal"
              src={CloseIcon}
              alt=""
              onClick={openEndWaitlistModalS}
            />
          </ResetModalTitle>
          <Typography
            style={{
              fontSize: "16px",
              fontWeight: 700,
              fontFamily: "Inter",
              fontStyle: "normal",
            }}
          >
            Select a reason
          </Typography>

          <Box mb={4}>
            <Select
              options={options}
              data-test-id="selectReason"
              onChange={handleReasonChangeS}
              placeholder="Select a reason"
              dropdownGap={5} // Adds some gap between the dropdown and the selected option
              dropdownPosition="auto" // Positioning of the dropdown
              className={classes.reasonDropDown} // Custom class for styling the dropdown
              contentRenderer={({ props: _props, state }) => {
                const isSelected =
                  Array.isArray(state.values) && state.values.length > 0;

                return (
                  <div
                    className={
                      isSelected
                        ? classes.dropdownFonts
                        : classes.placeholderFonts
                    }
                  >
                    {isSelected ? state.values[0].label : "Select a reason"}
                  </div>
                );
              }}
              values={ternaryCondition(selectedReasonS, [{ value: selectedReasonS, label: selectedReasonS }], [])}
              wrapperClassName=""
              itemRenderer={({ item, itemIndex, props, methods }) => (
                <div
                  key={item.value}
                  className={classes.selectedOption}
                  onClick={() => methods.addItem(item)}
                >
                  {item.label}
                </div>
              )}
            />
            <CustomConditionalRender isRender={isEmptyReason}>
              <Typography className={classes.errorMessage}>
                Please select a reason
              </Typography>
            </CustomConditionalRender>
          </Box>
          <DeleteFooter>
            <DeletePostConfirmButton
              data-test-id="resetButtonCall"
              type="button"
              onClick={openEndWaitlistModalS}
            >
              Cancel
            </DeletePostConfirmButton>
            <CancelPostConfirmButton
              data-test-id="apiCallButton"
              onClick={(event) => {
                if (!selectedReasonS) {
                  setIsEmptyReason(true);
                  return;
                }

                let hideableId = null;

                // Check if either postInfo.attributes?.account_id or banUserOfselectedCommentId exists

                if (banUserOfselectedCommentId) {
                  hideableId = banUserOfselectedCommentId;
                } else {
                  hideableId = account_id;
                }

                const values = {
                  hides: {
                    hideable_id: hideableId,
                    reason: selectedReasonS,
                    hideable_type: "AccountBlock::Account",
                  },
                };

                banUserApiCall(values);
                setTimeout(() => {
                  openEndWaitlistModalS(event);
                  openConfirmModalS();

                  handleClosePopOver();
                  handlePreviewModalClose()
                }, 700);
              }}
            >
              Confirm
            </CancelPostConfirmButton>
          </DeleteFooter>
        </Box>
      </Modal>

      <Modal
        open={hidePostConfirmationModalS}
        onClose={openHideConfirmationModalS}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        data-test-id="templateEditModal"
      >
        <Box className={classes.hidePostConfirmationModal}>
          <div>
            <HidePostModalTitle>
              Are you sure you want to hide post?
              <HideCloseImageIcon
                data-test-id="closeEndModal"
                src={CloseIcon}
                alt=""
                onClick={openHideConfirmationModalS}
              />
            </HidePostModalTitle>
          </div>
          <DeleteHidePostModalFooter>
            <DeleteHidePostModalButton
              data-test-id="resetButtonCall"
              type="button"
              onClick={openHideConfirmationModalS}
            >
              Cancel
            </DeleteHidePostModalButton>
            <CancelHidePostModalButton
              data-test-id="hidePostApiCall"
              onClick={(event) => {
                event.stopPropagation();
                // Set state first to update UI immediately
                safeSetIsPostHidden(true);
                
                // Close modal and popover
                openHideConfirmationModalS(event);
                handleClosePopOver();
                
                // Only close preview modal if it's open
                if (previewModalId) {
                  handlePreviewModalClose();
                }
                
                // Call API after UI updates
                const values = {
                  hides: {
                    hideable_id: postInfo.id,
                    hideable_type: commonFunctionForCondition(
                      model_name,
                      model_name,
                      ""
                    ),
                  },
                };
                
                try {
                  hidePostApicall(values);
                } catch (error) {
                  console.error("Error hiding post:", error);
                  // Revert state if API call fails
                  safeSetIsPostHidden(false);
                }
              }}
            >
              Confirm
            </CancelHidePostModalButton>
          </DeleteHidePostModalFooter>
        </Box>
      </Modal>

      <Modal
        open={deletePostConfirmationModalS}
        onClose={openDeletePostConfirmationModalS}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        data-test-id="deletePostModal"
      >
        <Box className={classes.hidePostConfirmationModal}>
          <div>
            <HidePostModalTitle>
              Are you sure you want to delete this post?
              <HideCloseImageIcon
                data-test-id="closeDeletePostModal"
                src={CloseIcon}
                alt=""
                onClick={openDeletePostConfirmationModalS}
              />
            </HidePostModalTitle>
          </div>
          <DeleteHidePostModalFooter>
            <DeleteHidePostModalButton
              data-test-id="cancelDeletePost"
              type="button"
              onClick={openDeletePostConfirmationModalS}
            >
              Cancel
            </DeleteHidePostModalButton>
            <CancelHidePostModalButton
              data-test-id="confirmDeletePost"
              onClick={(event) => {
                if (deletePostApicall) {
                  deletePostApicall(postInfo.id);
                }
                openDeletePostConfirmationModalS(event);
                handleClosePopOver();
                handlePreviewModalClose();
              }}
            >
              Confirm
            </CancelHidePostModalButton>
          </DeleteHidePostModalFooter>
        </Box>
      </Modal>

      <Modal
        open={confirmModal}
        onClose={closeConfirmModalS}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        data-test-id="templateEditModal"
      >
        <Box className={classes.confirmModalBox}>
          <ConfirmResetModalTitle>
            {showSuccess}
            <ClosePostImageIcon
              data-test-id="closeEndModal"
              src={CloseIcon}
              alt=""
              onClick={closeConfirmModalS}
            />
          </ConfirmResetModalTitle>

          <Footer>
            <CancelButton
              data-test-id="doneButton"
              onClick={closeConfirmModalS}
            >
              Done
            </CancelButton>
          </Footer>
        </Box>
      </Modal>

      {/* Comment Options Modal - Use Modal on mobile, Popover on desktop */}
      {isMobile ? (
        <Modal
          open={commentOptionsModal}
          onClose={handleCloseCommentOptionsModal}
          aria-labelledby="comment-options-modal-title"
          aria-describedby="comment-options-modal-description"
          data-test-id="commentOptionsModal"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box className={classes.commentOptionsModalBox} style={{
            position: 'relative',
            outline: 'none',
            maxWidth: '90%',
            width: '280px',
          }}>
            <IconButton
              onClick={handleCloseCommentOptionsModal}
              style={{
                position: 'absolute',
                right: '8px',
                top: '8px',
                padding: '4px',
              }}
            >
              <CloseRoundedIcon />
            </IconButton>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                padding: '8px 0',
              }}
            >
              <Box
                component="button"
                onClick={handleUploadVideoComment}
                onTouchEnd={(e) => {
                  e.preventDefault()
                  handleUploadVideoComment(e)
                }}
                className={classes.uploadVideoCommentButton}
                data-test-id="upload-video-comment-button"
              >
                {replyingToID ? 'Upload Video Reply' : 'Upload Video Comment'}
              </Box>
              {!replyingToID && (
                <Box
                  component="button"
                  onClick={handleAddPollComment}
                  onTouchEnd={(e) => {
                    e.preventDefault()
                    handleAddPollComment(e)
                  }}
                  className={classes.addPollCommentButton}
                  data-test-id="add-poll-comment-button"
                >
                  Add Poll Comment
                </Box>
              )}
            </Box>
          </Box>
        </Modal>
      ) : (
        <Popover
          open={commentOptionsModal}
          anchorEl={commentOptionsAnchorEl}
          onClose={handleCloseCommentOptionsModal}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          data-test-id="commentOptionsModal"
        >
          <Box className={classes.commentOptionsModalBox}>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                padding: '8px 0',
              }}
            >
              <Box
                component="button"
                onClick={handleUploadVideoComment}
                onTouchEnd={(e) => {
                  e.preventDefault()
                  handleUploadVideoComment(e)
                }}
                className={classes.uploadVideoCommentButton}
                data-test-id="upload-video-comment-button"
              >
                {replyingToID ? 'Upload Video Reply' : 'Upload Video Comment'}
              </Box>
              {!replyingToID && (
                <Box
                  component="button"
                  onClick={handleAddPollComment}
                  onTouchEnd={(e) => {
                    e.preventDefault()
                    handleAddPollComment(e)
                  }}
                  className={classes.addPollCommentButton}
                  data-test-id="add-poll-comment-button"
                >
                  Add Poll Comment mobile
                </Box>
              )}
            </Box>
          </Box>
        </Popover>
      )}

      {/* Poll Comment Modal */}
      <Modal
        open={pollCommentModal}
        onClose={handleClosePollCommentModal}
        aria-labelledby="poll-comment-modal-title"
        aria-describedby="poll-comment-modal-description"
        data-test-id="pollCommentModal"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1300,
        }}
        disableEnforceFocus={false}
        disableAutoFocus={false}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1299,
          },
          onClick: handleClosePollCommentModal,
        }}
      >
        <Box 
          className={classes.pollCommentModalBox}
          onClick={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
          style={{
            zIndex: 1300,
            position: 'relative',
            ...(isMobile && {
              maxWidth: '90%',
              maxHeight: '85vh',
              margin: '20px',
              overflowY: 'auto',
              WebkitOverflowScrolling: 'touch',
            }),
          }}
        >
          {/* Header */}
          <Box className={classes.pollCommentModalHeader}>
            <Typography className={classes.pollCommentModalTitle}>
              Make a Poll Comment
            </Typography>
            <IconButton
              onClick={handleClosePollCommentModal}
              className={classes.pollCommentModalCloseButton}
              data-test-id="close-poll-comment-modal"
            >
              <CloseRoundedIcon />
            </IconButton>
          </Box>

          {/* Question Section */}
          <Box className={classes.pollCommentModalSection}>
            <Typography className={classes.pollCommentModalLabel}>
              Question
            </Typography>
            <TextField
              placeholder="Make a question"
              value={pollQuestion}
              onChange={(e) => setPollQuestion(e.target.value)}
              variant="outlined"
              fullWidth
              className={classes.pollCommentModalInput}
              data-test-id="poll-question-input"
              autoFocus={!isMobile}
              inputProps={{
                style: {
                  WebkitAppearance: 'none',
                  WebkitUserSelect: 'text',
                  userSelect: 'text',
                },
              }}
              onFocus={(e) => {
                if (isMobile) {
                  // Ensure input is visible on mobile when keyboard opens
                  setTimeout(() => {
                    e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }, 300);
                }
              }}
            />
          </Box>

          {/* Options Section */}
          <Box className={classes.pollCommentModalSection}>
            <Typography className={classes.pollCommentModalLabel}>
              Options
            </Typography>
            {pollOptions.map((option, index) => (
              <Box key={index} style={{ marginBottom: '12px' }}>
                <TextField
                  placeholder="Add an Option"
                  value={option}
                  onChange={(e) => handlePollOptionChange(index, e.target.value)}
                  variant="outlined"
                  fullWidth
                  className={classes.pollCommentModalInput}
                  data-test-id={`poll-option-input-${index}`}
                  inputProps={{
                    style: {
                      WebkitAppearance: 'none',
                      WebkitUserSelect: 'text',
                      userSelect: 'text',
                    },
                  }}
                  onFocus={(e) => {
                    if (isMobile) {
                      // Ensure input is visible on mobile when keyboard opens
                      setTimeout(() => {
                        e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      }, 300);
                    }
                  }}
                />
              </Box>
            ))}
          </Box>

          {/* Allow Multiple Responses Toggle */}
          <Box className={classes.pollCommentModalSection}>
            <FormControlLabel
              control={
                <Switch
                  checked={allowMultipleResponses}
                  onChange={(e) => setAllowMultipleResponses(e.target.checked)}
                  className={classes.pollCommentSwitch}
                  data-test-id="allow-multiple-responses-switch"
                />
              }
              label="Allow Multiple responses"
              className={classes.pollCommentToggleLabel}
            />
          </Box>

          {/* Continue Button */}
          <Box className={classes.pollCommentModalFooter}>
            <Box
              component="button"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                handlePollContinue(e)
              }}
              onTouchEnd={(e) => {
                e.preventDefault()
                e.stopPropagation()
                handlePollContinue(e)
              }}
              className={classes.pollCommentContinueButton}
              data-test-id="poll-comment-continue-button"
            >
              Continue
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Video Comment Upload Modal */}
      <Modal
        open={videoCommentModal}
        onClose={handleCloseVideoCommentModal}
        aria-labelledby="video-comment-modal-title"
        aria-describedby="video-comment-modal-description"
        data-test-id="videoCommentModal"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1300,
        }}
        disableEnforceFocus={false}
        disableAutoFocus={false}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1299,
          },
          onClick: handleCloseVideoCommentModal,
        }}
      >
        <Box 
          className={classes.pollCommentModalBox}
          onClick={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
          style={{
            zIndex: 1300,
            position: 'relative',
            ...(isMobile && {
              maxWidth: '90%',
              maxHeight: '85vh',
              margin: '20px',
              overflowY: 'auto',
              WebkitOverflowScrolling: 'touch',
            }),
          }}
        >
          {/* Header */}
          <Box className={classes.pollCommentModalHeader}>
            <Typography className={classes.pollCommentModalTitle}>
              {replyingToID ? 'Upload Video Reply' : 'Upload Video Comment'}
            </Typography>
            <IconButton
              onClick={handleCloseVideoCommentModal}
              className={classes.pollCommentModalCloseButton}
              data-test-id="close-video-comment-modal"
            >
              <CloseRoundedIcon />
            </IconButton>
          </Box>

          {/* Content */}
          <Box className={classes.pollCommentModalSection}>
            {!selectedVideoFile ? (
              <>
                <Typography className={classes.pollCommentModalLabel} style={{ marginBottom: '16px' }}>
                  Select a video file to upload as a comment
                </Typography>
                <Box
                  component="button"
                  onClick={handleSelectVideo}
                  className={classes.uploadVideoCommentButton}
                  data-test-id="select-video-button"
                >
                  Select Video
                </Box>
              </>
            ) : (
              <>
                <Typography className={classes.pollCommentModalLabel} style={{ marginBottom: '16px' }}>
                  Selected Video
                </Typography>
                <Box style={{ 
                  padding: '12px', 
                  backgroundColor: '#f3f4f6', 
                  borderRadius: '8px',
                  marginBottom: '16px'
                }}>
                  <Typography style={{ 
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    color: '#1f2937',
                    wordBreak: 'break-word'
                  }}>
                    {selectedVideoFile.name}
                  </Typography>
                  <Typography style={{ 
                    fontFamily: 'Inter',
                    fontSize: '12px',
                    color: '#6b7280',
                    marginTop: '4px'
                  }}>
                    {(selectedVideoFile.size / (1024 * 1024)).toFixed(2)} MB
                  </Typography>
                </Box>
                <Box
                  component="button"
                  onClick={handleSelectVideo}
                  className={classes.addPollCommentButton}
                  data-test-id="change-video-button"
                  style={{ marginBottom: '12px' }}
                >
                  Change Video
                </Box>
                <Box style={{ marginTop: '16px' }}>
                  <TextField
                    data-test-id="video-comment-text-field"
                    placeholder={replyingToID ? `Replying to ${replyingToName}` : "Add a comment"}
                    variant="outlined"
                    value={comment}
                    fullWidth
                    multiline
                    maxRows={4}
                    minRows={2}
                    name="videoComment"
                    onChange={(e) => setComment(e.target.value)}
                    InputProps={{
                      classes: {
                        root: classes.postCommentTextField,
                        input: classes.postCommentinput,
                      },
                    }}
                    InputLabelProps={{
                      classes: {
                        root: classes.placeholder,
                      },
                    }}
                  />
                </Box>
              </>
            )}
          </Box>

          {/* Footer */}
          {selectedVideoFile && (
            <Box className={classes.pollCommentModalFooter}>
              <Box
                component="button"
                onClick={handleConfirmVideoUpload}
                className={classes.uploadVideoCommentButton}
                data-test-id="confirm-video-upload-button"
              >
                Upload Video
              </Box>
            </Box>
          )}

          {/* Hidden input elements */}
          <input
            ref={videoModalInputRef}
            accept="video/*,.mp4,.mpeg,.mov,.avi,.mkv,.webm,.3gp,.flv"
            type="file"
            hidden
            data-test-id="video-comment-modal-file"
            onChange={handleVideoCommentUpload}
          />
          <input
            ref={videoGalleryInputRef}
            accept="video/*,.mp4,.mpeg,.mov,.avi,.mkv,.webm,.3gp,.flv"
            type="file"
            hidden
            data-test-id="video-comment-gallery-file"
            capture={false}
            onChange={handleVideoCommentUpload}
          />
          <input
            ref={videoCameraInputRef}
            accept="video/*"
            type="file"
            hidden
            data-test-id="video-comment-camera-file"
            capture="environment"
            onChange={handleVideoCommentUpload}
          />
        </Box>
      </Modal>

      {postComment && (
        <Paper ref={elementRef} square elevation={0} className={classes.root}>
          {getCommentsUI()}
        </Paper>
      )}

      <Modal
        open={postInfo.id === previewModalId}
        onClose={handlePreviewModalClose}
        className={classes.previewModal}
      >
        <Box className={classes.postViewContainer}>
          <IconButton
            data-test-id="previewCloseBtn"
            onClick={handlePreviewModalClose}
            className={classes.previewCloseBtn}
          >
            <CloseRoundedIcon fontSize="small" />
          </IconButton>

          {/* Instagram Reels Style Modal */}
          {allPosts && allPosts.length > 0 ? (
            <Swiper
              key={`reels-modal-${previewModalId}`}
              onSwiper={(swiper) => setSwiperInstance(swiper)}
              onSlideChange={(swiper) => {
                // Keep this handler CHEAP - it can fire mid-swipe, while Swiper's own
                // transform transition is animating. The heavy work (pausing every video,
                // scanning the whole DOM, calling play()) used to run right here and was
                // blocking the main thread during the slide animation itself, which is what
                // showed up as the swipe flickering/bouncing before settling on both iOS and
                // Android. That work now runs in onSlideChangeTransitionEnd below, once the
                // animation has actually finished. Only cheap ref/state updates happen here,
                // since other handlers (mute toggle, etc.) need the current index right away.
                const newPostIndex = swiper.activeIndex;
                currentPostIndexRef.current = newPostIndex;
                currentPostSlideRef.current = 0;
                setCurrentPostIndex(newPostIndex);
                setCurrentPostSlide(0);
              }}
              onSlideChangeTransitionEnd={(swiper) => {
                const newPostIndex = swiper.activeIndex;

                // Pause and mute ALL videos now that the slide transition has finished.
                // Method 1: Pause all videos in refs
                reelVideoRefs.current.forEach((video) => {
                  if (video) {
                    video.pause();
                    video.muted = true;
                    video.volume = 0;
                    video.removeAttribute('autoplay');
                  }
                });

                // Method 2: Also query DOM directly to catch any videos we might have missed
                const allVideosInDOM = document.querySelectorAll('video');
                allVideosInDOM.forEach((video) => {
                  // NEVER play desktop feed videos
                  const isDesktopFeed = video.getAttribute('data-desktop-feed') === 'true';
                  if (isDesktopFeed) {
                    video.pause();
                    video.muted = true;
                    video.volume = 0;
                    video.removeAttribute('autoplay');
                    video.currentTime = 0;
                    return; // Skip desktop feed videos
                  }

                  const isInModal = video.closest('[class*="postViewContainer"], [class*="previewModal"]') !== null;
                  if (isInModal) {
                    video.pause();
                    // Don't mute modal videos - they should play with sound
                    video.removeAttribute('autoplay');
                  }
                });

                // Play the now-active video with sound
                const currentPost = allPosts[newPostIndex];
                if (currentPost && currentPost.attributes.files && currentPost.attributes.files.length > 0) {
                  const firstFile = currentPost.attributes.files[0];
                  if (firstFile && firstFile.link_content_type?.includes("video")) {
                    const videoKey = currentPost.attributes.files.length > 1
                      ? `post-${currentPost.id}-0`
                      : `post-${currentPost.id}`;
                    const video = reelVideoRefs.current.get(videoKey);
                    if (video && newPostIndex === currentPostIndexRef.current) {
                      // Always start muted (autoplay is only reliable on mobile when muted),
                      // then unmute right after playback actually begins if sound is wanted.
                      video.muted = true;
                      video.volume = 0;
                      video.play().then(() => {
                        if (!isReelMutedRef.current) {
                          video.muted = false;
                          video.volume = 1.0;
                        }
                      }).catch(err => console.log('Video play failed:', err));
                    }
                  }
                }
              }}
              direction="vertical"
              grabCursor={true}
              // touchAction: 'none' stops the browser's own touch/scroll gesture handling
              // from also reacting to this same swipe - without it, on iOS Safari the swipe
              // can trigger both Swiper's slide transition and a native scroll/bounce at once,
              // which is what caused the visible flicker/bounce-back before settling.
              style={{ height: '100%', touchAction: 'none' }}
              slidesPerView={1}
              spaceBetween={0}
              initialSlide={currentPostIndex}
              allowTouchMove={true}
              pagination={false}
              navigation={false}
              mousewheel={{
                invert: false,
                forceToAxis: true,
                sensitivity: 1,
                releaseOnEdges: true
              }}
              keyboard={{
                enabled: true,
                onlyInViewport: true,
              }}
            >
              {allPosts.map((post, postIdx) => (
                <SwiperSlide key={`post-${post.id}-${postIdx}`} style={{ height: '100%', width: '100%' }}>
                  <Box
                    style={{
                      position: 'relative',
                      height: '100%',
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {/* Post Media */}
                    {post.attributes.files && post.attributes.files.length > 0 && (
                      <Box
                        style={{
                          position: 'relative',
                          height: '100%',
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          zIndex: 1, // Media layer - below overlays
                        }}
                      >
                        {post.attributes.files.length > 1 ? (
                          <>
                            <Swiper
                              key={`post-${post.id}-swiper`}
                              direction="horizontal"
                              grabCursor={true}
                              style={{ height: '100%', width: '100%' }}
                              slidesPerView={1}
                              spaceBetween={0}
                              onSlideChange={(swiper) => {
                                // Keep this cheap - see the vertical reels Swiper above for why
                                // (heavy pause/play work here used to block the main thread
                                // during the slide animation, causing a visible bounce/flicker
                                // on both iOS and Android). The actual video pause/play work now
                                // happens in onSlideChangeTransitionEnd below.
                                const newSlideIndex = swiper.activeIndex;
                                if (postIdx === currentPostIndexRef.current) {
                                  currentPostSlideRef.current = newSlideIndex;
                                }
                                setCurrentPostSlide(newSlideIndex);
                              }}
                              onSlideChangeTransitionEnd={(swiper) => {
                                const newSlideIndex = swiper.activeIndex;

                                // Only handle if this is the current post
                                if (postIdx !== currentPostIndexRef.current) return;

                                // Aggressively pause all videos in this post first
                                const postFiles = post.attributes.files || [];
                                postFiles.forEach((file, fileIdx) => {
                                  if (file.link_content_type?.includes("video")) {
                                    // Try both key formats
                                    const videoKey1 = `post-${post.id}-${fileIdx}`;
                                    const videoKey2 = fileIdx === 0 ? `post-${post.id}` : null;

                                    [videoKey1, videoKey2].forEach((key) => {
                                      if (key) {
                                        const video = reelVideoRefs.current.get(key);
                                        if (video && !video.paused) {
                                          video.pause();
                                        }
                                        if (video) {
                                          video.muted = true;
                                          video.volume = 0;
                                        }
                                      }
                                    });
                                  }
                                });

                                // Play the active video with sound in modal
                                const activeFile = postFiles[newSlideIndex];
                                if (activeFile && activeFile.link_content_type?.includes("video")) {
                                  const videoKey = postFiles.length > 1
                                    ? `post-${post.id}-${newSlideIndex}`
                                    : `post-${post.id}`;
                                  const video = reelVideoRefs.current.get(videoKey);
                                  if (video) {
                                    // Always start muted (autoplay is only reliable on mobile when muted),
                                    // then unmute right after playback actually begins if sound is wanted.
                                    video.muted = true;
                                    video.volume = 0;
                                    video.play().then(() => {
                                      if (!isReelMutedRef.current) {
                                        video.muted = false;
                                        video.volume = 1.0;
                                      }
                                    }).catch(err => console.log('Video play failed:', err));
                                  }
                                }
                              }}
                              pagination={{
                                clickable: true,
                                el: `.swiper-pagination-${post.id}`,
                              }}
                              observer={true}
                              observeParents={true}
                            >
                              {post.attributes.files.map((file, fileIdx) => (
                                <SwiperSlide key={fileIdx} style={{ height: '100%', width: '100%' }}>
                                  {file.link_content_type?.includes("image") ? (
                                    <img
                                      ref={(el) => {
                                        if (el) {
                                          const imageKey = `post-${post.id}-${fileIdx}`;
                                          if (!processedImagesRef.current.has(imageKey)) {
                                            handleImageLoad(el, imageKey);
                                          }
                                        }
                                      }}
                                      src={file.link}
                                      alt={`Post ${postIdx} - Slide ${fileIdx}`}
                                      style={{
                                        border: 'none',
                                        objectFit:
                                          imageResizeModes.get(`post-${post.id}-${fileIdx}`) ||
                                          (isMobile ? 'cover' : 'contain'),
                                        width: '100%',
                                        height: '100%',
                                        outline: 'none',
                                        background: 'transparent',
                                      }}
                                    />
                                  ) : (
                                    <video
                                      ref={(el) => {
                                        if (el) {
                                          const videoKey = `post-${post.id}-${fileIdx}`;
                                          // Store video with both keys for consistency
                                          reelVideoRefs.current.set(videoKey, el);
                                          // Also store with post-${post.id} key if it's the first video
                                          if (fileIdx === 0) {
                                            reelVideoRefs.current.set(`post-${post.id}`, el);
                                          }
                                          if (!processedVideosRef.current.has(videoKey)) {
                                            handleVideoLoad(el, videoKey);
                                          }
                                          // Ensure video is muted and paused initially
                                          // Use refs to get latest values (not stale closures)
                                          const currentIdx = currentPostIndexRef.current;
                                          const currentSlide = currentPostSlideRef.current;
                                          const shouldPlay = postIdx === currentIdx && fileIdx === currentSlide;
                                          if (!shouldPlay) {
                                            el.pause();
                                            el.muted = true;
                                            el.volume = 0;
                                          }
                                        }
                                      }}
                                      src={file.link}
                                      // controls={false}
                                      loop
                                      muted={true}
                                      playsInline
                                      // swiper-no-swiping so tapping to toggle sound isn't swallowed by Swiper
                                      className="swiper-no-swiping"
                                      onClick={() => {
                                        // Tap anywhere on the video to toggle sound, same as
                                        // EuDashboard's handleFileRender onClick.
                                        const currentIdx = currentPostIndexRef.current;
                                        const currentSlide = currentPostSlideRef.current;
                                        if (!isMobile) return;
                                        if (postIdx !== currentIdx || fileIdx !== currentSlide) return;
                                        toggleReelSound(`post-${post.id}-${fileIdx}`);
                                      }}
                                      onPlay={(e) => {
                                        // Prevent video from playing if it's not the current active video
                                        // Use refs to get latest values (not stale closures)
                                        const video = e.currentTarget;
                                        const currentIdx = currentPostIndexRef.current;
                                        const currentSlide = currentPostSlideRef.current;
                                        const shouldPlay = postIdx === currentIdx && fileIdx === currentSlide;
                                        if (!shouldPlay) {
                                          video.pause();
                                          video.muted = true;
                                          video.volume = 0;
                                        }
                                      }}
                                      onLoadedMetadata={(e) => {
                                        // Ensure video is muted and paused on load
                                        // Use refs to get latest values (not stale closures)
                                        const video = e.currentTarget;
                                        const currentIdx = currentPostIndexRef.current;
                                        const currentSlide = currentPostSlideRef.current;
                                        const shouldPlay = postIdx === currentIdx && fileIdx === currentSlide;
                                        if (!shouldPlay) {
                                          video.pause();
                                          video.muted = true;
                                          video.volume = 0;
                                        }
                                      }}
                                      style={{
                                        border: 'none',
                                        objectFit:
                                          videoResizeModes.get(`post-${post.id}-${fileIdx}`) ||
                                          (isMobile ? 'cover' : 'contain'),
                                        width: '100%',
                                        height: '100%',
                                        outline: 'none',
                                        background: 'transparent',
                                      }}
                                    />
                                  )}
                                </SwiperSlide>
                              ))}
                            </Swiper>

                            {/* Instagram-like Dots */}
                            <div
                              className={`swiper-pagination-${post.id}`}
                              style={{
                                position: 'absolute',
                                bottom: '12px',
                                left: 0,
                                right: 0,
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '6px',
                                zIndex: 10,
                              }}
                            ></div>
                          </>
                        ) : (
                          post.attributes.files.map((file, fileIdx) => (
                            <Box
                              key={fileIdx}
                              style={{
                                position: 'absolute',
                                height: '100%',
                                width: '100%',
                                display: 'block',
                              }}
                            >
                              {file.link_content_type?.includes("image") ? (
                                <img
                                  ref={(el) => {
                                    if (el) {
                                      const imageKey = `post-${post.id}-${fileIdx}`;
                                      if (!processedImagesRef.current.has(imageKey)) {
                                        handleImageLoad(el, imageKey);
                                      }
                                    }
                                  }}
                                  src={file.link}
                                  alt={`Post ${postIdx} - Slide ${fileIdx}`}
                                  style={{
                                    border: 'none',
                                    objectFit:
                                      imageResizeModes.get(`post-${post.id}-${fileIdx}`) ||
                                      (isMobile ? 'cover' : 'contain'),
                                    width: '100%',
                                    height: '100%',
                                    outline: 'none',
                                    background: 'transparent',
                                  }}
                                />
                              ) : (
                                <video
                                  ref={(el) => {
                                    if (el) {
                                      const videoKey = `post-${post.id}-${fileIdx}`;
                                      // Store video with both keys for consistency
                                      reelVideoRefs.current.set(`post-${post.id}`, el);
                                      reelVideoRefs.current.set(videoKey, el);
                                      if (!processedVideosRef.current.has(videoKey)) {
                                        handleVideoLoad(el, videoKey);
                                      }
                                    }
                                  }}
                                  src={file.link}
                                  // controls={false}
                                  loop
                                  playsInline
                                  // swiper-no-swiping so tapping to toggle sound isn't swallowed by Swiper
                                  className="swiper-no-swiping"
                                  onClick={() => {
                                    // Tap anywhere on the video to toggle sound, same as
                                    // EuDashboard's handleFileRender onClick.
                                    
                                    if (!isMobile) return;
                                    if (postIdx !== currentPostIndexRef.current) return;
                                    toggleReelSound(`post-${post.id}`);
                                  }}
                                  style={{
                                    border: 'none',
                                    objectFit:
                                      videoResizeModes.get(`post-${post.id}-${fileIdx}`) ||
                                      (isMobile ? 'cover' : 'contain'),
                                    width: '100%',
                                    height: '100%',
                                    outline: 'none',
                                    background: 'transparent',
                                  }}
                                />
                              )}
                            </Box>
                          ))
                        )}

                        {/* Mute/unmute toggle for the active reel video (mobile) - ported
                            directly from EuDashboard's handleFileRender: FLASH overlay +
                            bottom-left MUTE BUTTON, both onClick-only. */}
                        {isMobile && postIdx === currentPostIndex && (() => {
                          const activeFileIdx = currentPostSlide;
                          const activeFile = post.attributes.files[activeFileIdx];
                          if (!activeFile || !activeFile.link_content_type?.includes("video")) return null;
                          const videoKey = post.attributes.files.length > 1
                            ? `post-${post.id}-${activeFileIdx}`
                            : `post-${post.id}`;
                          const isSoundOn = !isReelMuted;
                          return (
                            <>
                              {/* FLASH - same as EuDashboard's soundFlashOverlay/soundFlashBadge */}
                              {reelSoundFlash && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    inset: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 10,
                                    pointerEvents: 'none',
                                  }}
                                >
                                  <div
                                    style={{
                                      width: '80px',
                                      height: '80px',
                                      backgroundColor: 'transparent',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      borderRadius: '999px',
                                      border: '1px solid #fff',
                                    }}
                                  >
                                    {isSoundOn ? (
                                      <VolumeUpRoundedIcon style={{ fontSize: '40px', lineHeight: 1, color: '#fff' }} />
                                    ) : (
                                      <VolumeOffRoundedIcon style={{ fontSize: '40px', lineHeight: 1, color: '#fff' }} />
                                    )}
                                  </div>
                                </div>
                              )}

                              {/* MUTE BUTTON - same as EuDashboard's muteToggleButton/muteToggleIcon */}
                              <button
                                type="button"
                                // swiper-no-swiping is Swiper's built-in exclusion class: Swiper
                                // ignores touches that start on an element with this class
                                // entirely, so this button behaves like a plain button (same as
                                // EuDashboard's onClick-only mute button, which isn't inside a
                                // Swiper at all) instead of fighting Swiper's own touch handling.
                                className="swiper-no-swiping"
                                aria-label={isSoundOn ? "Mute video" : "Unmute video"}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleReelSound(videoKey);
                                }}
                                style={{
                                  position: 'absolute',
                                  left: '10px',
                                  bottom: '70px',
                                  zIndex: 12,
                                  width: '30px',
                                  height: '30px',
                                  border: 'none',
                                  background: 'transparent',
                                  backgroundColor: 'transparent',
                                  color: '#fff',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  padding: 0,
                                }}
                              >
                                {isSoundOn ? (
                                  <VolumeUpRoundedIcon style={{ color: '#fff', fontSize: '20px' }} />
                                ) : (
                                  <VolumeOffRoundedIcon style={{ color: '#fff', fontSize: '20px' }} />
                                )}
                              </button>
                            </>
                          );
                        })()}
                      </Box>
                    )}

                    {/* Overlay Container - Unified parent for Poll and Action Bar (outside media Box) */}
                    <Box
                      style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0,
                        zIndex: 10, // Above media layer (1)
                        pointerEvents: 'none', // Allow scroll events to pass through to reel
                      }}
                    >
                      {/* Display post poll as overlay on media (like Instagram stories) - Modal */}
                      {post.attributes.poll && post.attributes.poll.id && (
                        <Box 
                          style={{
                            position: 'absolute',
                            bottom: '115px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            zIndex: 12, // Poll layer - lower than action bar
                            width: 'fit-content', // Only as wide as content
                            maxWidth: '90%', // Constrain max width
                            pointerEvents: 'none', // Allow scroll events to pass through to reel
                            display: 'inline-flex', // Inline to prevent full-width expansion
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: 'auto',
                          }}
                        >
                          {/* Only this inner box captures pointer events - the actual poll content */}
                          <Box 
                            style={{
                              pointerEvents: 'auto', // Poll content captures clicks
                              width: 'fit-content',
                              maxWidth: '400px',
                              position: 'relative',
                            }}
                            onClick={(e) => e.stopPropagation()}
                            onTouchStart={(e) => e.stopPropagation()}
                          >
                            <Poll
                              poll={post.attributes.poll}
                              poll_options={post.attributes.poll_options || []}
                              accountProfile={post.attributes.account_profile?.url}
                              handleVote={(optionId: number) => {
                                return handleVote(optionId, post.id);
                              }}
                              handleDeleteVote={(optionId: number) => handleDeleteVote(optionId, post.id)}
                            />

                          </Box>
                        </Box>
                      )}

                      {/* Bottom Overlay - Action Bar */}
                      <Box 
                        className={classes.previewBottomWrapper}
                        style={{ pointerEvents: 'auto' }} // Action bar must capture clicks
                      >
                      <Box style={{ flex: 1, minWidth: 0, maxWidth: 'calc(100% - 80px)' }}>
                        <Typography
                          className="userName"
                          style={{ color: '#fff', marginBottom: '5px' }}
                        >
                          {post.attributes.account?.business_name || 'User'}{' '}
                          {/* {post.attributes.account?.last_name || ''} */}
                        </Typography>
                        <Box style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                          <Typography
                            variant="body2"
                            className={clsx(
                              classes.postDescripation,
                              expandedDescriptions.has(post.id) &&
                              classes.postDescripationExpanded
                            )}
                            style={{
                              lineHeight: '1.4',
                              color: '#fff',
                            }}
                          >
                            {post.attributes.body}
                          </Typography>
                          {post.attributes.body &&
                            post.attributes.body.length > 80 && (
                              <Typography
                                component="span"
                                variant="body2"
                                style={{
                                  cursor: 'pointer',
                                  fontWeight: 'bold',
                                  color: '#fff',
                                  marginLeft: '4px',
                                  textShadow: '0 1px 2px rgba(0,0,0,0.8)',
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setExpandedDescriptions((prev) => {
                                    const newSet = new Set(prev);
                                    if (newSet.has(post.id)) newSet.delete(post.id);
                                    else newSet.add(post.id);
                                    return newSet;
                                  });
                                }}
                              >
                                {expandedDescriptions.has(post.id) ? ' less' : ' more'}
                              </Typography>
                            )}
                        </Box>
                      </Box>

                      {/* Like/Comment Icons */}
                      <Box className={classes.reactionContainer}>
                        <Avatar
                          className={classes.avatar}
                          style={{
                            height: '35px',
                            width: '35px',
                            borderRadius: '40px',
                          }}
                          onClick={(event) => {
                            event.stopPropagation();
                            handlePostProfileClick(post.attributes.account_id);
                          }}
                        >
                          <img
                            src={post.attributes.account_profile?.url && post.attributes.account_profile.url.trim() !== '' ? post.attributes.account_profile.url : IconAvtar}
                            className={classes.fallbackAvatar}
                            onError={(e) => {
                              // If image fails to load, show fallback avatar
                              const target = e.target as HTMLImageElement;
                              if (target.src !== IconAvtar) {
                                target.src = IconAvtar;
                              }
                            }}
                          />
                        </Avatar>

                        {post.attributes.is_liked ? (
                          <IconButton
                            style={{ color: 'white', paddingBottom: 0 }}
                            onClick={(event) => {
                              event.stopPropagation();
                              handleUndoLikeAPICall(post.id, 'Post');
                            }}
                          >
                            <FavoriteIcon style={{ color: 'red', fontSize: '30px' }} />
                          </IconButton>
                        ) : (
                          <IconButton
                            style={{ color: 'white', paddingBottom: 0 }}
                            onClick={(event) => {
                              event.stopPropagation();
                              handleLikePostAPICall(post, 'Post');
                            }}
                          >
                            <FavoriteBorderOutlinedIcon style={{ fontSize: '30px' }} />
                          </IconButton>
                        )}

                        <Typography
                          variant="body2"
                          style={{ color: '#fff', marginTop: '-6px' }}
                        >
                          {getValue(post.attributes.likes_count)}
                        </Typography>

                        <IconButton
                          onClick={(event) => openInstagramCommentModal(event, post)}
                          style={{ padding: 0, marginTop: '7px' }}
                        >
                          <img
                            src={CommentIconWhite}
                            alt="Comment"
                            className={classes.commentIconWhite}
                          />
                        </IconButton>

                        <Typography
                          variant="body2"
                          style={{ color: '#fff', marginTop: '-6px' }}
                        >
                          {getValue(post.attributes.comments_count)}
                        </Typography>

                        <IconButton
                          size="small"
                          onClick={handleClickPopOver}
                          className={classes.postSettingsBtn}
                        >
                          <MoreHorizRoundedIcon style={{ color: 'white', fontSize: '28px' }} />
                        </IconButton>
                      </Box>
                    </Box>
                    </Box>
                    {/* End Overlay Container */}
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : null}
  <style>
    {`
      .swiper-pagination-bullet {
        background: grey;
        opacity: 1;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        margin: 0 3px;
        transition: all 0.3s ease;
      }

      .swiper-pagination-bullet-active {
        background: #FFC629 !important;
        width: 9px;
        height: 9px;
      }
    `}
  </style>
          {/* Comment Modal */}
          <Modal
            data-test-id="postPreviewCommentModal"
            open={postPreviewComment}
            onClose={() => setPostPreviewComment(!postPreviewComment)}
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Box className={classes.postPreviewComments}>{getCommentsUI()}</Box>
          </Modal>
        </Box>
      </Modal>

      {/* Mobile Comment Modal */}
      {instagramCommentModal && isMobile && (
        <div 
          className="comment-modal-open"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: '64px',
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            overscrollBehavior: "contain",
            touchAction: "none"
          }}
          onClick={() => handleInstagramCloseModal()}
          onTouchStart={(e) => e.stopPropagation()}
          onTouchMove={(e) => e.stopPropagation()}
        >
          <div 
            style={{
              width: "100%",
              height: "60%",
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(10px)",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              borderRadius: "20px 20px 0 0",
              transform: "translateY(0)",
              transition: "transform 0.3s ease-out",
              // Prevent scroll propagation
              overscrollBehavior: "contain"
            }}
            onClick={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
            onTouchMove={(e) => e.stopPropagation()}
          >
            {/* Header with close button - always visible */}
            <div style={{
              display: "flex",
              flexDirection: "column",
              padding: "12px 20px 16px 20px",
              backgroundColor: "transparent",
              position: "relative"
            }}>
              <div style={{
                width: "40px",
                height: "4px",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                borderRadius: "2px",
                margin: "0 auto 12px auto"
              }}></div>
              
              <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px"
              }}>
                <div style={{
                  color: "black",
                  fontSize: "18px",
                  fontWeight: "bold"
                }}>
                  {/* {(comments && comments.data && comments.data.length > 0) || poll || localPoll
                    ? ((poll || localPoll) ? "Poll & Comments" : `${comments?.data?.length || 0} Comments`)
                    : "Comments"
                  } */}
                  Comments
                </div>
              </div>
              
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  handleInstagramCloseModal();
                }}
                style={{
                  color: "black",
                  backgroundColor: "white",
                  border: "1px solid #ddd",
                  padding: "8px",
                  position: "absolute",
                  right: "20px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  fontSize: "16px",
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                ✕
              </button>
            </div>
            
            <div style={{
              flex: 1,
              overflowY: "auto",
              overflowX: "hidden",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "transparent",
              padding: "0 20px",
              maxHeight: "calc(60vh - 140px)",
              minHeight: "200px",
              WebkitOverflowScrolling: "touch",
              // Prevent scroll propagation
              overscrollBehavior: "contain",
              // Ensure smooth scrolling
              scrollBehavior: "smooth",
              // Allow touch scrolling within the modal
              touchAction: "auto"
            }}
            onTouchStart={(e) => e.stopPropagation()}
            onTouchMove={(e) => e.stopPropagation()}
            onWheel={(e) => e.stopPropagation()}
            >
              {/* Separate poll comments and normal comments for mobile */}
              {comments && comments.data && comments.data.length > 0 ? (
                <div style={{ padding: "16px 0" }}>
                  {/* Filter and render poll comments first */}
                  {comments.data
                    .filter((item: any) => {
                      const commentPoll = item.attributes?.comment_poll || item.attributes?.poll;
                      return !!commentPoll; // Only include comments with polls
                    })
                    .map((item: any, index: number) => {
                      const isCurrentUserPost = item?.attributes?.account_id == account_id;
                      const isHighlighted = highlightedComment === item.id || isCommentManuallyHighlighted(item.id);
                      const isNotCurrentUser = !isCurrentUserPost;
                      const commentPoll = item.attributes?.comment_poll || item.attributes?.poll;
                      const commentPollOptions = item.attributes?.comment_poll_options || item.attributes?.poll_options || [];
                      
                      let backgroundColor = "transparent";
                      
                      return (
                        <div key={item.id} style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "12px",
                          marginBottom: "16px",
                          padding: "8px 0",
                          backgroundColor: backgroundColor,
                          borderRadius: "8px",
                          transition: "background-color 200ms ease"
                        }}>
                          <Avatar style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            backgroundColor: "#f0f0f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#666",
                            fontSize: "12px",
                            flexShrink: 0
                          }}>
                            <img
                              src={commonFunctionForCondition(
                                item.attributes?.account.data.attributes?.profile_pic?.url,
                                item.attributes?.account.data.attributes?.profile_pic?.url,
                                IconAvtar
                              )}
                              className={classes.fallbackAvatar}
                            />
                          </Avatar>
                          
                          <div style={{ flex: 1 }}>
                            <div style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              marginBottom: "4px"
                            }}>
                              <span style={{
                                color: "black",
                                fontWeight: "bold",
                                fontSize: "14px"
                              }}>
                                {item.attributes?.account?.data?.attributes?.business_name || "User"}
                              </span>
                              <span style={{
                                color: "#666",
                                fontSize: "12px"
                              }}>
                                {moment(item.attributes?.created_at).fromNow()}
                              </span>
                            </div>
                            
                            <div style={{
                              color: "black",
                              fontSize: "14px",
                              marginBottom: "8px",
                              lineHeight: "1.4"
                            }}>
                              {
                                commentPoll 
                                  ? commentPoll.question ?? ""
                                  : (item.attributes?.comment === "Poll" ? "" : item.attributes?.comment)
                              }
                            </div>
                            
                            {/* Render Poll UI for comment polls */}
                            {commentPoll && (
                              <div style={{
                                marginTop: "12px",
                                marginBottom: "12px",
                                padding: "12px 0"
                              }}>
                                <Poll
                                  hideLabel={true}
                                  poll={{
                                    id: commentPoll.id,
                                    question: commentPoll.question,
                                    comment_id: item.id,
                                    post_id: item.attributes.commentable_id,
                                    created_at: commentPoll.created_at,
                                    user_voted_option_id: commentPoll.user_voted_option_id,
                                    total_count: commentPoll.total_count
                                  }}
                                  poll_options={commentPollOptions}
                                  accountProfile={item.attributes?.account?.data?.attributes?.profile_pic?.url}
                                  handleVote={(optionId: number) => {
                                    return handleVoteComment(optionId, item.id);
                                  }}
                                  handleDeleteVote={(optionId: number) => {
                                    handleDeleteVote(optionId, item.id)
                                    return;
                                  }}
                                />
                              </div>
                            )}
                            
                            {/* Render comment images and videos */}
                            <CommentImage files={item.attributes.files} />
                            
                            <div style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "16px",
                              marginTop: "8px"
                            }}>
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (item.attributes?.already_liked) {
                                    handleUndoLikeAPICall(item.id, "Comment", postInfo.id);
                                  } else {
                                    handleLikePostAPICall(item.id, "Comment", postInfo.id);
                                  }
                                }}
                                style={{ padding: "4px" }}
                              >
                                {item.attributes?.already_liked ? (
                                  <FavoriteIcon style={{ color: "#FF3040", fontSize: "18px" }} />
                                ) : (
                                  <FavoriteBorderOutlinedIcon style={{ color: "#666", fontSize: "18px" }} />
                                )}
                              </IconButton>
                              <span style={{ color: "#666", fontSize: "12px" }}>
                                {item.attributes?.likes_count || 0}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  
                  {/* Also show local poll if it exists (for newly created polls) */}
                  {isCommentPoll && (localPoll || poll) && !comments.data.find((item: any) => {
                    const commentPoll = item.attributes?.comment_poll || item.attributes?.poll;
                    return commentPoll?.id === (localPoll || poll)?.id;
                  }) && (
                    <div style={{
                      padding: "16px 0",
                      borderBottom: comments.data.filter((item: any) => {
                        const commentPoll = item.attributes?.comment_poll || item.attributes?.poll;
                        return !commentPoll;
                      }).length > 0 ? "1px solid rgba(0, 0, 0, 0.1)" : "none",
                      marginBottom: "16px"
                    }}>
                      <Poll 
                        poll={localPoll || poll} 
                        poll_options={localPollOptions.length > 0 ? localPollOptions : poll_options} 
                        accountProfile={account_profile?.url} 
                        handleVote={(optionId: number) => handleVote(optionId, postInfo.id)} 
                        handleDeleteVote={(optionId: number) => handleDeleteVote(optionId, postInfo.id)}
                      />
                    </div>
                  )}
                  
                  {/* Render normal comments below poll comments */}
                  {comments.data
                    .filter((item: any) => {
                      const commentPoll = item.attributes?.comment_poll || item.attributes?.poll;
                      return !commentPoll; // Only include comments without polls
                    })
                    .map((item: any, index: number) => {
                    const isCurrentUserPost = item?.attributes?.account_id == account_id;
                    const isHighlighted = highlightedComment === item.id || isCommentManuallyHighlighted(item.id);
                    const isNotCurrentUser = !isCurrentUserPost;
                    
                    // Determine background color: highlighted > not current user (cream/beige) > transparent
                    let backgroundColor = "transparent";
                    // if (isHighlighted) {
                    //   backgroundColor = "#fff2d2";
                    // } else if (isNotCurrentUser) {
                    //   backgroundColor = "#fff2d2"; // Cream/beige color
                    // }
                    
                    return (
                    <div key={item.id} style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "12px",
                      marginBottom: "16px",
                      padding: "8px 0",
                      backgroundColor: backgroundColor,
                      borderRadius: "8px",
                      transition: "background-color 200ms ease"
                    }}>
                      <Avatar style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        backgroundColor: "#f0f0f0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#666",
                        fontSize: "12px",
                        flexShrink: 0
                      }}>
                          <img
                            src={commonFunctionForCondition(
                            item.attributes?.account.data.attributes?.profile_pic?.url,
                            item.attributes?.account.data.attributes?.profile_pic?.url,
                            IconAvtar
                           )}
                          className={classes.fallbackAvatar}
                        />
                      </Avatar>
                      
                      <div style={{ flex: 1 }}>
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          marginBottom: "4px"
                        }}>
                          <span style={{
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "14px"
                          }}>
                            {item.attributes?.account?.data?.attributes?.business_name || "User"}
                          </span>
                          <span style={{
                            color: "#666",
                            fontSize: "12px"
                          }}>
                            {moment(item.attributes?.created_at).fromNow()}
                          </span>
                        </div>
                        
                        <div style={{
                          color: "black",
                          fontSize: "14px",
                          marginBottom: "8px",
                          lineHeight: "1.4"
                        }}>
                          {item.attributes?.comment === "Poll" ? "" : item.attributes?.comment}
                        </div>
                        
                        {/* Render comment images and videos - same as desktop */}
                        <CommentImage files={item.attributes.files} />
                        
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "16px",
                          // backgroundColor: isNotCurrentUser ? "#fff2d2" : "transparent",
                          // borderRadius: isNotCurrentUser ? "8px" : "0px",
                          // padding: isNotCurrentUser ? "8px" : "0px",
                          // marginTop: isNotCurrentUser ? "8px" : "0px",
                          transition: "all 0.3s ease-in-out"
                        }}>
                          <div
                            className={classes.reactionBtn}
                            data-test-id="reactonButtonsOfComment"
                          >
                            <IconButton aria-label="post-likes" onClick={() => handleInstagramCommentLike(item)} style={{padding:'0px'}}>
                              <img src={item.attributes?.already_liked ? redHeart : HeartSmallIcon} style={{padding:'0px'}} />
                            </IconButton>
                            <Typography
                              component="span"
                              variant="body2"
                              className={classes.likesComments}
                            >
                              {item.attributes?.likes_count || 0}
                            </Typography>
                          </div>
                           
                          <button 
                            onClick={() => handleReplyClick(item.id, item.attributes?.account?.data?.attributes?.first_name || "User")}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#666",
                              fontSize: "12px",
                              cursor: "pointer"
                            }}
                          >
                            Reply
                          </button>

                          {item.attributes?.replies?.data && item.attributes.replies.data.length > 0 && (
                            <button
                              onClick={() => handleViewRepliesClick(item.id)}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#666",
                                fontSize: "12px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px"
                              }}
                            >
                              View reply
                              <span style={{ fontSize: "10px" }}>⌄</span>
                            </button>
                          )}
                        </div>

                        {/* Reply Comments */}
                        {item.attributes?.replies?.data && item.attributes.replies.data.length > 0 && repliesVisible[String(item.id)] && (
                          <div style={{
                            marginTop: "12px",
                            paddingLeft: "20px",
                            marginLeft: "53px",
                            borderLeft: "2px solid #f0f0f0"
                          }}>
                            {item.attributes.replies.data.map((reply: any, replyIndex: number) => {
                              const isReplyCurrentUserPost = reply?.attributes?.account_id == account_id;
                              const isReplyHighlighted = highlightedComment === reply.id || isCommentManuallyHighlighted(reply.id);
                              const isReplyNotCurrentUser = !isReplyCurrentUserPost;
                              
                              // Determine background color: highlighted > not current user (cream/beige) > transparent
                              let replyBackgroundColor = "transparent";
                              // if (isReplyHighlighted) {
                              //   replyBackgroundColor = "#fff2d2";
                              // } else if (isReplyNotCurrentUser) {
                              //   replyBackgroundColor = "#fff2d2"; // Cream/beige color
                              // }
                              
                              return (
                              <div key={reply.id} style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "8px",
                                marginBottom: "8px",
                                padding: replyBackgroundColor !== "transparent" ? "8px" : "4px 0",
                                backgroundColor: replyBackgroundColor,
                                borderRadius: "8px"
                              }}>
                                <div style={{
                                  width: "24px",
                                  height: "24px",
                                  borderRadius: "50%",
                                  backgroundColor: "#f0f0f0",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#666",
                                  fontSize: "10px",
                                  flexShrink: 0
                                }}>
                                  👤
                                </div>
                                
                                <div style={{ flex: 1 }}>
                                  <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    marginBottom: "2px"
                                  }}>
                                    <span style={{
                                      color: "black",
                                      fontWeight: "bold",
                                      fontSize: "12px"
                                    }}>
                                      {reply.attributes?.account?.data?.attributes?.business_name || "User"}
                                    </span>
                                    <span style={{
                                      color: "#666",
                                      fontSize: "10px"
                                    }}>
                                      {moment(reply.attributes?.created_at).fromNow()}
                                    </span>
                                  </div>
                                  
                                  <div style={{
                                    color: "black",
                                    fontSize: "12px",
                                    marginBottom: "4px",
                                    lineHeight: "1.3"
                                  }}>
                                    {reply.attributes?.comment}
                                  </div>
                                  
                                  {/* Render reply comment images and videos */}
                                  <CommentImage files={reply.attributes?.files} />
                                  
                                  <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    // backgroundColor: isReplyNotCurrentUser ? "#fff2d2" : "transparent",
                                    // borderRadius: isReplyNotCurrentUser ? "8px" : "0px",
                                    padding: isReplyNotCurrentUser ? "8px" : "0px",
                                    // marginTop: isReplyNotCurrentUser ? "8px" : "0px",
                                    transition: "all 0.3s ease-in-out"
                                  }}>
                                    <div
                                      className={classes.reactionBtn}
                                      style={{ fontSize: "10px" }}
                                    >
                                      <IconButton size="small" aria-label="reply-likes" onClick={() => handleReplyLike(reply, item.id)} style={{padding:'0px'}}>
                                        <img src={reply.attributes?.already_liked ? redHeart : HeartSmallIcon} style={{ width: "12px", height: "12px", padding:"0px" }} />
                                      </IconButton>
                                      <Typography
                                        component="span"
                                        variant="body2"
                                        className={classes.likesComments}
                                        style={{ fontSize: "10px" }}
                                      >
                                        {reply.attributes?.likes_count || 0}
                                      </Typography>
                                    </div>
                                    {/* Reply three-dot menu */}
                                    <div style={{ marginLeft: "8px" }}>
                                      <IconButton
                                        size="small"
                                        onClick={(e) => handleCommentMenuClick(e as any, reply.id, reply)}
                                        style={{ padding: "4px" }}
                                      >
                                        <MoreHorizRoundedIcon style={{ fontSize: "16px", color: "#666" }} />
                                      </IconButton>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              );
                            })}
                          </div>
                        )}
                      </div>

                      {/* Three-dot menu */}
                      <div style={{ marginLeft: "8px" }}>
                        <IconButton
                          size="small"
                          onClick={(e) => handleCommentMenuClick(e, item.id, item)}
                          style={{ padding: "4px" }}
                        >
                          <MoreHorizRoundedIcon style={{ fontSize: "16px", color: "#666" }} />
                        </IconButton>
                      </div>
                    </div>
                    );
                  })}
                </div>
              ) : (
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "40px 20px",
                  color: "#666",
                  textAlign: "center"
                }}>
                  <div style={{
                    fontSize: "16px",
                    marginBottom: "8px",
                    fontWeight: 500
                  }}>
                    No comments yet
                  </div>
                  <div style={{
                    fontSize: "14px",
                    color: "#999"
                  }}>
                    Be the first to comment!
                  </div>
                </div>
              )}
            </div>

            {/* Context Menu for Comments */}
            {console.log('Mobile Popover state:', { open: Boolean(anchorEl), anchorEl })}
            <Popover
              id="mobile-comment-menu"
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={() => setAnchorEl(null)}
              disablePortal={false}
              anchorOrigin={{
                vertical: "center",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
              classes={{
                paper: classes.popOverPaper,
              }}
              style={{
                zIndex: 10000
              }}
            >
              <StyledMenuItem
                data-test-id="mobile-reply"
                onClick={() => {
                  setAnchorEl(null);
                  handleReplyClick(selectedCommentId, "User");
                }}
              >
                <ListItemText primary="Reply" />
              </StyledMenuItem>
              <StyledMenuItem
                data-test-id="mobile-archive"
                disabled={
                  selectedCommentId === null ||
                  archivedStatus[selectedCommentId]
                }
                onClick={() => {
                  setAnchorEl(null);
                  const values = {
                    archives: {
                      archiveable_id: selectedCommentId,
                      archiveable_type: "BxBlockComments::Comment",
                    },
                  };
                  archiveCommentApiCall(values);
                }}
              >
                <ListItemText primary="Archive" />
              </StyledMenuItem>
              <StyledMenuItem
                data-test-id="mobile-revert-archive"
                disabled={
                  Boolean(selectedCommentId &&
                  !archivedStatus[selectedCommentId])
                }
                onClick={() => {
                  setAnchorEl(null);
                  const values = {
                    archives: {
                      archiveable_id: selectedCommentId,
                      archiveable_type: "BxBlockComments::Comment",
                    },
                  };
                  revertArchiveCommentApiCall(values);
                }}
              >
                <ListItemText primary="Revert archive" />
              </StyledMenuItem>
              {isSelfComment() && (
                <StyledMenuItem
                  data-test-id="mobile-delete"
                  onClick={() => {
                    setAnchorEl(null);
                    deleteCommentApiCall(selectedCommentId);
                  }}
                >
                  <ListItemText primary="Delete" />
                </StyledMenuItem>
              )}
              {!isSelfComment() && (
                <StyledMenuItem
                  data-test-id="mobile-banUser"
                  onClick={(event) => {
                    setAnchorEl(null);
                    openEndWaitlistModalS(event);
                  }}
                >
                  <ListItemText primary="Ban user" />
                </StyledMenuItem>
              )}
            </Popover>

            {/* Comment Input Section - Fixed at bottom */}
            <Box style={{
              flexShrink: 0,
              width: "100%",
              padding: "12px 16px",
              borderTop: "1px solid #E2E8F0",
              backgroundColor: "#fff",
              position: "sticky",
              bottom: 'calc(0px + env(safe-area-inset-bottom))',
              zIndex: 10
            }}>
              {commentImage && (
                <Box paddingX={1} style={{ marginBottom: '8px' }}>
                  <Box className={classes.commentImagePreviewWrapper}>
                    <IconButton
                      size="small"
                      data-test-id="image-comment-remove"
                      onClick={handleImageCommentRemove}
                    >
                      <CloseRoundedIcon fontSize="small" />
                    </IconButton>
                    <img
                      src={URL.createObjectURL(commentImage)}
                      alt="Image"
                      data-test-id="comment-image-selected"
                      className={classes.commentImage}
                    />
                  </Box>
                </Box>
              )}
            <Box
              alignItems="center"
              className={classes.postCommentRoot}
              style={{ margin: 0, padding: 0 }}
            >
              <Box>
                <IconButton
                  style={{paddingLeft: "8px"}}
                  data-test-id="image-comment-upload"
                  aria-label="add emoji"
                  onClick={handleImageCommentClick}
                >
                  <img
                    src={uploadIcon}
                    alt="uploadIcon"
                  />
                  <input
                    ref={imageInputRef}
                    accept=".jpeg, .jpg, .png"
                    type="file"
                    hidden
                    data-test-id="image-comment-file"
                    capture={isMobile ? "environment" : undefined}
                    onChange={handleImageCommentUpload}
                  />
                  <input
                    ref={videoInputRef}
                    accept="video/*,.mp4,.mpeg,.mov,.avi,.mkv,.webm,.3gp,.flv"
                    type="file"
                    hidden
                    data-test-id="video-comment-file"
                    capture={isMobile ? "environment" : undefined}
                    onChange={handleVideoCommentUpload}
                  />
                </IconButton>
              </Box>
              <Box className={classes.commentInputBox}>
                <Box>
                  <TextField
                    data-test-id="commentField"
                    placeholder={replyingToName ? `Replying to ${replyingToName}` : "Add a Comment"}
                    inputRef={commentRef}
                    onBlur={handleCommentOnBlur}
                    variant="outlined"
                    value={comment}
                    fullWidth
                    multiline
                    maxRows={6}
                    minRows={1}
                    name="comment"
                    onChange={(e) => setComment(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey && comment.trim()) {
                        e.preventDefault();
                        handleInstagramAddComment();
                      }
                    }}
                    InputProps={{
                      classes: {
                        root: classes.postCommentTextField,
                        input: classes.postCommentinput,
                      },
                    }}
                    InputLabelProps={{
                      classes: {
                        root: classes.placeholder,
                      },
                    }}
                  />
                </Box>
              </Box>
              <Box className={classes.uploadFileBox}>
              </Box>
              <Box className={clsx("iconStyle", classes.postCommentBox)}>
                <IconButton
                  size="small"
                  disabled={Boolean(checkAndCondition(!comment, !commentImage))}
                  data-test-id="postCommentApiCall"
                  onClick={() => replyingToID ? handleSendClick(
                      false,
                      comment,
                      setViewReplies
                    ) : handleInstagramAddComment()}
                  >
                  <img
                    src={sendMedssageIcon}
                    alt="sendIcon"
                  />
                </IconButton>
              </Box>
            </Box>
            </Box>
          </div>
        </div>
      )}
    </div>
  );
}

export default Post;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    previewModal: {
      background: "rgba(255, 255, 255, 0.2)",
      backdropFilter: "blur(5px)",
      // For larger screens
      [theme.breakpoints.up("sm")]: {
        background: "rgba(255, 255, 255, 0.2)",
        backdropFilter: "blur(5px)",
        zIndex: 1300, // default modal zIndex
      },
      // For mobile (xs and below)
      [theme.breakpoints.down("xs")]: {
        background: "rgba(255, 255, 255, 0)", 
        backdropFilter: "none",
        zIndex: `${theme.zIndex.drawer + 1} !important`, // ensures it’s above drawers
      },
    },
    // postViewContainer: {
    //   position: 'absolute',
    //   top: '50%',
    //   left: '50%',
    //   transform: 'translate(-50%, -50%)',
    //   width: '30%',
    //   height: '85%',
    //   maxHeight: "100%",
    //   maxWidth: "450px",
    //   color: 'white',
    //   borderRadius: '40px',
    //   overflow: 'hidden',
    //   //boxShadow: 24,
    //   background: "#000",
    
    //   // [theme.breakpoints.down(1200)]: {
    //   //   width: "100%",
    //   // },
    //   // [theme.breakpoints.down(900)]: {
    //   //   width: "100%",
    //   // },
    //   // [theme.breakpoints.down(600)]: {
    //   //   width: "100%",
    //   //   height: "80%",
    //   //   borderRadius: "20px",
    //   // },
    //   // [theme.breakpoints.down(400)]: {
    //   //   width: "100%",
    //   //   height: "75%",
    //   //   borderRadius: "16px",
    //   // },
    //   [theme.breakpoints.down(1200)]: {
    //     width: "40%",
    //   },
    //   [theme.breakpoints.down(900)]: {
    //     width: "55%",
    //   },
    //   [theme.breakpoints.down(600)]: {
    //     width: "70%",
    //     height: "80%",
    //     borderRadius: "20px",
    //   },
    //   [theme.breakpoints.down(400)]: {
    //     width: "90%",
    //     height: "75%",
    //     borderRadius: "16px",
    //   },
    // },
    
    postViewContainer: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 'clamp(300px, 40%, 450px)', // responsive width: min 300px, max 450px
      height: '85%',
      maxHeight: '100%',
      color: 'white',
      borderRadius: '40px',
      overflow: 'hidden',
      background: '#000',
      [theme.breakpoints.down(1200)]: {
        width: 'clamp(250px, 55%, 470px)',
      },
      [theme.breakpoints.down(900)]: {
        width: 'clamp(250px, 55%, 450px)',
      },
      [theme.breakpoints.down(600)]: {
        width: 'clamp(200px, 75%, 400px)',
        height: '80%',
        borderRadius: '20px',
      },
      [theme.breakpoints.down(400)]: {
        width: 'clamp(180px, 90%, 360px)',
        height: '75%',
        borderRadius: '16px',
      },
    },
    
    // postPreviewComments: {
    //   position: 'absolute',
    //   top: '70%',
    //   left: '50%',
    //   transform: 'translate(-50%, -50%)',
    //   width: '100%',
    //   maxHeight: "410px",
    //   height: "100%",
    //   maxWidth: "450px",
    //   background: 'white',
    //   borderRadius: '20px 0px 40px 40px',
    //   boxShadow: '24',
    //   padding: "0px 10px",
    //   [theme.breakpoints.down(1200)]: {
    //     width: "40%",
    //   },
    //   [theme.breakpoints.down(900)]: {
    //     width: "55%",
    //   },
    //   [theme.breakpoints.down(600)]: {
    //     width: "70%",
    //     height: "80%",
    //     borderRadius: "20px",
    //   },
    //   [theme.breakpoints.down(400)]: {
    //     width: "90%",
    //     height: "80%",
    //     borderRadius: "16px",
    //   },
    // },
    postPreviewComments: {
      position: 'absolute',
      bottom: '7%', // ✅ stick to the bottom of parent container
      left: '50%',
      transform: 'translateX(-50%)', // ✅ center horizontally only
      width: 'clamp(300px, 40%, 450px)',
      maxHeight: '45%', // ✅ responsive height
      background: 'white',
      borderRadius: '20px 0px 40px 40px',
      overflowY: 'hidden', // ✅ prevent modal from scrolling
      display: 'flex', // ✅ flexbox layout
      flexDirection: 'column', // ✅ vertical layout
      padding: '0px 10px',
      [theme.breakpoints.down(1200)]: {
        width: 'clamp(250px, 55%, 470px)',
      },

      [theme.breakpoints.down(900)]: {
        width: 'clamp(250px, 55%, 450px)',
      },
      [theme.breakpoints.down(600)]: {
        width: 'clamp(220px, 75%, 400px)',
        height: '80%',
        maxHeight: '80%',
        borderRadius: '20px',
      },
      [theme.breakpoints.down(400)]: {
        width: 'clamp(200px, 90%, 360px)',
        height: '80%',
        maxHeight: '80%',
        borderRadius: '16px',
      },
    },
    
    instagramCommentModal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      '& .comment-panel': {
        width: '100%',
        maxWidth: '500px',
        height: '75%',
        backgroundColor: 'white',
        borderRadius: '20px 20px 0 0',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        transform: 'translateY(100%)',
        transition: 'transform 0.3s ease-out',
        '&.open': {
          transform: 'translateY(0)',
        },
      },
      '& .comment-header': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '12px 20px 16px 20px',
        backgroundColor: 'white',
        position: 'relative',
        '& .drag-handle': {
          width: '40px',
          height: '4px',
          backgroundColor: '#d1d5db',
          borderRadius: '2px',
          margin: '0 auto',
        },
        '& .close-btn': {
          position: 'absolute',
          right: '20px',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          backgroundColor: '#f3f4f6',
          border: 'none',
          fontSize: '16px',
          cursor: 'pointer',
          color: '#374151',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
        },
      },
      '& .comment-list': {
        flex: 1,
        overflowY: 'auto',
        padding: '0 20px',
        '&::-webkit-scrollbar': {
          width: '0px',
          background: 'transparent',
        },
      },
      '& .comment-item': {
        display: 'flex',
        alignItems: 'flex-start',
        padding: '16px 0',
        position: 'relative',
        '& .avatar': {
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          // marginRight: '12px',
          backgroundColor: '#fbbf24',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: '16px',
          fontWeight: 'bold',
          flexShrink: 0,
        },
        '& .comment-content': {
          flex: 1,
          minWidth: 0,
          '& .username': {
            fontWeight: '600',
            fontSize: '14px',
            color: '#000',
            marginRight: '8px',
            display: 'inline',
          },
          '& .timestamp': {
            fontSize: '12px',
            color: '#9ca3af',
            marginLeft: '4px',
          },
          '& .comment-text': {
            fontSize: '14px',
            color: '#374151',
            lineHeight: '1.4',
            margin: '4px 0 8px 0',
            display: 'block',
          },
          '& .comment-meta': {
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            '& .like-btn': {
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              fontSize: '12px',
              color: '#6b7280',
              padding: '4px 8px',
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: '#f3f4f6',
              },
            },
            '& .reply-btn': {
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '12px',
              color: '#6b7280',
              padding: '4px 8px',
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: '#f3f4f6',
              },
            },
          },
        },
        '& .comment-options': {
          position: 'absolute',
          right: '0',
          top: '16px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#6b7280',
          fontSize: '16px',
          padding: '4px',
        },
      },
      '& .comment-input': {
        padding: '16px 20px',
        borderTop: '1px solid #e5e7eb',
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        '& .upload-btn': {
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          backgroundColor: '#000',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: '16px',
          flexShrink: 0,
        },
        '& .input-field': {
          flex: 1,
          background: '#f3f4f6',
          border: '1px solid #d1d5db',
          borderRadius: '24px',
          padding: '12px 16px',
          fontSize: '14px',
          outline: 'none',
          color: '#374151',
          '&::placeholder': {
            color: '#9ca3af',
          },
          '&:focus': {
            borderColor: '#3b82f6',
            background: '#ffffff',
          },
        },
        '& .send-btn': {
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          backgroundColor: '#000',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '16px',
          flexShrink: 0,
          transition: 'all 0.2s ease',
          '&:hover:not(:disabled)': {
            backgroundColor: '#374151',
            transform: 'scale(1.05)',
          },
          '&:disabled': {
            backgroundColor: '#d1d5db',
            cursor: 'not-allowed',
            transform: 'none',
          },
        },
      },
    },
    previewBottomWrapper: {
      position: 'absolute',
      // Lift above bottom tab bar + safe area
      bottom: 'calc(var(--app-tabbar-height, 30px) + env(safe-area-inset-bottom, 0px))',
      left: 0,
      right: 0,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      padding: '0 16px 16px 16px',
      zIndex: 3, // Action bar layer - higher than poll (2)
      minHeight: '120px',
      pointerEvents: 'auto', // Action bar captures clicks
      [theme.breakpoints.down('xs')]: {
        // bottom: 'calc(var(--app-tabbar-height, 10px) + env(safe-area-inset-bottom, 0px))',
        padding: '0 16px 16px 16px',
        minHeight: '140px',
        bottom:'4px'
      }
    },
    postDescripation: {
      marginTop: '5px',
      fontFamily: "inter",
      fontSize: "14px",
      lineHeight: "1.4",
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      maxWidth: '100%',
      textShadow: "0 1px 2px rgba(0,0,0,0.8)",
      display: '-webkit-box',
      WebkitLineClamp: 2, // show max 2 lines
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      [theme.breakpoints.down('xs')]: {
        fontSize: "14px",
        lineHeight: "1.5",
        marginBottom: '8px',
        paddingRight: '10px',
        fontWeight: "500",
        textShadow: "0 1px 3px rgba(0,0,0,0.9)",
      },
    },
    postDescripationExpanded: {
      display: 'block',
      WebkitLineClamp: 'unset',
      WebkitBoxOrient: 'unset',
      overflow: 'visible'
    },
    paginateDots: {
      zIndex: 999,
      width: '6px',
      height: '6px',
      borderRadius: '50%',
      margin: '0 5px',
      cursor: 'pointer',
    },
    paginateBox: {
      position: 'absolute',
      bottom: 161,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '10px 0',
    },
    previewCloseBtn: {
      position: 'absolute',
      top: '20px',
      right: '20px',
      zIndex: 2,
      color: '#8e8e8e',
      background: "#fff",
      padding: "3px",
      cursor: "pointer",
      "&:hover": {
        color: '#9b9b9b',
        background: "#fff",
      },
    },
    previewPostIcons: {
      height: "25px",
      width: "25px",
      fontSize: "26px",
      color: "#fff"
    },
    commentCloseIconWrapper: {
      display: "flex",
      justifyContent: "flex-end",
      margin: "10px 0px",
      flexShrink: 0, // ✅ prevent close icon from shrinking
      "& > button": {
        padding: "0px",
        border: "1px solid #E2E8F0"
      }
    },
    commentsContentWrapper: {
      display: "flex",
      flexDirection: "column",
      flex: 1, // ✅ take available space
      minHeight: 0, // ✅ allow flex item to shrink
      overflow: "hidden", // ✅ prevent this container from scrolling
    },
    pollCommentsWrapper: {
      flex: 1, // ✅ take available space
      minHeight: 0, // ✅ allow flex item to shrink below content size
      overflowY: "auto", // ✅ scroll only comments
      overflowX: "hidden",
      padding: "0 16px", // ✅ consistent horizontal padding
      WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
      scrollBehavior: "smooth", // Smooth scrolling
      "&::-webkit-scrollbar": {
        width: "6px",
        background: "transparent"
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#cbd5e1",
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#94a3b8"
      },
      [theme.breakpoints.down(768)]: {
        padding: "0 20px", // ✅ more padding on mobile
        "&::-webkit-scrollbar": {
          width: "0px",
          background: "transparent"
        },
        "&::-webkit-scrollbar-track": {
          background: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "transparent",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "transparent"
        },
      },
    },
    imageSetWidth:{

    },
    placeholder: {
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: 400,
      color: "#64748B",
      border: "1px red"
    },
    ratingText: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "22px",
      marginLeft: "4px",
    },
    ratingsBox: {
      display: "flex",
      flexDirection: "row",
      margin: "5px",
    },
    optionsAndRatings: {
      flexBasis: "2%",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      justifyContent: "space-between",
      "@media (max-width: 900px)": {
        // flexBasis: "100%",
        width: "100%",
        flexDirection: "row",
        justifyContent: "flex-end",
        marginTop: 12,
      },
    },
    selectedOption: {
      backgroundColor: "#fff",
      color: "#333",
      padding: "8px",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#ffca29",
      }
    },
    hoveredOption: {
      backgroundColor: "black",
      color: "white",
    },
    root: {
      padding: theme.spacing(1, 3, 2),
      height: "400px",
    },

    post: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: "space-between",
      alignItems: "flex-start",
      width: "100%",
      padding: "20px 24px",
      boxSizing: "border-box",
      overflow: "hidden",
      [theme.breakpoints.down(1024)]: {
        padding: "16px 20px",
      },
      [theme.breakpoints.down(768)]: {
        padding: "12px 16px",
        flexWrap: "wrap",
      },
      [theme.breakpoints.down(650)]: {
        padding: "0px",
      },
    },

    postDataContainer: {
      flexBasis: "70%",
      flexShrink: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      [theme.breakpoints.down(1024)]: {
        flexBasis: "65%",
      },
      [theme.breakpoints.down(768)]: {
        flexBasis: "60%",
      },
      "@media (max-width: 900px)": {
        // flexBasis: "100%",
        width: "100%",
      },
    },

    mediaContainer: {
      flexBasis: "21%",
      position: "relative",
      // display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
      borderRadius: 8,
      [theme.breakpoints.down(1024)]: {
        flexBasis: "25%",
      },
      [theme.breakpoints.down(768)]: {
        flexBasis: "30%",
      },
      "@media (max-width: 900px)": {
        // flexBasis: "100%",
        width: "100%",
        marginTop: 16,
      },
      "& img, & video": {
        width: "100%",
        height: "auto",
        objectFit: "cover",
        borderRadius: 8,
        [theme.breakpoints.down(1024)]: {
          objectFit: "contain", // Better for tablets
        },
        [theme.breakpoints.down(650)]: {
          objectFit: "contain", // Show full image on mobile
        },
      },
    },

    postMediaContainer: {
      display: "flex",
      alignItems: "center",
      backgroundColor: "#000",
      width: "162px",
      minWidth: "162px",
      maxWidth: "162px", // Ensure consistent width
      height: "162px",
      borderRadius: "10px",
      marginLeft: 8,
      flexShrink: 0, // Prevent shrinking
      [theme.breakpoints.down(1024)]: {
        width: "140px",
        minWidth: "140px",
        maxWidth: "140px",
        height: "140px",
      },
      [theme.breakpoints.down(768)]: {
        width: "120px",
        minWidth: "120px",
        maxWidth: "120px",
        height: "120px",
        marginLeft: 4,
      },
      [theme.breakpoints.down(650)]: {
        width: "100%",
        minWidth: "100%",
        maxWidth: "100%",
        height: "auto",
        minHeight: "200px",
        marginLeft: 0,
        marginTop: 12,
      },
      "& > img": {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: "10px",
        maxWidth: "100%", // Ensure image doesn't overflow
        maxHeight: "100%", // Ensure image doesn't overflow
        [theme.breakpoints.down(650)]: {
          objectFit: "contain", // Show full image on mobile
          height: "auto",
          minHeight: "200px",
        },
      },

      "& > video": {
        width: "100%",
        height: "100%",
        maxWidth: "100%", // Ensure video doesn't overflow
        maxHeight: "100%", // Ensure video doesn't overflow
        [theme.breakpoints.down(650)]: {
          objectFit: "contain", // Show full video on mobile
          height: "auto",
          minHeight: "200px",
        },
      },
    },

    cardHeader: {
      display: "flex",
      alignItems: "center",
    },
    commentscardHeader: {
      display: "flex",
    },
    cardHeaderContent: {
      flex: 1,
    },
    cardTitleWrapper: {
      display: "flex",
      alignItems: "center",
      gap: "3px",
      flexWrap: "wrap",
    },
    cardHeaderContentOfResponsiveContainer: {
      flex: 1,
      opacity: 0.5,
      pointerEvents: "none",
    },
    cardHeaderAction: {
      marginTop: theme.spacing(-1),
      marginRight: theme.spacing(-1),
      "& button": {
        transform: "rotate(90deg)",
      },
    },
    cardContent: {
      margin: theme.spacing(2, 0),
      "& p": {
        color: "#000000",
      },
    },
    cardActions: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(3),
      "& button": {
        padding: theme.spacing(0),
      },
    },
    commentCardActions: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(3),
      paddingLeft: "60px",
      marginBottom: "20px",
      "& button": {
        padding: "0px"
      },
      [theme.breakpoints.down(950)]: { 
        paddingLeft: "48px",
      }
    },
    commentReplyCardActions: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(2),
      paddingLeft: "150px",
      marginBottom: "10px",
      "& button": {
        padding: "0px"
      }
    },
    bullet: {
      fontSize: "10px",
      color: "#0F172A",
    },
    avatar: {
      width: "44px",
      height: "44px",
      // marginRight: theme.spacing(2),
      backgroundColor: "#FFF",
      border: "2px solid #F0E5FF",
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down(950)]: { 
        width: "30px",
        height: "30px",
        marginRight: "8px",
        "& img": {
          height: "30px",
          width: "30px"
        }
      } 
    },
    reactionContainer: { 
      display: 'flex', 
      alignItems: 'center', 
      flexDirection: "column", 
      gap: "8px",
      marginTop: '0px',
      position: 'relative', // Relative to parent (previewBottomWrapper) which is already absolute
      zIndex: 1, // Within parent's stacking context
      pointerEvents: 'auto', // Ensure clicks work
      [theme.breakpoints.down('xs')]: {
        gap: "12px",
      }
    },
    fontBold: {
      color: "#0F172A",
      fontFamily: "Inter, 'sans-serif'",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "24px",
    },
    darkText: {
      color: "#0F172A",
    },
    lightText: {
      color: "#64748B",
      fontFamily: "Inter",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "24px",
    },
    followersText: {
      color: "#64748B",
      fontFamily: "Inter",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "22px",
    },
    reactionBtn: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(0.5),
      paddingBottom:0
    },
    replyExpandIcon: {
      transition: "transform 0.3s"
    },
    replyExpandedIcon: {
      transform: "rotate(180deg)",
    },
    fallbackAvatar: {
      width: "56px",
      height: "56px",
      objectFit: "cover",
    },
    postSettingsBtn: {
      color: "#0F172A",
    },
    content: {
      color: "#000",

      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
    },
    commentCardHeaderAction: {
      paddingTop: "6px",
      paddingRight: "42px",
      "& button": {
        transform: "rotate(90deg)",
      },
      [theme.breakpoints.down(1100)]: {
        paddingRight: "8px"
      },
      [theme.breakpoints.down(480)]: { 
        paddingRight: "0px"
      } 
    },
    commentIcon: {
      height: "21px",
      width: "21px",
    },
    commentIconWhite: {
      height: "30px",
      width: "30px",
    },
    likesComments: {
      color: "#64748B",
      fontFamily: "Inter",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "22px",
      [theme.breakpoints.down(950)]: {
        fontSize: "12px"
      }
    },

    viewComments: {
      color: "#64748B",
      cursor: "pointer",
      fontFamily: "Inter",
      fontSize: "10px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "22px",
    },
    popOverPaper: {
      padding: "4px 4px 2px 4px",
      borderRadius: "8px",
      border: "1px solid #E2E8F0",
      minWidth: "192px",
      background: "#FFF",

      boxShadow:
        "0px 8px 32px 0px rgba(0, 0, 0, 0.06), 0px 4px 8px 0px rgba(0, 0, 0, 0.03)",
    },
    EndWaitlistmodalBox: {
      position: "relative",
      backgroundColor: "#fff",
      padding: "22px 22px 22px 22px",
      width: "100%",
      maxWidth: "556px",
      borderRadius: "0px 0px 40px 0",
      top: "50%",
      transform: "translate(-50%, -50%)",
      left: "50%",
      height: "100%",
      maxHeight: "415px",
    },
    confirmModalBox: {
      position: "relative",
      backgroundColor: "#fff",
      padding: "85px 98px 31px 93px",
      width: "100%",
      maxWidth: "556px",
      borderRadius: "0px 0px 40px 0",
      top: "50%",
      transform: "translate(-50%, -50%)",
      left: "50%",
      height: "272px",
    },
    commentOptionsModalBox: {
      backgroundColor: "#fff",
      padding: "8px",
      borderRadius: "12px",
      minWidth: "240px",
      outline: "none",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
    },
    uploadVideoCommentButton: {
      backgroundColor: "#000",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      padding: "12px 16px",
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "24px",
      cursor: "pointer",
      width: "100%",
      textAlign: "center",
      minHeight: "44px", // Minimum touch target size for mobile
      touchAction: "manipulation", // Improve touch responsiveness
      WebkitTapHighlightColor: "transparent", // Remove tap highlight on mobile
      "&:hover": {
        backgroundColor: "#333",
      },
      "&:active": {
        backgroundColor: "#555",
      },
    },
    addPollCommentButton: {
      backgroundColor: "transparent",
      color: "#64748B",
      border: "none",
      borderRadius: "8px",
      padding: "12px 16px",
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      cursor: "pointer",
      width: "100%",
      textAlign: "center",
      minHeight: "44px", // Minimum touch target size for mobile
      touchAction: "manipulation", // Improve touch responsiveness
      WebkitTapHighlightColor: "transparent", // Remove tap highlight on mobile
      "&:hover": {
        backgroundColor: "#f3f4f6",
      },
      "&:active": {
        backgroundColor: "#e5e7eb",
      },
    },
    pollCommentModalBox: {
      position: "relative",
      backgroundColor: "#fff",
      borderRadius: "12px",
      padding: "24px",
      width: "100%",
      maxWidth: "500px",
      outline: "none",
      maxHeight: "90vh",
      overflowY: "auto",
    },
    pollCommentModalHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "24px",
    },
    pollCommentModalTitle: {
      fontFamily: "Inter",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "28px",
      color: "#0F172A",
    },
    pollCommentModalCloseButton: {
      padding: "4px",
    },
    pollCommentModalSection: {
      marginBottom: "24px",
    },
    pollCommentModalLabel: {
      fontFamily: "Inter",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "20px",
      color: "#0F172A",
      marginBottom: "8px",
      display: "block",
    },
    pollCommentModalInput: {
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        backgroundColor: "#F8FAFC",
        "& fieldset": {
          borderColor: "#E2E8F0",
        },
        "&:hover fieldset": {
          borderColor: "#CBD5E1",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#94A3B8",
        },
      },
      "& .MuiInputBase-input": {
        padding: "12px 16px",
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        color: "#0F172A",
        WebkitAppearance: "none",
        WebkitUserSelect: "text",
        userSelect: "text",
        "&::placeholder": {
          color: "#94A3B8",
          opacity: 1,
        },
        // Mobile-specific fixes to ensure inputs work properly
        [theme.breakpoints.down("sm")]: {
          fontSize: "16px", // Prevent zoom on iOS (minimum 16px)
          WebkitAppearance: "none",
          WebkitTapHighlightColor: "transparent",
          touchAction: "manipulation",
        },
      },
      // Ensure inputs are focusable on mobile
      "& .MuiInputBase-root": {
        [theme.breakpoints.down("sm")]: {
          WebkitTapHighlightColor: "transparent",
          touchAction: "manipulation",
        },
      },
    },
    pollCommentToggleLabel: {
      margin: 0,
      "& .MuiFormControlLabel-label": {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20px",
        color: "#0F172A",
      },
    },
    pollCommentSwitch: {
      "& .MuiSwitch-switchBase": {
        "&.Mui-checked": {
          color: "#FFC629",
          "& + .MuiSwitch-track": {
            backgroundColor: "#FFC629",
          },
        },
      },
      "& .MuiSwitch-track": {
        backgroundColor: "#E2E8F0",
      },
    },
    pollCommentModalFooter: {
      marginTop: "24px",
    },
    pollCommentContinueButton: {
      backgroundColor: "#000",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      padding: "12px 24px",
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "24px",
      cursor: "pointer",
      width: "100%",
      textAlign: "center",
      "&:hover": {
        backgroundColor: "#333",
      },
    },
    selectField: {
      width: "100%",
      height: "56px",

      border: "1px solid #CBD5E1",

      background: "#FFF",
      color: "#000",
      borderRadius: "8px",
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "24px",
      marginBottom: "41px",
      marginTop: "4px",

      "& .react-dropdown-select-item-selected": {
        backgroundColor: "black",
        color: "white",
      },
    },
    optionFonts: {
      "&:hover": {
        backgroundColor: "black", // Change background color when hovered
      },
    },
    iconButton: {
      position: "absolute",
      right: 0,
      top: "50%",
      transform: "translateY(-50%)",
    },
    hidePostConfirmationModal: {
      position: "relative",
      backgroundColor: "#fff",
      padding: "85px 106px 31px 72px",
      width: "100%",
      maxWidth: "636px",
      borderRadius: "0px 0px 40px 0",
      top: "50%",
      transform: "translate(-50%, -50%)",
      left: "50%",
    },
    iconStyle:{
      "@media (max-width: 350-450px)": {
       marginLeft: '15px',
       paddingLeft: '10px'
      },
    },
    menu: {
      marginTop: theme.spacing(1),
    },
    placeholderFonts: {
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,

      color: "#64748B",
    },
    dropdownFonts: {
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,

      color: "#000",
    },
    postCommentRoot: {
      // padding: "13px 0px 27px 0px",
      display: "flex",
      width: "100%",
      flexShrink: 0, // ✅ prevent input field from shrinking
    },
    commentInputBox: {
      width: "80%"
    },
    uploadFileBox: {
      width: "1%",
    },
    postCommentBox: {
      width: "15%"
    },
    commentSection: {
      padding: "4px 47px 40px 24px",
    },
    postCommentAvatar: {
      backgroundColor: "#CCC",
      height: theme.spacing(7),
      width: theme.spacing(7),
    },
    postCommentButtton: {
      fontWeight: 700,
      color: "#FFF",
      backgroundColor: "#0F172A",
      textTransform: "capitalize",
      fontFamily: "Inter",
      borderRadius: theme.spacing(2),
      fontStyle: "normal",

      fontSize: "16px",
      "&:hover": {
        backgroundColor: "#0F172A",
      },
    },
    commentImagePreviewWrapper: {
      position: "relative",
      margin: "5px 0px",
      height: "50px",
      width: "50px",
      "& > button": {
        position: "absolute",
        top: "-9px",
        right: "-8px",
        backgroundColor: "#ffca29",
        padding: "1px",
        "&:hover": {
          backgroundColor: "#ffca29"
        },
        "& svg": {
          fontSize: "1.1rem",
          color: "#000"
        }
      }
    },
    commentImage: {
      height: "100%",
      width: "100%",
      borderRadius: "8px",
      marginTop: "3px",
      cursor: "pointer"
    },
    postCommentTextField: {
      "& .MuiOutlinedInput-root": {
        minHeight: "40px",
        maxHeight: "120px",
        "& textarea": {
          minHeight: "40px !important",
          maxHeight: "100px",
          overflowY: "auto !important",
        }
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E2E8F0",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "1px solid #000"
      },
      borderRadius: "0px 16px 16px 16px",
      backgroundColor: "#F8FAFC",
      borderColor: "#F0F3F8",
    },

    postReplyField: {
      padding: "12px 16px 12px 16px",
      height: "88px",
      borderRadius: "0px 16px 16px 16px",
      background: "#F1F5F9",
    },
    postReplyInput: {
      "&::placeholder": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontWeight: 400,
        fontStyle: "normal",
        color: "#64748B",
      },
    },
    postCommentinput: {
      "&::placeholder": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontWeight: 400,
        fontStyle: "normal",
        color: "#64748B",
      },
    },
    postCommentFallbackAvatar: {
      width: "70%",
      height: "70%",
    },
    commnetSectionUser: {
      color: "#0F172A",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 700,
      fontFamily: "Inter",
      [theme.breakpoints.down(950)]: { 
        fontSize: "12px" 
      } 
    },
    commentTime: {
      fontSize: "14px",
      fontWeight: 400,
      fontFamily: "Inter",
      fontStyle: "normal",
      color: "#64748B",
      marginLeft: "6px",
      [theme.breakpoints.down(950)]: { 
        fontSize: "12px" 
      } 
    },
    commentFonts: {
      color: "#0F172A",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      fontFamily: "Inter",
      wordBreak: "break-word",
      whiteSpace: "pre-line",
      [theme.breakpoints.down(950)]: {
        fontSize: "14px"
      }
    },
    reasonDropDown: {
      height: "56px",
      border: "1px solid #CBD5E1 !important",
      background: "#FFF",
      color: "#000",
      borderRadius: "8px !important",
      marginTop: "8px",
      padding: "2px 12px !important",
      "& .react-dropdown-select-dropdown": {
        borderRadius: "8px"
      }
    },
    errorMessage: {
      fontSize: "15px",
      color: "#FF0000",
      marginTop: "2px"
    },
    commentSectionContainer: {
      display: "flex",
      flexDirection: "column",
      flex: 1, // ✅ take available space in parent
      minHeight: 0, // ✅ allow flex item to shrink
      width: "100%",
      overflow: "hidden", // ✅ prevent container from scrolling
      height: "100%", // ✅ ensure it takes full height
      [theme.breakpoints.down(950)]: { 
        padding: "0",
      } 
    }
  })
);

const MobileViewPostViewRender = styled(Box)({
  // Reserve space for fixed app header (approx 56px) and bottom tab bar (approx 64px)
  // Use CSS vars if provided by shell, otherwise fallback to constants
  // Full viewport height minus bottom navigation bar
  height: "calc(100vh - 64px)", // 100vh minus bottom nav bar height
  width: "100vw",
  minHeight: "calc(100vh - 64px)", // Fallback for older browsers
  overflow: "hidden", // Prevent any overflow that might cause extra space
  position: "relative",
  backgroundColor: "#000", // Black background like Instagram Reels
  // Handle iPhone safe areas
  paddingBottom: "env(safe-area-inset-bottom, 0px)",
  paddingTop: "env(safe-area-inset-top, 0px)",
  "& .videoImageContainer": {
    position: "relative",
    height: "calc(100vh - 64px)", // Full viewport height minus bottom nav
    width: "100vw", // Full viewport width like TikTok
    minHeight: "calc(100vh - 64px)", // Fallback for older browsers
    "& .imageVideoContainer": {
      position: "relative",
      width: "100vw", // Full viewport width
      height: "calc(100vh - 64px)", // Full viewport height minus bottom nav
      minHeight: "calc(100vh - 64px)", // Fallback for older browsers
      overflow: "hidden",
        "& .mediaContainer": {
          backgroundColor: "#000",
          width: "100vw", // Full viewport width like TikTok
          height: "calc(100vh - 64px)", // Full viewport height minus bottom nav
          minHeight: "calc(100vh - 64px)", // Fallback for older browsers
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          "& >img": {
            width: "100%",
            height: "100%",
            objectFit: "cover", // Cover the entire container like Instagram Reels
          },
          "& >video": {
            width: "100%",
            height: "100%",
            objectFit: "cover", // Cover the entire container like Instagram Reels
            backgroundColor: "#000",
            objectPosition: "center", // Center the content
            borderRadius: "0px", // Remove any border radius for full screen
          },
        },
      "& .progressBarOuterContainer":{

        position: "absolute",
        bottom: "2px",
        zIndex: 2,
        width: "100%",

        "& .progressBar": {
          position: "relative",
          height: "3px",
          backgroundColor: "#fff",
          borderRadius: "5px",
          cursor: "pointer",
          marginTop: "10px",

          "& .playedPart": {
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            backgroundColor: "#FFC629",
            borderRadius: "5px",
            transition: "width 0.1s linear",
          },

          "& .unplayedPart": {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            width: "8px",
            height: "8px",
            backgroundColor: "#FFC629",
            borderRadius: "50%",
            transition: "left 0.1s linear",
          }
        },
      },
    },
    "& .postInfoContainer":{
      position: "absolute",
      width: "100%",
      bottom: "0px",
      left: "0px",
      right: "0px",
      zIndex: 3, // Action bar layer - higher than poll (2)
      color: "#fff",
      paddingBottom: "env(safe-area-inset-bottom, 0px)", // Handle iPhone safe area
      background: "linear-gradient(transparent, rgba(0,0,0,0.3))", // Gradient overlay like Instagram
      padding: "0 16px 20px 16px", // Add padding for better text positioning
      pointerEvents: 'auto', // Ensure clicks work

      "& .tradmard": {
        position: "absolute",
        bottom: "17px",
        left: "36%",
        display: "flex",
        alignItems: "center",
        "& p":{
          fontSize: "8px",
          fontWeight: "bold",
          color: "#86898D",
        },
        "& img": {
          height: '22px',
          // filter: "brightness(0) invert(1)",
        }
      }
    },
    "& .commentSection":{

    }
  },
  
  "@media (min-width: 650px)": {
    display: "none"
  }
})

const DesktopViewPostRender = styled(Box)({
  "@media (max-width: 650px)": {
    display: "none"
  }
})

const PostSummary = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: "0px",
  color: "#fff",
  flex: 1,
  minWidth: 0, // Allow text to shrink
  textShadow: "0 1px 2px rgba(0,0,0,0.8)", // Add text shadow for better readability
  "& .userName": {
    fontFamily: "inter",
    fontWeight: 'bold', 
    fontSize: "16px", 
    lineHeight: "24px", 
    color: "#fff",
    marginBottom: '4px',
    textShadow: "0 1px 2px rgba(0,0,0,0.8)", // Add text shadow
  },
  "@media (max-width: 600px)": {
    paddingRight: "10px", // Add padding on mobile
    "& .userName": {
      fontSize: "15px",
      lineHeight: "22px",
      fontWeight: "700", // Bolder text on mobile
    }
  }
})

const ReceiverMessageContainer = styled("div")({
  display: "flex",
  justifyContent: "flex-start",
  padding: "0px",
  width: "94%",
  marginRight: "auto",
  "@media (max-width: 480px)": {
    padding: "0 0 10px 0"
  },
  "& .commenterTime": {
    fontSize: "12px",
    marginLeft:'10px'
  }
});
const MessageBubble = styled(Paper)({
  padding: "0px 16px 12px 0px",
  borderRadius: "0px 16px 16px 16px",
  background: "transparent",
  boxShadow: "none",
  "@media (max-width: 950px)": {
    padding: "12px"
  },
  "& .replyToCommentTime": {
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: "Inter",
    fontStyle: "normal",
    color: "#64748B",
    "@media (max-width: 950px)": {
      fontSize: "12px"
    }
  }
});

const ReplayToComment = styled(Box)({
  display: "flex",
  paddingLeft: "67px",
  "@media (max-width: 950px)": {
    paddingLeft: "48px"
  }
})

const HidePostModalTitle = styled(Typography)({
  paddingBottom: "21px",
  fontStyle: "normal",
  justifyContent: "center",
  position: "relative",
  textAlign: "center",
  color: "#0F172A",
  letterSpacing: "-0.12px",
  marginBottom: "38px",
  fontFamily: "Inter",
  fontSize: "24px",
  fontWeight: 700,
  lineHeight: "32px" /* 133.333% */,
  display: "flex",
});

const DeleteHidePostModalFooter = styled(Box)({
  alignItems: "center",
  gap: "20px",
  justifyContent: "space-between",
  display: "flex",
});
const CancelHidePostModalButton = styled("button")({
  color: "black",
  padding: "16px 0",
  backgroundColor: "#ffca29",
  textTransform: "capitalize",
  display: "block",
  border: "none",
  fontWeight: 700,
  borderRadius: "12px",
  fontSize: "16px",
  cursor: "pointer",
  width: "100%",
});

const DeleteHidePostModalButton = styled("button")({
  border: "none",
  backgroundColor: "black",
  borderRadius: "12px",
  color: "white",
  width: "100%",
  padding: "16px 0",
  textTransform: "capitalize",
  fontSize: "16px",
  fontWeight: 700,
  cursor: "pointer",
});
const HideCloseImageIcon = styled("img")({
  position: "absolute",
  cursor: "pointer",
  right: "-71px",
  height: "26px",
  bottom: "81px",
  padding: "4px",
  width: "24px",
  borderRadius: "80px",
  justifyContent: "space-between",
  alignItems: "center",
  border: " 1px solid var(--Neutrals-Cool-gray-200, #E2E8F0)",
  background: "#FFF",
  boxShadow:
    " 0px 8px 32px 0px rgba(0, 0, 0, 0.06), 0px 4px 8px 0px rgba(0, 0, 0, 0.03)",
});
const ResetModalTitle = styled(Typography)({
  fontSize: "20px",
  position: "relative",
  marginBottom: "38px",
  display: "flex",
  justifyContent: "center",
  fontWeight: 700,
  fontFamily: "Inter",
  fontStyle: "normal",
  textAlign: "center",
  marginTop: "41px",
});

const DeleteFooter = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "20px",
});
const CancelPostConfirmButton = styled("button")({
  textTransform: "capitalize",
  backgroundColor: "#ffca29",
  padding: "16px 0",
  display: "block",
  width: "100%",
  border: "none",
  borderRadius: "12px",
  fontSize: "16px",
  color: "black",
  fontWeight: 700,
  cursor: "pointer",
});

const DeletePostConfirmButton = styled("button")({
  backgroundColor: "black",
  padding: "16px 0",
  color: "white",
  fontSize: "16px",
  textTransform: "capitalize",
  width: "100%",
  border: "none",
  fontWeight: 700,
  cursor: "pointer",
  borderRadius: "12px",
});
const ClosePostConfirmButton = styled("img")({
  height: "26px",
  width: "24px",
  position: "absolute",
  padding: "4px",
  borderRadius: "80px",
  boxShadow:
    " 0px 8px 32px 0px rgba(0, 0, 0, 0.06), 0px 4px 8px 0px rgba(0, 0, 0, 0.03)",
  bottom: "56px",
  cursor: "pointer",
  right: "-10px",
  alignItems: "center",
  border: " 1px solid var(--Neutrals-Cool-gray-200, #E2E8F0)",
  justifyContent: "space-between",
  background: "#FFF",
});

const ConfirmResetModalTitle = styled(Typography)({
  fontSize: "20px",
  position: "relative",
  marginBottom: "66px",
  display: "flex",
  justifyContent: "center",
  fontWeight: 700,
  fontStyle: "normal",
  fontFamily: "Inter",
  textAlign: "center",
});
const Footer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "20px",
  paddingRight: "36px",
  paddingLeft: "62px",
});
const CancelButton = styled("button")({
  backgroundColor: "#ffca29",
  padding: "16px 0",
  color: "black",
  textTransform: "capitalize",
  display: "block",
  width: "100%",
  border: "none",
  borderRadius: "12px",
  fontSize: "16px",
  fontWeight: 700,
  cursor: "pointer",
  maxWidth: "232px",
});

const ClosePostImageIcon = styled("img")({
  position: "absolute",
  bottom: "83px",
  border: " 1px solid var(--Neutrals-Cool-gray-200, #E2E8F0)",
  cursor: "pointer",
  width: "24px",
  padding: "4px",
  borderRadius: "80px",
  justifyContent: "space-between",
  alignItems: "center",
  background: "#FFF",
  right: "-89px",
  boxShadow:
    " 0px 8px 32px 0px rgba(0, 0, 0, 0.06), 0px 4px 8px 0px rgba(0, 0, 0, 0.03)",
  height: "26px",
});

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: "#FFC629",
      borderRadius: "8px",
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: "#0F172A",
      },
    },
  },
}))(MenuItem);
// Customizable Area End
